'use client'

export function CompanyIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="220"
      height="40"
      viewBox="0 0 220 40"
      fill="none"
    >
      <path
        d="M22.7756 40V0H40.0531C43.0239 0 45.6234 0.584185 47.8515 1.75256C50.0796 2.92092 51.8125 4.56313 53.0504 6.67918C54.2882 8.79523 54.9071 11.2683 54.9071 14.0983C54.9071 16.9543 54.2687 19.4274 52.9917 21.5175C51.7278 23.6076 49.9493 25.2173 47.656 26.3467C45.3758 27.4762 42.7112 28.0409 39.6622 28.0409H29.3426V19.6286H37.4732C38.7501 19.6286 39.8381 19.4079 40.7372 18.9665C41.6493 18.5122 42.3464 17.8696 42.8285 17.0387C43.3236 16.2079 43.5712 15.2278 43.5712 14.0983C43.5712 12.9559 43.3236 11.9823 42.8285 11.1774C42.3464 10.3595 41.6493 9.73642 40.7372 9.30802C39.8381 8.86663 38.7501 8.64594 37.4732 8.64594H33.6424V40H22.7756Z"
        fill="#044752"
      />
      <path
        d="M13.4726 25.3367C15.9826 24.3538 17.9842 22.8134 19.4755 20.7078C20.9649 18.6023 21.7096 16.1659 21.7096 13.3913C21.7096 9.55819 20.3903 6.36961 17.748 3.82365C15.1056 1.27392 11.7942 0 7.81175 0H0V8.46383H7.61518C9.01007 8.46383 10.1706 8.9458 11.0967 9.90786C12.0191 10.8699 12.4841 12.0682 12.4841 13.5047C12.4841 14.9412 12.0172 16.1055 11.0835 17.0562C10.1498 18.0107 8.99305 18.4851 7.61707 18.4851H0V26.3271H3.79341L12.0304 40H22.8172L13.4745 25.3367H13.4726Z"
        fill="#CB9A2B"
      />
      <path
        d="M212.024 34.5654C211.687 35.443 211.36 36.2194 211.045 36.8945C210.73 37.5696 210.325 38.1322 209.83 38.5823C209.357 39.0548 208.75 39.4036 208.007 39.6287C207.265 39.8762 206.286 40 205.07 40C203.765 40 202.505 39.7975 201.29 39.3924L201.965 35.2405C202.73 35.578 203.518 35.7468 204.328 35.7468C204.89 35.7468 205.352 35.6793 205.712 35.5443C206.072 35.4318 206.364 35.2517 206.589 35.0042C206.837 34.7792 207.04 34.4979 207.197 34.1603C207.355 33.8228 207.523 33.429 207.703 32.9789L208.075 32.0337L200.885 15.4937H206.353L210.573 26.3291H210.64L214.252 15.4937H219.45L212.024 34.5654Z"
        fill="#044752"
      />
      <path
        d="M194.738 29.8397H194.67C194.108 30.7173 193.354 31.3474 192.409 31.73C191.486 32.1125 190.507 32.3038 189.472 32.3038C188.707 32.3038 187.964 32.1913 187.244 31.9663C186.546 31.7637 185.928 31.4487 185.387 31.0211C184.847 30.5936 184.42 30.0647 184.105 29.4346C183.79 28.8045 183.632 28.0732 183.632 27.2405C183.632 26.2954 183.801 25.4965 184.139 24.8439C184.499 24.1913 184.971 23.6512 185.556 23.2236C186.164 22.7961 186.85 22.4698 187.615 22.2447C188.38 21.9972 189.168 21.8172 189.978 21.7047C190.811 21.5921 191.632 21.5246 192.442 21.5021C193.275 21.4796 194.04 21.4684 194.738 21.4684C194.738 20.5682 194.411 19.8594 193.759 19.3418C193.129 18.8017 192.375 18.5317 191.497 18.5317C190.665 18.5317 189.899 18.7117 189.202 19.0717C188.527 19.4093 187.919 19.8819 187.379 20.4895L184.679 17.7215C185.624 16.8439 186.726 16.1913 187.987 15.7637C189.247 15.3137 190.552 15.0886 191.902 15.0886C193.387 15.0886 194.603 15.2799 195.548 15.6625C196.515 16.0225 197.281 16.5626 197.843 17.2827C198.428 18.0028 198.833 18.8917 199.058 19.9494C199.283 20.9845 199.396 22.1885 199.396 23.5612V31.8988H194.738V29.8397ZM193.489 24.7089C193.106 24.7089 192.622 24.7314 192.037 24.7764C191.475 24.7989 190.923 24.8889 190.383 25.0464C189.866 25.204 189.416 25.4402 189.033 25.7553C188.673 26.0703 188.493 26.5092 188.493 27.0718C188.493 27.6793 188.752 28.1294 189.269 28.422C189.787 28.7145 190.327 28.8608 190.89 28.8608C191.385 28.8608 191.857 28.7933 192.307 28.6582C192.78 28.5232 193.196 28.3319 193.556 28.0844C193.916 27.8369 194.198 27.5218 194.4 27.1393C194.625 26.7567 194.738 26.3066 194.738 25.7891V24.7089H193.489Z"
        fill="#044752"
      />
      <path
        d="M163.822 8H172.699C173.937 8 175.107 8.11252 176.21 8.33755C177.313 8.56259 178.269 8.9564 179.079 9.51899C179.912 10.0591 180.564 10.8017 181.037 11.7468C181.532 12.6695 181.78 13.8397 181.78 15.2574C181.78 16.6526 181.555 17.8228 181.105 18.7679C180.654 19.7131 180.036 20.467 179.248 21.0295C178.46 21.5921 177.526 21.9972 176.446 22.2447C175.366 22.4698 174.196 22.5823 172.936 22.5823H169.088V31.8987H163.822V8ZM169.088 18.1266H172.598C173.071 18.1266 173.521 18.0816 173.948 17.9916C174.398 17.9016 174.792 17.7553 175.13 17.5527C175.49 17.3277 175.771 17.0352 175.974 16.6751C176.199 16.2925 176.311 15.82 176.311 15.2574C176.311 14.6498 176.165 14.166 175.872 13.8059C175.602 13.4233 175.242 13.1308 174.792 12.9283C174.365 12.7257 173.881 12.602 173.341 12.557C172.801 12.4895 172.283 12.4557 171.788 12.4557H169.088V18.1266Z"
        fill="#044752"
      />
      <path
        d="M155.346 29.8397H155.278C154.715 30.7173 153.962 31.3474 153.016 31.73C152.094 32.1125 151.115 32.3038 150.08 32.3038C149.315 32.3038 148.572 32.1913 147.852 31.9663C147.154 31.7637 146.535 31.4487 145.995 31.0211C145.455 30.5936 145.028 30.0647 144.713 29.4346C144.398 28.8045 144.24 28.0732 144.24 27.2405C144.24 26.2954 144.409 25.4965 144.746 24.8439C145.106 24.1913 145.579 23.6512 146.164 23.2236C146.772 22.7961 147.458 22.4698 148.223 22.2447C148.988 21.9972 149.776 21.8172 150.586 21.7047C151.419 21.5921 152.24 21.5246 153.05 21.5021C153.883 21.4796 154.648 21.4684 155.346 21.4684C155.346 20.5682 155.019 19.8594 154.367 19.3418C153.737 18.8017 152.983 18.5317 152.105 18.5317C151.272 18.5317 150.507 18.7117 149.81 19.0717C149.135 19.4093 148.527 19.8819 147.987 20.4895L145.286 17.7215C146.232 16.8439 147.334 16.1913 148.594 15.7637C149.855 15.3137 151.16 15.0886 152.51 15.0886C153.995 15.0886 155.211 15.2799 156.156 15.6625C157.123 16.0225 157.888 16.5626 158.451 17.2827C159.036 18.0028 159.441 18.8917 159.666 19.9494C159.891 20.9845 160.004 22.1885 160.004 23.5612V31.8988H155.346V29.8397ZM154.097 24.7089C153.714 24.7089 153.23 24.7314 152.645 24.7764C152.083 24.7989 151.531 24.8889 150.991 25.0464C150.474 25.204 150.023 25.4402 149.641 25.7553C149.281 26.0703 149.101 26.5092 149.101 27.0718C149.101 27.6793 149.36 28.1294 149.877 28.422C150.395 28.7145 150.935 28.8608 151.497 28.8608C151.993 28.8608 152.465 28.7933 152.915 28.6582C153.388 28.5232 153.804 28.3319 154.164 28.0844C154.524 27.8369 154.805 27.5218 155.008 27.1393C155.233 26.7567 155.346 26.3066 155.346 25.7891V24.7089H154.097Z"
        fill="#044752"
      />
      <path
        d="M124.572 15.4937H130.04L134.192 26.6329H134.26L138.108 15.4937H143.205L136.724 31.8987H131.357L124.572 15.4937Z"
        fill="#044752"
      />
      <path
        d="M105.815 15.4937H111.284L115.436 26.6329H115.503L119.351 15.4937H124.448L117.967 31.8987H112.6L105.815 15.4937Z"
        fill="#044752"
      />
      <path
        d="M103.681 29.0633C102.871 30.0985 101.847 30.8973 100.61 31.4599C99.372 32.0225 98.0893 32.3038 96.7616 32.3038C95.5014 32.3038 94.3087 32.1013 93.1836 31.6962C92.0809 31.2912 91.1132 30.7173 90.2806 29.9747C89.4705 29.2096 88.8291 28.2982 88.3566 27.2405C87.884 26.1829 87.6477 25.0014 87.6477 23.6962C87.6477 22.391 87.884 21.2096 88.3566 20.1519C88.8291 19.0943 89.4705 18.1941 90.2806 17.4515C91.1132 16.6864 92.0809 16.1013 93.1836 15.6962C94.3087 15.2912 95.5014 15.0886 96.7616 15.0886C97.9318 15.0886 98.9895 15.2912 99.9346 15.6962C100.902 16.1013 101.712 16.6864 102.365 17.4515C103.04 18.1941 103.558 19.0943 103.918 20.1519C104.278 21.2096 104.458 22.391 104.458 23.6962V25.2827H92.711C92.9135 26.2504 93.3523 27.0267 94.0275 27.6118C94.7026 28.1744 95.5352 28.4557 96.5253 28.4557C97.358 28.4557 98.0556 28.2757 98.6182 27.9156C99.2033 27.5331 99.7096 27.0492 100.137 26.4642L103.681 29.0633ZM99.3945 21.8397C99.417 20.9845 99.1358 20.2532 98.5507 19.6456C97.9656 19.038 97.2117 18.7342 96.2891 18.7342C95.7265 18.7342 95.2314 18.8242 94.8038 19.0042C94.3763 19.1843 94.005 19.4206 93.6899 19.7131C93.3974 19.9831 93.1611 20.3094 92.981 20.692C92.8235 21.0521 92.7335 21.4346 92.711 21.8397H99.3945Z"
        fill="#044752"
      />
      <path
        d="M66.9072 8H76.1562C77.3714 8 78.519 8.12377 79.5992 8.37131C80.7019 8.59634 81.6583 8.99015 82.4684 9.55274C83.301 10.0928 83.9536 10.8354 84.4262 11.7806C84.9213 12.7032 85.1688 13.8622 85.1688 15.2574C85.1688 16.9451 84.73 18.3854 83.8524 19.5781C82.9747 20.7482 81.692 21.4909 80.0043 21.8059L86.0802 31.8987H79.768L74.7722 22.346H72.1731V31.8987H66.9072V8ZM72.1731 17.8903H75.2785C75.7511 17.8903 76.2462 17.879 76.7638 17.8565C77.3039 17.8115 77.7877 17.7103 78.2152 17.5527C78.6428 17.3727 78.9916 17.1027 79.2617 16.7426C79.5542 16.3826 79.7005 15.8762 79.7005 15.2236C79.7005 14.616 79.5767 14.1322 79.3292 13.7722C79.0816 13.4121 78.7666 13.1421 78.384 12.962C78.0015 12.7595 77.5626 12.6245 77.0676 12.557C76.5725 12.4895 76.0887 12.4557 75.6161 12.4557H72.1731V17.8903Z"
        fill="#044752"
      />
    </svg>
  )
}

export function EyeOutlineIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M2.94167 2.05837C2.82319 1.94797 2.66649 1.88787 2.50457 1.89072C2.34265 1.89358 2.18816 1.95917 2.07365 2.07368C1.95914 2.18819 1.89355 2.34268 1.89069 2.5046C1.88784 2.66652 1.94794 2.82322 2.05834 2.9417L17.0583 17.9417C17.1156 18.0031 17.1846 18.0524 17.2612 18.0865C17.3379 18.1207 17.4207 18.139 17.5046 18.1405C17.5885 18.142 17.6718 18.1266 17.7497 18.0951C17.8275 18.0637 17.8982 18.0169 17.9575 17.9576C18.0169 17.8982 18.0637 17.8275 18.0951 17.7497C18.1265 17.6719 18.142 17.5885 18.1405 17.5046C18.139 17.4207 18.1206 17.3379 18.0865 17.2613C18.0523 17.1846 18.0031 17.1156 17.9417 17.0584L2.94167 2.05837ZM18.8967 10.4609C18.4475 11.8088 17.6977 13.0369 16.7042 14.0525L14.1217 11.47C14.4003 10.69 14.4517 9.84684 14.27 9.03868C14.0883 8.23053 13.6809 7.49057 13.0952 6.90486C12.5095 6.31914 11.7695 5.91173 10.9614 5.73002C10.1532 5.54831 9.31007 5.59975 8.53 5.87837L6.46584 3.8142C7.58836 3.3575 8.78897 3.12344 10.0008 3.12503C14.1425 3.12503 17.655 5.81087 18.8967 9.53337C18.9967 9.83503 18.9967 10.16 18.8967 10.4609Z"
        fill="#044752"
      />
      <path
        d="M13.125 10C13.125 10.15 13.1142 10.2975 13.0942 10.4417L9.5575 6.90588C10.0008 6.84247 10.4526 6.87507 10.8822 7.0015C11.3118 7.12792 11.7092 7.3452 12.0475 7.63863C12.3859 7.93205 12.6571 8.29476 12.843 8.70218C13.0289 9.1096 13.1251 9.55222 13.125 10ZM10.4417 13.0942L6.90583 9.55754C6.83713 10.0379 6.88125 10.5277 7.03471 10.9881C7.18816 11.4485 7.44672 11.8668 7.78991 12.2099C8.1331 12.553 8.55148 12.8115 9.0119 12.9648C9.47232 13.1182 9.96212 13.1622 10.4425 13.0934L10.4417 13.0942Z"
        fill="#044752"
      />
      <path
        d="M5.625 9.99999C5.625 9.48415 5.71417 8.98916 5.87834 8.52999L3.295 5.94666C2.30175 6.96236 1.55233 8.19051 1.10334 9.53832C1.00334 9.83999 1.00334 10.165 1.10334 10.4667C2.34417 14.1892 5.85667 16.875 9.99917 16.875C11.2492 16.875 12.4433 16.63 13.5342 16.1858L11.47 14.1217C10.8097 14.3572 10.1025 14.4306 9.40789 14.3358C8.71329 14.2409 8.05166 13.9805 7.47873 13.5765C6.90581 13.1725 6.43835 12.6367 6.11575 12.0143C5.79315 11.3919 5.62484 10.701 5.625 9.99999Z"
        fill="#044752"
      />
    </svg>
  )
}

export function SidebarCompanyIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="174"
      height="32"
      viewBox="0 0 174 32"
      fill="none"
    >
      <path
        d="M18.2205 32V0H32.0426C34.4192 0 36.4988 0.467348 38.2812 1.40205C40.0637 2.33674 41.4501 3.65051 42.4404 5.34335C43.4306 7.03618 43.9258 9.01462 43.9258 11.2787C43.9258 13.5635 43.415 15.5419 42.3935 17.214C41.3823 18.8861 39.9595 20.1739 38.1249 21.0774C36.3007 21.9809 34.169 22.4327 31.7298 22.4327H23.4741V15.7029H29.9786C31.0002 15.7029 31.8706 15.5263 32.5898 15.1732C33.3195 14.8097 33.8772 14.2957 34.2628 13.631C34.6589 12.9663 34.857 12.1822 34.857 11.2787C34.857 10.3647 34.6589 9.58583 34.2628 8.94193C33.8772 8.28764 33.3195 7.78913 32.5898 7.44641C31.8706 7.09331 31.0002 6.91675 29.9786 6.91675H26.914V32H18.2205Z"
        fill="#044752"
      />
      <path
        d="M10.7781 20.2693C12.7861 19.4831 14.3874 18.2507 15.5804 16.5663C16.7719 14.8818 17.3677 12.9328 17.3677 10.713C17.3677 7.64655 16.3122 5.09569 14.1984 3.05892C12.0845 1.01914 9.43534 0 6.2494 0H0V6.77106H6.09214C7.20805 6.77106 8.13646 7.15664 8.87738 7.92629C9.61527 8.69593 9.98724 9.65459 9.98724 10.8038C9.98724 11.9529 9.61376 12.8844 8.86679 13.6449C8.11983 14.4085 7.19444 14.7881 6.09365 14.7881H0V21.0617H3.03473L9.62434 32H18.2537L10.7796 20.2693H10.7781Z"
        fill="#CB9A2B"
      />
      <path
        d="M168.019 27.6524C167.749 28.3545 167.488 28.9756 167.236 29.5157C166.984 30.0558 166.66 30.5059 166.264 30.8659C165.886 31.244 165.4 31.523 164.806 31.703C164.212 31.9011 163.428 32.0001 162.456 32.0001C161.412 32.0001 160.404 31.8381 159.432 31.514L159.972 28.1925C160.584 28.4625 161.214 28.5976 161.862 28.5976C162.312 28.5976 162.681 28.5435 162.969 28.4355C163.257 28.3455 163.491 28.2015 163.672 28.0035C163.87 27.8234 164.032 27.5984 164.158 27.3284C164.284 27.0583 164.419 26.7433 164.563 26.3832L164.86 25.6271L159.108 12.395H163.482L166.858 21.0634H166.912L169.801 12.395H173.96L168.019 27.6524Z"
        fill="#044752"
      />
      <path
        d="M154.19 23.8716H154.136C153.686 24.5738 153.083 25.0778 152.327 25.3839C151.589 25.6899 150.806 25.843 149.977 25.843C149.365 25.843 148.771 25.7529 148.195 25.5729C147.637 25.4109 147.142 25.1589 146.71 24.8168C146.278 24.4747 145.936 24.0517 145.684 23.5476C145.432 23.0435 145.306 22.4584 145.306 21.7923C145.306 21.0362 145.441 20.3971 145.711 19.875C145.999 19.3529 146.377 18.9209 146.845 18.5788C147.331 18.2368 147.88 17.9757 148.492 17.7957C149.104 17.5977 149.734 17.4536 150.382 17.3636C151.049 17.2736 151.706 17.2196 152.354 17.2016C153.02 17.1836 153.632 17.1746 154.19 17.1746C154.19 16.4545 153.929 15.8874 153.407 15.4733C152.903 15.0413 152.3 14.8252 151.598 14.8252C150.932 14.8252 150.319 14.9693 149.761 15.2573C149.221 15.5273 148.735 15.9054 148.303 16.3915L146.143 14.1771C146.899 13.475 147.781 12.9529 148.789 12.6109C149.797 12.2508 150.842 12.0708 151.922 12.0708C153.11 12.0708 154.082 12.2238 154.838 12.5299C155.612 12.8179 156.224 13.25 156.674 13.8261C157.143 14.4022 157.467 15.1133 157.647 15.9594C157.827 16.7875 157.917 17.7507 157.917 18.8489V25.5189H154.19V23.8716ZM153.191 19.767C152.885 19.767 152.498 19.785 152.03 19.821C151.58 19.839 151.139 19.911 150.707 20.037C150.292 20.1631 149.932 20.3521 149.626 20.6041C149.338 20.8562 149.194 21.2072 149.194 21.6573C149.194 22.1434 149.401 22.5034 149.815 22.7375C150.229 22.9715 150.661 23.0885 151.112 23.0885C151.508 23.0885 151.886 23.0345 152.246 22.9265C152.624 22.8185 152.957 22.6655 153.245 22.4674C153.533 22.2694 153.758 22.0174 153.92 21.7113C154.1 21.4053 154.19 21.0452 154.19 20.6311V19.767H153.191Z"
        fill="#044752"
      />
      <path
        d="M129.457 6.3999H136.559C137.55 6.3999 138.486 6.48992 139.368 6.66994C140.25 6.84997 141.015 7.16502 141.663 7.61509C142.329 8.04716 142.851 8.64125 143.229 9.39737C143.626 10.1355 143.824 11.0716 143.824 12.2058C143.824 13.322 143.644 14.2581 143.284 15.0143C142.923 15.7704 142.428 16.3735 141.798 16.8235C141.168 17.2736 140.421 17.5977 139.557 17.7957C138.693 17.9757 137.757 18.0657 136.748 18.0657H133.67V25.5189H129.457V6.3999ZM133.67 14.5012H136.478C136.856 14.5012 137.217 14.4652 137.559 14.3932C137.919 14.3211 138.234 14.2041 138.504 14.0421C138.792 13.8621 139.017 13.628 139.179 13.34C139.359 13.0339 139.449 12.6559 139.449 12.2058C139.449 11.7197 139.332 11.3327 139.098 11.0446C138.882 10.7386 138.594 10.5045 138.234 10.3425C137.892 10.1805 137.505 10.0815 137.073 10.0455C136.64 9.99146 136.226 9.96446 135.83 9.96446H133.67V14.5012Z"
        fill="#044752"
      />
      <path
        d="M122.676 23.8716H122.622C122.172 24.5738 121.569 25.0778 120.813 25.3839C120.075 25.6899 119.292 25.843 118.464 25.843C117.852 25.843 117.257 25.7529 116.681 25.5729C116.123 25.4109 115.628 25.1589 115.196 24.8168C114.764 24.4747 114.422 24.0517 114.17 23.5476C113.918 23.0435 113.792 22.4584 113.792 21.7923C113.792 21.0362 113.927 20.3971 114.197 19.875C114.485 19.3529 114.863 18.9209 115.331 18.5788C115.817 18.2368 116.366 17.9757 116.978 17.7957C117.59 17.5977 118.221 17.4536 118.869 17.3636C119.535 17.2736 120.192 17.2196 120.84 17.2016C121.506 17.1836 122.118 17.1746 122.676 17.1746C122.676 16.4545 122.415 15.8874 121.893 15.4733C121.389 15.0413 120.786 14.8252 120.084 14.8252C119.418 14.8252 118.806 14.9693 118.248 15.2573C117.707 15.5273 117.221 15.9054 116.789 16.3915L114.629 14.1771C115.385 13.475 116.267 12.9529 117.275 12.6109C118.284 12.2508 119.328 12.0708 120.408 12.0708C121.596 12.0708 122.568 12.2238 123.324 12.5299C124.098 12.8179 124.711 13.25 125.161 13.8261C125.629 14.4022 125.953 15.1133 126.133 15.9594C126.313 16.7875 126.403 17.7507 126.403 18.8489V25.5189H122.676V23.8716ZM121.677 19.767C121.371 19.767 120.984 19.785 120.516 19.821C120.066 19.839 119.625 19.911 119.193 20.037C118.779 20.1631 118.419 20.3521 118.113 20.6041C117.824 20.8562 117.68 21.2072 117.68 21.6573C117.68 22.1434 117.888 22.5034 118.302 22.7375C118.716 22.9715 119.148 23.0885 119.598 23.0885C119.994 23.0885 120.372 23.0345 120.732 22.9265C121.11 22.8185 121.443 22.6655 121.731 22.4674C122.019 22.2694 122.244 22.0174 122.406 21.7113C122.586 21.4053 122.676 21.0452 122.676 20.6311V19.767H121.677Z"
        fill="#044752"
      />
      <path
        d="M98.0575 12.395H102.432L105.754 21.3064H105.808L108.886 12.395H112.964L107.779 25.5191H103.485L98.0575 12.395Z"
        fill="#044752"
      />
      <path
        d="M83.0522 12.395H87.4269L90.7484 21.3064H90.8025L93.8809 12.395H97.9586L92.7738 25.5191H88.4801L83.0522 12.395Z"
        fill="#044752"
      />
      <path
        d="M81.3451 23.2506C80.697 24.0787 79.8778 24.7178 78.8877 25.1679C77.8975 25.6179 76.8714 25.843 75.8092 25.843C74.8011 25.843 73.8469 25.6809 72.9468 25.3569C72.0646 25.0328 71.2905 24.5738 70.6244 23.9797C69.9763 23.3676 69.4632 22.6385 69.0852 21.7923C68.7071 20.9462 68.5181 20.001 68.5181 18.9569C68.5181 17.9127 68.7071 16.9676 69.0852 16.1214C69.4632 15.2753 69.9763 14.5552 70.6244 13.9611C71.2905 13.349 72.0646 12.8809 72.9468 12.5569C73.8469 12.2328 74.8011 12.0708 75.8092 12.0708C76.7454 12.0708 77.5915 12.2328 78.3476 12.5569C79.1217 12.8809 79.7698 13.349 80.2919 13.9611C80.832 14.5552 81.2461 15.2753 81.5341 16.1214C81.8221 16.9676 81.9662 17.9127 81.9662 18.9569V20.2261H72.5687C72.7307 21.0002 73.0818 21.6213 73.6219 22.0894C74.162 22.5394 74.8281 22.7645 75.6202 22.7645C76.2863 22.7645 76.8444 22.6205 77.2944 22.3324C77.7625 22.0264 78.1676 21.6393 78.5096 21.1712L81.3451 23.2506ZM77.9155 17.4716C77.9335 16.7875 77.7085 16.2024 77.2404 15.7164C76.7724 15.2303 76.1693 14.9873 75.4311 14.9873C74.9811 14.9873 74.585 15.0593 74.243 15.2033C73.9009 15.3473 73.6039 15.5363 73.3518 15.7704C73.1178 15.9864 72.9288 16.2475 72.7847 16.5535C72.6587 16.8415 72.5867 17.1476 72.5687 17.4716H77.9155Z"
        fill="#044752"
      />
      <path
        d="M51.9257 6.3999H59.3248C60.297 6.3999 61.2151 6.49892 62.0792 6.69695C62.9614 6.87698 63.7265 7.19203 64.3746 7.6421C65.0407 8.07416 65.5628 8.66826 65.9409 9.42438C66.3369 10.1625 66.5349 11.0896 66.5349 12.2058C66.5349 13.556 66.1839 14.7082 65.4818 15.6624C64.7797 16.5985 63.7535 17.1926 62.4033 17.4446L67.2641 25.5189H62.2143L58.2176 17.8767H56.1383V25.5189H51.9257V6.3999ZM56.1383 14.3121H58.6227C59.0008 14.3121 59.3968 14.3031 59.8109 14.2851C60.243 14.2491 60.63 14.1681 60.9721 14.0421C61.3141 13.8981 61.5932 13.682 61.8092 13.394C62.0432 13.106 62.1603 12.7009 62.1603 12.1788C62.1603 11.6927 62.0612 11.3057 61.8632 11.0176C61.6652 10.7296 61.4131 10.5135 61.1071 10.3695C60.801 10.2075 60.45 10.0995 60.0539 10.0455C59.6579 9.99146 59.2708 9.96446 58.8927 9.96446H56.1383V14.3121Z"
        fill="#044752"
      />
    </svg>
  )
}

export function HelpIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        opacity="0.4"
        d="M8.95828 2.0416C9.54161 1.54993 10.4833 1.54993 11.0499 2.0416L12.3666 3.1666C12.6166 3.37493 13.0916 3.54993 13.4249 3.54993H14.8416C15.7249 3.54993 16.4499 4.27494 16.4499 5.15827V6.57493C16.4499 6.90827 16.6249 7.37493 16.8333 7.62493L17.9583 8.9416C18.4499 9.52494 18.4499 10.4666 17.9583 11.0333L16.8333 12.3499C16.6249 12.5999 16.4499 13.0666 16.4499 13.3999V14.8166C16.4499 15.6999 15.7249 16.4249 14.8416 16.4249H13.4249C13.0916 16.4249 12.6249 16.5999 12.3749 16.8083L11.0583 17.9333C10.4749 18.4249 9.53328 18.4249 8.96661 17.9333L7.64994 16.8083C7.39994 16.5999 6.92494 16.4249 6.59994 16.4249H5.14161C4.25828 16.4249 3.53328 15.6999 3.53328 14.8166V13.3916C3.53328 13.0666 3.36661 12.5916 3.15828 12.3499L2.03328 11.0249C1.54994 10.4499 1.54994 9.5166 2.03328 8.9416L3.15828 7.6166C3.36661 7.3666 3.53328 6.89993 3.53328 6.57493V5.1666C3.53328 4.28327 4.25828 3.55827 5.14161 3.55827H6.58328C6.91661 3.55827 7.38328 3.38327 7.63328 3.17493L8.95828 2.0416Z"
        fill="#9CA3AF"
      />
      <path
        d="M9.99996 14.0583C9.54163 14.0583 9.16663 13.6833 9.16663 13.2249C9.16663 12.7666 9.53329 12.3916 9.99996 12.3916C10.4583 12.3916 10.8333 12.7666 10.8333 13.2249C10.8333 13.6833 10.4666 14.0583 9.99996 14.0583Z"
        fill="#9CA3AF"
      />
      <path
        d="M10 11.4332C9.65833 11.4332 9.375 11.1499 9.375 10.8082V6.7749C9.375 6.43324 9.65833 6.1499 10 6.1499C10.3417 6.1499 10.625 6.43324 10.625 6.7749V10.7999C10.625 11.1499 10.35 11.4332 10 11.4332Z"
        fill="#9CA3AF"
      />
    </svg>
  )
}

export function DocumentationIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        opacity="0.4"
        d="M17.0834 8.49175H14.675C12.7 8.49175 11.0917 6.88341 11.0917 4.90841V2.50008C11.0917 2.04175 10.7167 1.66675 10.2584 1.66675H6.72504C4.15837 1.66675 2.08337 3.33342 2.08337 6.30841V13.6917C2.08337 16.6667 4.15837 18.3334 6.72504 18.3334H13.275C15.8417 18.3334 17.9167 16.6667 17.9167 13.6917V9.32508C17.9167 8.86675 17.5417 8.49175 17.0834 8.49175Z"
        fill="#9CA3AF"
      />
      <path
        d="M13.1666 1.84158C12.8249 1.49991 12.2333 1.73325 12.2333 2.20825V5.11658C12.2333 6.33325 13.2666 7.34158 14.5249 7.34158C15.3166 7.34991 16.4166 7.34991 17.3583 7.34991C17.8333 7.34991 18.0833 6.79158 17.7499 6.45825C16.5499 5.24991 14.3999 3.07491 13.1666 1.84158Z"
        fill="#9CA3AF"
      />
      <path
        d="M11.25 11.4583H6.25C5.90833 11.4583 5.625 11.1749 5.625 10.8333C5.625 10.4916 5.90833 10.2083 6.25 10.2083H11.25C11.5917 10.2083 11.875 10.4916 11.875 10.8333C11.875 11.1749 11.5917 11.4583 11.25 11.4583Z"
        fill="#9CA3AF"
      />
      <path
        d="M9.58333 14.7917H6.25C5.90833 14.7917 5.625 14.5084 5.625 14.1667C5.625 13.8251 5.90833 13.5417 6.25 13.5417H9.58333C9.925 13.5417 10.2083 13.8251 10.2083 14.1667C10.2083 14.5084 9.925 14.7917 9.58333 14.7917Z"
        fill="#9CA3AF"
      />
    </svg>
  )
}

export function ApiSettingsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        opacity="0.4"
        d="M15.7833 4.51662L11.475 2.02495C10.65 1.54995 9.35834 1.54995 8.53334 2.02495L4.18334 4.53328C2.45834 5.69995 2.35834 5.87495 2.35834 7.73328V12.2583C2.35834 14.1166 2.45834 14.2999 4.21667 15.4833L8.525 17.9749C8.94167 18.2166 9.475 18.3333 10 18.3333C10.525 18.3333 11.0583 18.2166 11.4667 17.9749L15.8167 15.4666C17.5417 14.2999 17.6417 14.1249 17.6417 12.2666V7.73328C17.6417 5.87495 17.5417 5.69995 15.7833 4.51662Z"
        fill="#9CA3AF"
      />
      <path
        d="M10 12.7084C11.4958 12.7084 12.7084 11.4959 12.7084 10.0001C12.7084 8.50431 11.4958 7.29175 10 7.29175C8.50425 7.29175 7.29169 8.50431 7.29169 10.0001C7.29169 11.4959 8.50425 12.7084 10 12.7084Z"
        fill="#9CA3AF"
      />
    </svg>
  )
}

export function ProfileIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        opacity="0.4"
        d="M18.3333 6.50841V13.4918C18.3333 15.8334 17.2583 17.4417 15.3666 18.0501C14.8166 18.2417 14.1833 18.3334 13.4916 18.3334H6.50829C5.81662 18.3334 5.18329 18.2417 4.63329 18.0501C2.74162 17.4417 1.66663 15.8334 1.66663 13.4918V6.50841C1.66663 3.47508 3.47496 1.66675 6.50829 1.66675H13.4916C16.525 1.66675 18.3333 3.47508 18.3333 6.50841Z"
        fill="#9CA3AF"
      />
      <path
        d="M15.3666 18.0499C14.8166 18.2416 14.1833 18.3333 13.4916 18.3333H6.5083C5.81663 18.3333 5.1833 18.2416 4.6333 18.0499C4.92497 15.8499 7.22497 14.1416 9.99997 14.1416C12.775 14.1416 15.075 15.8499 15.3666 18.0499Z"
        fill="#9CA3AF"
      />
      <path
        d="M12.9834 9.6501C12.9834 11.3001 11.6501 12.6417 10.0001 12.6417C8.35006 12.6417 7.01672 11.3001 7.01672 9.6501C7.01672 8.0001 8.35006 6.66675 10.0001 6.66675C11.6501 6.66675 12.9834 8.0001 12.9834 9.6501Z"
        fill="#9CA3AF"
      />
    </svg>
  )
}

export function CustomerIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        opacity="0.4"
        d="M15 15.7167H14.3667C13.7 15.7167 13.0667 15.975 12.6 16.4417L11.175 17.85C10.525 18.4917 9.46668 18.4917 8.81668 17.85L7.39166 16.4417C6.925 15.975 6.28333 15.7167 5.625 15.7167H5C3.61667 15.7167 2.5 14.6084 2.5 13.2417V4.15002C2.5 2.78336 3.61667 1.67505 5 1.67505H15C16.3833 1.67505 17.5 2.78336 17.5 4.15002V13.2417C17.5 14.6001 16.3833 15.7167 15 15.7167Z"
        fill="#9CA3AF"
      />
      <path
        d="M9.99991 8.67506C11.0723 8.67506 11.9416 7.80578 11.9416 6.73343C11.9416 5.66108 11.0723 4.79175 9.99991 4.79175C8.92756 4.79175 8.05823 5.66108 8.05823 6.73343C8.05823 7.80578 8.92756 8.67506 9.99991 8.67506Z"
        fill="#9CA3AF"
      />
      <path
        d="M12.2333 12.5502C12.9083 12.5502 13.2999 11.8002 12.9249 11.2418C12.3583 10.4002 11.2583 9.8335 9.99994 9.8335C8.7416 9.8335 7.6416 10.4002 7.07493 11.2418C6.69993 11.8002 7.09161 12.5502 7.76661 12.5502H12.2333Z"
        fill="#9CA3AF"
      />
    </svg>
  )
}

export function PaymentLinkIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.8833 9.1167C12.7583 10.9917 12.7583 14.025 10.8833 15.8917C9.00833 17.7584 5.97499 17.7667 4.10833 15.8917C2.24166 14.0167 2.23333 10.9834 4.10833 9.1167"
        stroke="#9CA3AF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M8.82505 11.1749C6.87505 9.2249 6.87505 6.05824 8.82505 4.0999C10.775 2.14157 13.9417 2.1499 15.9 4.0999C17.8584 6.0499 17.85 9.21657 15.9 11.1749"
        stroke="#9CA3AF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function PayoutIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        opacity="0.8"
        d="M10.75 2.09999L10.725 2.15833L8.30837 7.76666H5.93337C5.36671 7.76666 4.83337 7.87499 4.33337 8.09166L5.79171 4.60833L5.82504 4.53333L5.87504 4.39999C5.90004 4.34166 5.91671 4.29166 5.94171 4.24999C7.03337 1.72499 8.26671 1.14999 10.75 2.09999Z"
        fill="#9CA3AF"
      />
      <path
        d="M15.2417 7.93343C14.8667 7.8251 14.475 7.76676 14.0667 7.76676H8.30835L10.725 2.15843L10.75 2.1001C10.8667 2.14176 10.9917 2.2001 11.1167 2.24176L12.9584 3.01676C13.9834 3.44176 14.7 3.88343 15.1417 4.41676C15.2167 4.51676 15.2834 4.60843 15.35 4.71676C15.425 4.83343 15.4834 4.9501 15.5167 5.0751C15.55 5.1501 15.575 5.21676 15.5917 5.29176C15.8083 6.0001 15.675 6.85843 15.2417 7.93343Z"
        fill="#9CA3AF"
      />
      <path
        opacity="0.4"
        d="M18.1334 11.8333V13.4583C18.1334 13.6249 18.125 13.7916 18.1167 13.9499C17.9584 16.8666 16.3334 18.3333 13.25 18.3333H6.75003C6.5417 18.3333 6.35003 18.3166 6.15837 18.2916C3.50837 18.1166 2.0917 16.6999 1.90837 14.0499C1.88337 13.8499 1.8667 13.6583 1.8667 13.4583V11.8333C1.8667 10.1583 2.88337 8.7166 4.33337 8.0916C4.83337 7.87494 5.3667 7.7666 5.93337 7.7666H14.0667C14.475 7.7666 14.8667 7.82494 15.2417 7.93327C16.9084 8.4416 18.1334 9.9916 18.1334 11.8333Z"
        fill="#9CA3AF"
      />
      <path
        opacity="0.6"
        d="M5.7917 4.6084L4.33337 8.09173C2.88337 8.71673 1.8667 10.1584 1.8667 11.8334V9.39173C1.8667 7.02507 3.55003 5.05007 5.7917 4.6084Z"
        fill="#9CA3AF"
      />
      <path
        opacity="0.6"
        d="M18.1334 9.39162V11.8333C18.1334 9.99162 16.9084 8.44162 15.2417 7.93328C15.675 6.85828 15.8084 5.99995 15.5917 5.29162C15.575 5.21662 15.55 5.14995 15.5167 5.07495C17.075 5.88328 18.1334 7.52495 18.1334 9.39162Z"
        fill="#9CA3AF"
      />
      <path
        d="M12.0833 13.9583H7.91663C7.57496 13.9583 7.29163 13.6749 7.29163 13.3333C7.29163 12.9916 7.57496 12.7083 7.91663 12.7083H12.0833C12.425 12.7083 12.7083 12.9916 12.7083 13.3333C12.7083 13.6749 12.425 13.9583 12.0833 13.9583Z"
        fill="#9CA3AF"
      />
    </svg>
  )
}

export function TransactionIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        opacity="0.4"
        d="M13.4916 1.66675H6.50829C3.47496 1.66675 1.66663 3.47508 1.66663 6.50841V13.4834C1.66663 16.5251 3.47496 18.3334 6.50829 18.3334H13.4833C16.5166 18.3334 18.325 16.5251 18.325 13.4917V6.50841C18.3333 3.47508 16.525 1.66675 13.4916 1.66675Z"
        fill="#9CA3AF"
      />
      <path
        d="M6.10826 12.7C5.97493 12.7 5.8416 12.6583 5.72493 12.5667C5.44993 12.3583 5.39993 11.9667 5.60826 11.6917L7.5916 9.11667C7.83326 8.80834 8.17493 8.60834 8.5666 8.55834C8.94993 8.50834 9.3416 8.61667 9.64993 8.85834L11.1749 10.0583C11.2333 10.1083 11.2916 10.1083 11.3333 10.1C11.3666 10.1 11.4249 10.0833 11.4749 10.0167L13.3999 7.53334C13.6083 7.25834 14.0083 7.20834 14.2749 7.42501C14.5499 7.63334 14.5999 8.02501 14.3833 8.30001L12.4583 10.7833C12.2166 11.0917 11.8749 11.2917 11.4833 11.3333C11.0916 11.3833 10.7083 11.275 10.3999 11.0333L8.87493 9.83334C8.8166 9.78334 8.74993 9.78334 8.7166 9.79167C8.68326 9.79167 8.62493 9.80834 8.57493 9.87501L6.5916 12.45C6.48326 12.6167 6.29993 12.7 6.10826 12.7Z"
        fill="#9CA3AF"
      />
    </svg>
  )
}

export function DashboardIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        opacity="0.4"
        d="M8.39173 2.35005L2.61673 6.97504C1.96673 7.4917 1.55006 8.58337 1.69172 9.40004L2.80006 16.0334C3.00006 17.2167 4.13339 18.175 5.33339 18.175H14.6667C15.8584 18.175 17.0001 17.2084 17.2001 16.0334L18.3084 9.40004C18.4417 8.58337 18.0251 7.4917 17.3834 6.97504L11.6084 2.35836C10.7167 1.6417 9.27506 1.64171 8.39173 2.35005Z"
        fill="#9CA3AF"
      />
      <path
        d="M9.99996 12.9167C11.1506 12.9167 12.0833 11.9839 12.0833 10.8333C12.0833 9.68274 11.1506 8.75 9.99996 8.75C8.84937 8.75 7.91663 9.68274 7.91663 10.8333C7.91663 11.9839 8.84937 12.9167 9.99996 12.9167Z"
        fill="#9CA3AF"
      />
    </svg>
  )
}

export function DashboardActiveIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        opacity="0.4"
        d="M8.39167 2.35005L2.61666 6.97504C1.96666 7.4917 1.55 8.58337 1.69166 9.40004L2.8 16.0334C3 17.2167 4.13333 18.175 5.33333 18.175H14.6667C15.8583 18.175 17 17.2084 17.2 16.0334L18.3083 9.40004C18.4417 8.58337 18.025 7.4917 17.3833 6.97504L11.6083 2.35836C10.7167 1.6417 9.275 1.64171 8.39167 2.35005Z"
        fill="white"
      />
      <path
        d="M10 12.9167C11.1506 12.9167 12.0834 11.9839 12.0834 10.8333C12.0834 9.68274 11.1506 8.75 10 8.75C8.84943 8.75 7.91669 9.68274 7.91669 10.8333C7.91669 11.9839 8.84943 12.9167 10 12.9167Z"
        fill="white"
      />
    </svg>
  )
}

export function TransactionActiveIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        opacity="0.4"
        d="M13.4917 1.6665H6.50835C3.47502 1.6665 1.66669 3.47484 1.66669 6.50817V13.4832C1.66669 16.5248 3.47502 18.3332 6.50835 18.3332H13.4834C16.5167 18.3332 18.325 16.5248 18.325 13.4915V6.50817C18.3334 3.47484 16.525 1.6665 13.4917 1.6665Z"
        fill="#F2F6F6"
      />
      <path
        d="M6.10832 12.7C5.97499 12.7 5.84166 12.6583 5.72499 12.5667C5.44999 12.3583 5.39999 11.9667 5.60832 11.6917L7.59166 9.11667C7.83332 8.80834 8.17499 8.60834 8.56666 8.55834C8.94999 8.50834 9.34166 8.61667 9.64999 8.85834L11.175 10.0583C11.2333 10.1083 11.2917 10.1083 11.3333 10.1C11.3667 10.1 11.425 10.0833 11.475 10.0167L13.4 7.53334C13.6083 7.25834 14.0083 7.20834 14.275 7.42501C14.55 7.63334 14.6 8.02501 14.3833 8.30001L12.4583 10.7833C12.2167 11.0917 11.875 11.2917 11.4833 11.3333C11.0917 11.3833 10.7083 11.275 10.4 11.0333L8.87499 9.83334C8.81666 9.78334 8.74999 9.78334 8.71666 9.79167C8.68333 9.79167 8.62499 9.80834 8.57499 9.87501L6.59166 12.45C6.48332 12.6167 6.29999 12.7 6.10832 12.7Z"
        fill="#F2F6F6"
      />
    </svg>
  )
}

export function PaymentActiveIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        opacity="0.8"
        d="M10.75 2.10024L10.725 2.15857L8.30831 7.7669H5.93331C5.36665 7.7669 4.83331 7.87524 4.33331 8.0919L5.79165 4.60857L5.82498 4.53357L5.87498 4.40024C5.89998 4.3419 5.91665 4.2919 5.94165 4.25024C7.03331 1.72524 8.26665 1.15024 10.75 2.10024Z"
        fill="#F2F6F6"
      />
      <path
        d="M15.2417 7.93343C14.8667 7.8251 14.475 7.76676 14.0667 7.76676H8.30835L10.725 2.15843L10.75 2.1001C10.8667 2.14176 10.9917 2.2001 11.1167 2.24176L12.9584 3.01676C13.9834 3.44176 14.7 3.88343 15.1417 4.41676C15.2167 4.51676 15.2834 4.60843 15.35 4.71676C15.425 4.83343 15.4834 4.9501 15.5167 5.0751C15.55 5.1501 15.575 5.21676 15.5917 5.29176C15.8083 6.0001 15.675 6.85843 15.2417 7.93343Z"
        fill="#F2F6F6"
      />
      <path
        opacity="0.4"
        d="M18.1333 11.8333V13.4583C18.1333 13.6249 18.125 13.7916 18.1166 13.9499C17.9583 16.8666 16.3333 18.3333 13.25 18.3333H6.74997C6.54164 18.3333 6.34997 18.3166 6.1583 18.2916C3.5083 18.1166 2.09164 16.6999 1.9083 14.0499C1.8833 13.8499 1.86664 13.6583 1.86664 13.4583V11.8333C1.86664 10.1583 2.8833 8.7166 4.3333 8.0916C4.8333 7.87494 5.36664 7.7666 5.9333 7.7666H14.0666C14.475 7.7666 14.8666 7.82494 15.2416 7.93327C16.9083 8.4416 18.1333 9.9916 18.1333 11.8333Z"
        fill="#F2F6F6"
      />
      <path
        opacity="0.6"
        d="M5.79164 4.6084L4.3333 8.09173C2.8833 8.71673 1.86664 10.1584 1.86664 11.8334V9.39173C1.86664 7.02507 3.54997 5.05007 5.79164 4.6084Z"
        fill="#F2F6F6"
      />
      <path
        opacity="0.6"
        d="M18.1333 9.39186V11.8335C18.1333 9.99186 16.9083 8.44186 15.2416 7.93353C15.675 6.85853 15.8083 6.0002 15.5916 5.29186C15.575 5.21686 15.55 5.1502 15.5166 5.0752C17.075 5.88353 18.1333 7.5252 18.1333 9.39186Z"
        fill="#F2F6F6"
      />
      <path
        d="M12.0834 13.9585H7.91669C7.57502 13.9585 7.29169 13.6752 7.29169 13.3335C7.29169 12.9918 7.57502 12.7085 7.91669 12.7085H12.0834C12.425 12.7085 12.7084 12.9918 12.7084 13.3335C12.7084 13.6752 12.425 13.9585 12.0834 13.9585Z"
        fill="#F2F6F6"
      />
    </svg>
  )
}

export function PaymentLinksActiveIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.8833 9.11621C12.7583 10.9912 12.7583 14.0245 10.8833 15.8912C9.00833 17.7579 5.97499 17.7662 4.10833 15.8912C2.24166 14.0162 2.23333 10.9829 4.10833 9.11621"
        stroke="#F2F6F6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M8.82499 11.1754C6.87499 9.22539 6.87499 6.05873 8.82499 4.10039C10.775 2.14206 13.9417 2.15039 15.9 4.10039C17.8583 6.05039 17.85 9.21706 15.9 11.1754"
        stroke="#F2F6F6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CustomerActiveIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        opacity="0.4"
        d="M15 15.7165H14.3667C13.7 15.7165 13.0667 15.9748 12.6 16.4414L11.175 17.8498C10.525 18.4914 9.46668 18.4914 8.81668 17.8498L7.39166 16.4414C6.925 15.9748 6.28333 15.7165 5.625 15.7165H5C3.61667 15.7165 2.5 14.6081 2.5 13.2415V4.14978C2.5 2.78311 3.61667 1.6748 5 1.6748H15C16.3833 1.6748 17.5 2.78311 17.5 4.14978V13.2415C17.5 14.5998 16.3833 15.7165 15 15.7165Z"
        fill="#B4C8CB"
      />
      <path
        d="M10 8.6753C11.0724 8.6753 11.9417 7.80603 11.9417 6.73367C11.9417 5.66132 11.0724 4.79199 10 4.79199C8.92768 4.79199 8.05835 5.66132 8.05835 6.73367C8.05835 7.80603 8.92768 8.6753 10 8.6753Z"
        fill="#B4C8CB"
      />
      <path
        d="M12.2333 12.5507C12.9083 12.5507 13.3 11.8007 12.925 11.2423C12.3583 10.4007 11.2583 9.83398 10 9.83398C8.74166 9.83398 7.64166 10.4007 7.07499 11.2423C6.69999 11.8007 7.09167 12.5507 7.76667 12.5507H12.2333Z"
        fill="#B4C8CB"
      />
    </svg>
  )
}

export function ProfileActiveIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        opacity="0.4"
        d="M18.3334 6.50866V13.492C18.3334 15.8337 17.2584 17.442 15.3667 18.0503C14.8167 18.242 14.1834 18.3337 13.4917 18.3337H6.50835C5.81669 18.3337 5.18335 18.242 4.63335 18.0503C2.74169 17.442 1.66669 15.8337 1.66669 13.492V6.50866C1.66669 3.47532 3.47502 1.66699 6.50835 1.66699H13.4917C16.525 1.66699 18.3334 3.47532 18.3334 6.50866Z"
        fill="#F2F6F6"
      />
      <path
        d="M15.3666 18.0499C14.8166 18.2416 14.1833 18.3333 13.4916 18.3333H6.5083C5.81663 18.3333 5.1833 18.2416 4.6333 18.0499C4.92497 15.8499 7.22497 14.1416 9.99997 14.1416C12.775 14.1416 15.075 15.8499 15.3666 18.0499Z"
        fill="#F2F6F6"
      />
      <path
        d="M12.9833 9.65034C12.9833 11.3003 11.65 12.642 10 12.642C8.35 12.642 7.01666 11.3003 7.01666 9.65034C7.01666 8.00034 8.35 6.66699 10 6.66699C11.65 6.66699 12.9833 8.00034 12.9833 9.65034Z"
        fill="#F2F6F6"
      />
    </svg>
  )
}

export function ApiSettingsActiveIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        opacity="0.4"
        d="M15.7833 4.51686L11.475 2.0252C10.65 1.5502 9.35834 1.5502 8.53334 2.0252L4.18334 4.53353C2.45834 5.70019 2.35834 5.87519 2.35834 7.73353V12.2585C2.35834 14.1169 2.45834 14.3002 4.21667 15.4835L8.525 17.9752C8.94167 18.2169 9.475 18.3335 10 18.3335C10.525 18.3335 11.0583 18.2169 11.4667 17.9752L15.8167 15.4669C17.5417 14.3002 17.6417 14.1252 17.6417 12.2669V7.73353C17.6417 5.87519 17.5417 5.70019 15.7833 4.51686Z"
        fill="#F2F6F6"
      />
      <path
        d="M10 12.7087C11.4958 12.7087 12.7084 11.4961 12.7084 10.0003C12.7084 8.50455 11.4958 7.29199 10 7.29199C8.50425 7.29199 7.29169 8.50455 7.29169 10.0003C7.29169 11.4961 8.50425 12.7087 10 12.7087Z"
        fill="#F2F6F6"
      />
    </svg>
  )
}

export function HelpActiveIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        opacity="0.4"
        d="M8.95834 2.0416C9.54167 1.54993 10.4833 1.54993 11.05 2.0416L12.3667 3.1666C12.6167 3.37493 13.0917 3.54993 13.425 3.54993H14.8417C15.725 3.54993 16.45 4.27494 16.45 5.15827V6.57493C16.45 6.90827 16.625 7.37493 16.8333 7.62493L17.9583 8.9416C18.45 9.52494 18.45 10.4666 17.9583 11.0333L16.8333 12.3499C16.625 12.5999 16.45 13.0666 16.45 13.3999V14.8166C16.45 15.6999 15.725 16.4249 14.8417 16.4249H13.425C13.0917 16.4249 12.625 16.5999 12.375 16.8083L11.0583 17.9333C10.475 18.4249 9.53334 18.4249 8.96667 17.9333L7.65 16.8083C7.4 16.5999 6.925 16.4249 6.6 16.4249H5.14167C4.25834 16.4249 3.53334 15.6999 3.53334 14.8166V13.3916C3.53334 13.0666 3.36667 12.5916 3.15834 12.3499L2.03334 11.0249C1.55 10.4499 1.55 9.5166 2.03334 8.9416L3.15834 7.6166C3.36667 7.3666 3.53334 6.89993 3.53334 6.57493V5.1666C3.53334 4.28327 4.25834 3.55827 5.14167 3.55827H6.58334C6.91667 3.55827 7.38334 3.38327 7.63334 3.17493L8.95834 2.0416Z"
        fill="#F2F6F6"
      />
      <path
        d="M10 14.0583C9.54169 14.0583 9.16669 13.6833 9.16669 13.2249C9.16669 12.7666 9.53335 12.3916 10 12.3916C10.4584 12.3916 10.8334 12.7666 10.8334 13.2249C10.8334 13.6833 10.4667 14.0583 10 14.0583Z"
        fill="#F2F6F6"
      />
      <path
        d="M10 11.4337C9.65833 11.4337 9.375 11.1504 9.375 10.8087V6.77539C9.375 6.43372 9.65833 6.15039 10 6.15039C10.3417 6.15039 10.625 6.43372 10.625 6.77539V10.8004C10.625 11.1504 10.35 11.4337 10 11.4337Z"
        fill="#F2F6F6"
      />
    </svg>
  )
}

export function LogoutIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        opacity="0.4"
        d="M11.0333 1.66699C11.425 1.66699 11.75 1.98366 11.75 2.38366V17.6253C11.75 18.017 11.4333 18.342 11.0333 18.342C6.12501 18.342 2.70001 14.917 2.70001 10.0087C2.70001 5.10033 6.13335 1.66699 11.0333 1.66699Z"
        fill="#9CA3AF"
      />
      <path
        d="M17.1167 9.6168L14.75 7.2418C14.5083 7.00013 14.1083 7.00013 13.8666 7.2418C13.625 7.48346 13.625 7.88346 13.8666 8.12513L15.1667 9.42513H7.19165C6.84998 9.42513 6.56665 9.70846 6.56665 10.0501C6.56665 10.3918 6.84998 10.6751 7.19165 10.6751H15.1667L13.8666 11.9751C13.625 12.2168 13.625 12.6168 13.8666 12.8585C13.9916 12.9835 14.15 13.0418 14.3083 13.0418C14.4667 13.0418 14.625 12.9835 14.75 12.8585L17.1167 10.4835C17.3583 10.2501 17.3583 9.85846 17.1167 9.6168Z"
        fill="#9CA3AF"
      />
    </svg>
  )
}

export const WaveIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_602_1048)">
        <path
          d="M2.70056 5.08175C3.22278 4.71675 4.01001 4.78675 4.4789 5.17398L3.94112 4.39231C3.50834 3.77509 3.66334 3.10731 4.28112 2.67398C4.8989 2.24231 6.64945 3.40287 6.64945 3.40287C6.21278 2.77953 6.29445 1.98953 6.91778 1.55231C7.54112 1.11675 8.40112 1.26731 8.83778 1.89175L14.6267 10.0695L13.8889 17.2223L7.73167 14.9768L2.36112 7.01398C1.92056 6.38675 2.07278 5.52175 2.70056 5.08175Z"
          fill="#EF9645"
        />
        <path
          d="M1.49722 9.63107C1.49722 9.63107 0.868334 8.71441 1.78556 8.08607C2.70167 7.45774 3.33 8.37385 3.33 8.37385L6.24722 12.6283C6.34778 12.4605 6.45778 12.295 6.58056 12.1316L2.53167 6.22774C2.53167 6.22774 1.90333 5.31163 2.82 4.6833C3.73611 4.05496 4.36444 4.97107 4.36444 4.97107L8.17278 10.525C8.31445 10.4094 8.45944 10.2933 8.60889 10.1794L4.19389 3.73996C4.19389 3.73996 3.56556 2.82385 4.48222 2.19552C5.39833 1.56719 6.02667 2.4833 6.02667 2.4833L10.4417 8.92163C10.6039 8.82219 10.7644 8.73607 10.9256 8.64496L6.79889 2.62719C6.79889 2.62719 6.17056 1.71107 7.08667 1.08274C8.00278 0.454408 8.63111 1.37052 8.63111 1.37052L12.9944 7.73385L13.6578 8.70163C10.9089 10.5872 10.6472 14.1344 12.2178 16.425C12.5317 16.8833 12.99 16.5694 12.99 16.5694C11.105 13.82 11.6806 10.7305 14.43 8.84552L13.6194 4.78885C13.6194 4.78885 13.3167 3.71996 14.385 3.41663C15.4539 3.11385 15.7572 4.18274 15.7572 4.18274L16.6933 6.96274C17.0644 8.06496 17.4594 9.1633 17.9822 10.2022C19.4583 13.1355 18.5767 16.7811 15.7933 18.6905C12.7572 20.7722 8.60667 19.9983 6.52445 16.9627L1.49722 9.63107Z"
          fill="#FFDC5D"
        />
        <path
          d="M6.66667 17.8012C4.44445 17.8012 2.19889 15.5556 2.19889 13.3334C2.19889 13.0262 1.97389 12.7778 1.66667 12.7778C1.35945 12.7778 1.08778 13.0262 1.08778 13.3334C1.08778 16.6667 3.33334 18.9123 6.66667 18.9123C6.9739 18.9123 7.22223 18.6406 7.22223 18.3334C7.22223 18.0262 6.9739 17.8012 6.66667 17.8012Z"
          fill="#5DADEC"
        />
        <path
          d="M3.88889 18.8891C2.22222 18.8891 1.11111 17.778 1.11111 16.1113C1.11111 15.8041 0.862778 15.5558 0.555556 15.5558C0.248333 15.5558 0 15.8041 0 16.1113C0 18.3336 1.66667 20.0002 3.88889 20.0002C4.19611 20.0002 4.44444 19.7519 4.44444 19.4447C4.44444 19.1374 4.19611 18.8891 3.88889 18.8891ZM13.3333 1.11133C13.0267 1.11133 12.7778 1.36022 12.7778 1.66688C12.7778 1.97355 13.0267 2.22244 13.3333 2.22244C15.5556 2.22244 17.7778 4.21633 17.7778 6.66688C17.7778 6.97355 18.0267 7.22244 18.3333 7.22244C18.64 7.22244 18.8889 6.97355 18.8889 6.66688C18.8889 3.60355 16.6667 1.11133 13.3333 1.11133Z"
          fill="#5DADEC"
        />
        <path
          d="M16.1111 0.0234375C15.8044 0.0234375 15.5556 0.248993 15.5556 0.55566C15.5556 0.862326 15.8044 1.13455 16.1111 1.13455C17.7778 1.13455 18.8656 2.37066 18.8656 3.88899C18.8656 4.19566 19.1372 4.44455 19.4444 4.44455C19.7517 4.44455 19.9767 4.19566 19.9767 3.88899C19.9767 1.75733 18.3333 0.0234375 16.1111 0.0234375Z"
          fill="#5DADEC"
        />
      </g>
      <defs>
        <clipPath id="clip0_602_1048">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const BackArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="8"
      viewBox="0 0 18 8"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.06661 0.43376C5.18365 0.550948 5.24939 0.709801 5.24939 0.875427C5.24939 1.04105 5.18365 1.19991 5.06661 1.31709L3.00827 3.37543H16.4999C16.6657 3.37543 16.8247 3.44127 16.9419 3.55849C17.0591 3.6757 17.1249 3.83467 17.1249 4.00043C17.1249 4.16619 17.0591 4.32516 16.9419 4.44237C16.8247 4.55958 16.6657 4.62543 16.4999 4.62543H3.00827L5.06661 6.68376C5.12801 6.74098 5.17726 6.80998 5.21142 6.88664C5.24558 6.96331 5.26395 7.04607 5.26543 7.12999C5.26691 7.21391 5.25147 7.29727 5.22004 7.37509C5.18861 7.45291 5.14182 7.52361 5.08247 7.58296C5.02312 7.64231 4.95243 7.68909 4.8746 7.72053C4.79678 7.75196 4.71342 7.7674 4.6295 7.76592C4.54558 7.76444 4.46282 7.74607 4.38616 7.71191C4.30949 7.67775 4.24049 7.6285 4.18327 7.56709L1.05827 4.44209C0.94123 4.32491 0.875488 4.16605 0.875488 4.00043C0.875488 3.8348 0.94123 3.67595 1.05827 3.55876L4.18327 0.43376C4.30046 0.316718 4.45931 0.250977 4.62494 0.250977C4.79056 0.250977 4.94942 0.316718 5.06661 0.43376Z"
        fill="#1C1C1C"
      />
    </svg>
  )
}

export const GenerateIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19.07 14.2401C18.78 14.5301 18.32 14.5301 18.04 14.2401C17.75 13.9501 17.75 13.4901 18.04 13.2101C20.04 11.2101 20.04 7.9601 18.04 5.9701C16.04 3.9801 12.79 3.9701 10.8 5.9701C8.81 7.9701 8.8 11.2201 10.8 13.2101C11.09 13.5001 11.09 13.9601 10.8 14.2401C10.51 14.5301 10.05 14.5301 9.77 14.2401C7.2 11.6701 7.2 7.4901 9.77 4.9301C12.34 2.3701 16.52 2.3601 19.08 4.9301C21.64 7.5001 21.64 11.6701 19.07 14.2401Z"
        fill="white"
      />
      <path
        d="M4.93 9.75998C5.22 9.46998 5.68 9.46998 5.96 9.75998C6.25 10.05 6.25 10.51 5.96 10.79C3.96 12.79 3.96 16.04 5.96 18.03C7.96 20.02 11.21 20.03 13.2 18.03C15.19 16.03 15.2 12.78 13.2 10.79C12.91 10.5 12.91 10.04 13.2 9.75998C13.49 9.46998 13.95 9.46998 14.23 9.75998C16.8 12.33 16.8 16.51 14.23 19.07C11.66 21.63 7.48 21.64 4.92 19.07C2.36 16.5 2.36 12.33 4.93 9.75998Z"
        fill="white"
      />
    </svg>
  )
}

export const HideBalanceIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M2.94167 2.05837C2.82319 1.94797 2.66649 1.88787 2.50457 1.89072C2.34265 1.89358 2.18816 1.95917 2.07365 2.07368C1.95914 2.18819 1.89355 2.34268 1.89069 2.5046C1.88784 2.66652 1.94794 2.82322 2.05834 2.9417L17.0583 17.9417C17.1156 18.0031 17.1846 18.0524 17.2612 18.0865C17.3379 18.1207 17.4207 18.139 17.5046 18.1405C17.5885 18.142 17.6718 18.1266 17.7497 18.0951C17.8275 18.0637 17.8982 18.0169 17.9575 17.9576C18.0169 17.8982 18.0637 17.8275 18.0951 17.7497C18.1265 17.6719 18.142 17.5885 18.1405 17.5046C18.139 17.4207 18.1206 17.3379 18.0865 17.2613C18.0523 17.1846 18.0031 17.1156 17.9417 17.0584L2.94167 2.05837ZM18.8967 10.4609C18.4475 11.8088 17.6977 13.0369 16.7042 14.0525L14.1217 11.47C14.4003 10.69 14.4517 9.84684 14.27 9.03868C14.0883 8.23053 13.6809 7.49057 13.0952 6.90486C12.5095 6.31914 11.7695 5.91173 10.9614 5.73002C10.1532 5.54831 9.31007 5.59975 8.53 5.87837L6.46584 3.8142C7.58836 3.3575 8.78897 3.12344 10.0008 3.12503C14.1425 3.12503 17.655 5.81087 18.8967 9.53337C18.9967 9.83503 18.9967 10.16 18.8967 10.4609Z"
        fill="#B4C8CB"
      />
      <path
        d="M13.125 9.99992C13.125 10.1499 13.1142 10.2974 13.0942 10.4416L9.5575 6.90576C10.0008 6.84234 10.4526 6.87495 10.8822 7.00138C11.3118 7.1278 11.7092 7.34508 12.0475 7.6385C12.3859 7.93193 12.6571 8.29463 12.843 8.70206C13.0289 9.10948 13.1251 9.55209 13.125 9.99992ZM10.4417 13.0941L6.90583 9.55742C6.83713 10.0378 6.88125 10.5276 7.03471 10.988C7.18816 11.4484 7.44672 11.8667 7.78991 12.2098C8.1331 12.5529 8.55148 12.8114 9.0119 12.9647C9.47232 13.1181 9.96212 13.1621 10.4425 13.0933L10.4417 13.0941Z"
        fill="#B4C8CB"
      />
      <path
        d="M5.62499 10.0001C5.62499 9.48428 5.71415 8.98928 5.87832 8.53011L3.29499 5.94678C2.30174 6.96248 1.55231 8.19063 1.10332 9.53844C1.00332 9.84011 1.00332 10.1651 1.10332 10.4668C2.34415 14.1893 5.85665 16.8751 9.99915 16.8751C11.2492 16.8751 12.4433 16.6301 13.5342 16.1859L11.47 14.1218C10.8097 14.3573 10.1025 14.4308 9.40787 14.3359C8.71327 14.241 8.05165 13.9806 7.47872 13.5766C6.90579 13.1726 6.43834 12.6368 6.11574 12.0144C5.79313 11.392 5.62482 10.7012 5.62499 10.0001Z"
        fill="#B4C8CB"
      />
    </svg>
  )
}

export const StatisticsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M12.4917 0.666748H5.50833C2.475 0.666748 0.666668 2.47508 0.666668 5.50841V12.4834C0.666668 15.5251 2.475 17.3334 5.50833 17.3334H12.4833C15.5167 17.3334 17.325 15.5251 17.325 12.4917V5.50841C17.3333 2.47508 15.525 0.666748 12.4917 0.666748ZM13.3833 7.30008L11.4583 9.78341C11.2167 10.0917 10.875 10.2917 10.4833 10.3334C10.0917 10.3834 9.70833 10.2751 9.4 10.0334L7.875 8.83342C7.81667 8.78341 7.75 8.78341 7.71667 8.79175C7.68333 8.79175 7.625 8.80842 7.575 8.87508L5.59167 11.4501C5.46667 11.6084 5.28333 11.6917 5.1 11.6917C4.96667 11.6917 4.83333 11.6501 4.71667 11.5584C4.44167 11.3501 4.39167 10.9584 4.6 10.6834L6.58333 8.10842C6.825 7.80008 7.16667 7.60008 7.55833 7.55008C7.94167 7.50008 8.33333 7.60842 8.64167 7.85008L10.1667 9.05008C10.225 9.10008 10.2833 9.10008 10.325 9.09175C10.3583 9.09175 10.4167 9.07508 10.4667 9.00842L12.3917 6.52508C12.6 6.25008 13 6.20008 13.2667 6.41675C13.5417 6.64175 13.5917 7.03341 13.3833 7.30008Z"
        fill="#044752"
      />
    </svg>
  )
}

export const EmptyCurrencyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
    >
      <path
        d="M42.5339 61.0823C42.5339 61.768 42.3314 62.2317 41.9265 62.4602C41.5216 62.6953 41.0188 62.6366 40.4179 62.2904L6.52407 42.7182C5.35509 42.0455 4.36246 40.9941 3.53307 39.5639C2.69715 38.1337 2.28571 36.7492 2.28571 35.4104V11.1035C2.28571 10.4178 2.48811 9.9541 2.89301 9.72553L3.01713 9.66676C3.40244 9.51002 3.85958 9.58186 4.40162 9.89533C5.00243 10.2415 5.50525 10.7704 5.91015 11.4692C6.32158 12.168 6.52407 12.8602 6.52407 13.5525V37.8594L40.4179 57.4251C41.0188 57.7712 41.5216 58.3002 41.9265 58.999C42.3314 59.6978 42.5339 60.39 42.5339 61.0823Z"
        fill="#F2F6F6"
        stroke="#044752"
        strokeWidth="0.979592"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.7432 44.6968C42.3514 44.6968 41.9922 44.8013 41.6592 44.9907C40.8298 45.4609 40.4183 46.3686 40.4183 47.7074L44.6502 50.1498V45.8005L42.7432 44.6968Z"
        fill="#F2F6F6"
        stroke="#044752"
        strokeWidth="0.979592"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M55.5952 54.5515C55.5952 55.2372 55.3928 55.7009 54.9879 55.9295L54.8639 55.9882L41.9267 62.4601C42.3316 62.2315 42.534 61.7678 42.534 61.0821C42.534 60.3964 42.3316 59.6976 41.9267 58.9988C41.5218 58.3001 41.019 57.7711 40.4182 57.425L6.52423 37.8592L12.1863 35.0315C12.9765 36.318 13.9169 37.265 14.9944 37.8919L44.6499 55.0152C45.8189 55.6878 46.8181 55.7858 47.6475 55.309L50.3577 53.9572L54.5634 51.8478C54.7201 52.0372 54.8573 52.2462 54.9879 52.4682C55.3928 53.167 55.5952 53.8592 55.5952 54.5515Z"
        fill="#F2F6F6"
        stroke="#044752"
        strokeWidth="0.979592"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9714 4.93849L15.347 6.74746L12.2646 8.28868L12.0033 8.4193C11.1739 8.89603 10.756 9.79726 10.756 11.136V30.5842C10.756 31.9164 11.1739 33.3009 12.0033 34.7311C12.0621 34.8356 12.1209 34.9336 12.1862 35.0315L6.52414 37.8593V13.5524C6.52414 12.8601 6.32166 12.1679 5.91023 11.4691C5.50533 10.7703 5.00251 10.2413 4.4017 9.89521C3.85965 9.58175 3.40252 9.50991 3.01721 9.66664L15.9543 3.19482C16.3592 2.96625 16.8621 3.01849 17.4629 3.36461C18.0637 3.71074 18.5665 4.23972 18.9714 4.93849Z"
        fill="#F2F6F6"
        stroke="#044752"
        strokeWidth="0.979592"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.4904 28.7751C23.51 29.2388 23.5688 29.7025 23.6602 30.1662C23.5753 29.696 23.5165 29.2388 23.4904 28.7751Z"
        fill="#F2F6F6"
        stroke="#044752"
        strokeWidth="0.979592"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.6496 30.7017V35.567C43.4871 34.8944 42.488 33.843 41.6586 32.4127C41.4496 32.0536 41.2667 31.7009 41.1165 31.3483H41.11C40.6463 30.2903 40.4177 29.2585 40.4177 28.2593L44.6496 30.7017Z"
        fill="#F2F6F6"
        stroke="#044752"
        strokeWidth="0.979592"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.6602 30.1662C23.5688 29.7025 23.51 29.2388 23.4904 28.7751C23.5165 29.2388 23.5753 29.696 23.6602 30.1662Z"
        fill="#F2F6F6"
        stroke="#044752"
        strokeWidth="0.979592"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.7182 31.6617C48.5288 30.7931 48.1761 29.905 47.6472 28.9972C46.8178 27.567 45.8187 26.5156 44.6497 25.8429L36.5451 21.167L23.817 13.8136L19.5851 11.3711L15.3468 8.92212L14.9941 8.71967C13.9492 8.11886 13.0415 7.97518 12.2644 8.28865L12.0031 8.41927C11.1738 8.896 10.7557 9.79723 10.7557 11.136V30.5842C10.7557 31.9164 11.1738 33.3009 12.0031 34.7311C12.0619 34.8356 12.1207 34.9336 12.186 35.0315C12.9762 36.318 13.9166 37.265 14.9941 37.8919L44.6497 55.0152C45.8187 55.6878 46.8178 55.7858 47.6472 55.3091C48.3721 54.8976 48.777 54.1597 48.8684 53.0952C48.8814 52.9385 48.888 52.7687 48.888 52.5989V33.1507C48.888 32.6609 48.8357 32.1646 48.7182 31.6617ZM17.6912 34.5874L15.5492 33.3466L14.9941 33.0266V28.1678C15.1117 28.2397 15.2293 28.3115 15.3468 28.3899C16.3656 29.0625 17.2407 30.0356 17.9852 31.3221C18.0178 31.3744 18.0504 31.4266 18.0766 31.4854C18.168 31.6421 18.2463 31.7989 18.3247 31.9556C18.9321 33.1638 19.2325 34.3327 19.2325 35.4756L17.6912 34.5874ZM19.2194 16.3278C19.2129 16.478 19.1999 16.6152 19.1803 16.7523C19.1672 16.8568 19.1542 16.9548 19.128 17.0527C19.0497 17.438 18.919 17.7646 18.7296 18.0454C18.6708 18.1368 18.6121 18.2152 18.5403 18.2936C18.5403 18.3001 18.5338 18.3001 18.5272 18.3066C18.4619 18.3785 18.3901 18.4503 18.3117 18.5156C18.3117 18.5156 18.279 18.5482 18.2594 18.5613C18.2398 18.5744 18.2268 18.5874 18.2072 18.6005C18.1419 18.6527 18.07 18.6985 17.9917 18.7442C17.2472 19.1687 16.3721 19.1295 15.3534 18.6331C15.2358 18.5744 15.1247 18.5091 15.0072 18.4438H15.0006V13.585L15.3534 13.7874L19.239 16.0274C19.239 16.1319 19.239 16.2299 19.2259 16.3278H19.2194ZM36.1664 36.0438C36.0685 37.7874 35.4545 38.9825 34.3247 39.6291C34.2594 39.6617 34.2007 39.7009 34.1354 39.727C32.9338 40.3148 31.497 40.1254 29.8252 39.1589C28.1468 38.1923 26.7166 36.7295 25.528 34.7572C25.4561 34.6527 25.3909 34.5417 25.3256 34.4307C25.0448 33.9474 24.7966 33.4707 24.5811 32.994C24.5289 32.8829 24.4766 32.7719 24.4309 32.6609C24.2219 32.1646 24.0455 31.6682 23.9084 31.1785C23.8757 31.0674 23.8431 30.9564 23.817 30.8454C23.7582 30.6234 23.7059 30.3948 23.6602 30.1662C23.5688 29.7025 23.51 29.2389 23.4904 28.7752C23.4774 28.5858 23.4708 28.3899 23.4708 28.2005C23.4708 27.1295 23.6406 26.2478 23.9868 25.5491C24.2937 24.9156 24.7378 24.4323 25.3256 24.0993C26.1223 23.6487 27.0366 23.5507 28.0553 23.825C28.617 23.9687 29.2048 24.2168 29.8252 24.576C30.4456 24.9352 31.0334 25.3597 31.5885 25.856C32.6138 26.7703 33.528 27.9197 34.3247 29.2976C35.559 31.4331 36.1795 33.5099 36.1795 35.5344C36.1795 35.7107 36.1729 35.8805 36.1664 36.0438ZM44.6497 50.1499L40.4178 47.7074C40.4178 46.3687 40.8293 45.4609 41.6587 44.9907C41.9917 44.8013 42.3508 44.7034 42.7427 44.6968L44.6497 45.8005V50.1499ZM44.6497 35.567C43.4872 34.8944 42.488 33.8429 41.6587 32.4127C41.4497 32.0536 41.2668 31.7009 41.1166 31.3482H41.11C40.6463 30.2903 40.4178 29.2585 40.4178 28.2593L44.6497 30.7017V35.567Z"
        fill="#F2F6F6"
        stroke="#044752"
        strokeWidth="0.979592"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.1793 35.5343C36.1793 35.7107 36.1727 35.8804 36.1662 36.0437C36.0683 37.7874 35.4543 38.9825 34.3245 39.629C34.2592 39.6617 34.2005 39.7009 34.1352 39.727C32.9336 40.3147 31.4969 40.1253 29.8251 39.1588C28.1467 38.1923 26.7164 36.7294 25.5278 34.7572C25.456 34.6527 25.3907 34.5417 25.3254 34.4307C25.0446 33.9474 24.7964 33.4707 24.5809 32.9939C24.5287 32.8829 24.4764 32.7719 24.4307 32.6609C24.2217 32.1645 24.0454 31.6682 23.9083 31.1784C23.8756 31.0674 23.8429 30.9564 23.8168 30.8453C23.7581 30.6233 23.7058 30.3947 23.6601 30.1662C23.5752 29.696 23.5164 29.2388 23.4903 28.7751C23.4772 28.5858 23.4707 28.3898 23.4707 28.2004C23.4707 27.1294 23.6405 26.2478 23.9866 25.549C24.2936 24.9155 24.7376 24.4323 25.3254 24.0992C26.1221 23.6486 27.0364 23.5507 28.0552 23.8249C28.6168 23.9686 29.2046 24.2168 29.8251 24.576C30.4455 24.9351 31.0332 25.3596 31.5883 25.856C32.6136 26.7702 33.5278 27.9196 34.3245 29.2976C35.5588 31.4331 36.1793 33.5098 36.1793 35.5343Z"
        fill="#F2F6F6"
        stroke="#044752"
        strokeWidth="0.979592"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M61.9495 26.62V46.0682C61.9495 47.4004 61.5381 48.3082 60.7087 48.7784L60.4409 48.909L54.5634 51.8477L50.3577 53.9571L47.6475 55.309C48.3724 54.8975 48.7773 54.1596 48.8687 53.0951C48.8818 52.9384 48.8883 52.7686 48.8883 52.5988V33.1506C48.8883 32.6608 48.836 32.1645 48.7185 31.6616C48.5291 30.7931 48.1765 29.9049 47.6475 28.9971C46.8181 27.5669 45.8189 26.5155 44.6499 25.8428L36.5454 21.1669L23.8173 13.8135L19.5854 11.371L15.3471 8.92203L14.9944 8.71958C13.9495 8.11877 13.0418 7.97509 12.2647 8.28856L15.3471 6.74734L18.9716 4.93835L25.0646 1.88856C25.894 1.41835 26.8932 1.51631 28.0556 2.18897L57.7112 19.3122C58.8801 19.9849 59.8793 21.0363 60.7087 22.4665C61.5381 23.8967 61.9495 25.2812 61.9495 26.62Z"
        fill="#F2F6F6"
        stroke="#044752"
        strokeWidth="0.979592"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2327 35.4756L17.6914 34.5874L15.5493 33.3466L14.9943 33.0266L18.0767 31.4854C18.1681 31.6421 18.2465 31.7988 18.3248 31.9556C18.9322 33.1637 19.2327 34.3327 19.2327 35.4756Z"
        fill="#F2F6F6"
        stroke="#044752"
        strokeWidth="0.979592"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0767 31.4855L14.9943 33.0267V28.168C15.1118 28.2398 15.2294 28.3116 15.3469 28.39C16.3657 29.0627 17.2408 30.0357 17.9853 31.3223C18.018 31.3745 18.0506 31.4267 18.0767 31.4855Z"
        fill="#F2F6F6"
        stroke="#044752"
        strokeWidth="0.979592"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2327 16.0274C19.2327 16.1319 19.2326 16.2299 19.2195 16.3278L15.0008 18.4437H14.9943V13.585L15.3469 13.7874L19.2327 16.0274Z"
        fill="#F2F6F6"
        stroke="#044752"
        strokeWidth="0.979592"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2198 16.3345C19.2133 16.4781 19.2003 16.6153 19.1807 16.7524C19.1677 16.8569 19.1546 16.9549 19.1285 17.0528C19.0501 17.4381 18.9194 17.7647 18.73 18.0455C18.6713 18.1369 18.6126 18.2153 18.5407 18.2937C18.5407 18.3002 18.5342 18.3002 18.5277 18.3067C18.4624 18.3786 18.3905 18.4504 18.3122 18.5157C18.3122 18.5157 18.2794 18.5484 18.2598 18.5614C18.2402 18.5745 18.2273 18.5875 18.2077 18.6006C18.1424 18.6528 18.0705 18.6986 17.9921 18.7443C17.2476 19.1688 16.3726 19.1296 15.3538 18.6332C15.2362 18.5745 15.1252 18.5092 15.0077 18.4439L19.2264 16.3345H19.2198Z"
        fill="#F2F6F6"
        stroke="#044752"
        strokeWidth="0.979592"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const EmptyTransactionIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
    >
      <path
        d="M65.6908 35.1871L65.1746 34.9291C63.0779 33.9871 60.5875 34.3484 57.7037 36.0129C57.1359 36.3355 56.5875 36.6968 56.0521 37.0904C53.6327 38.8581 51.523 41.2968 49.723 44.4065C47.7488 47.8194 46.6585 51.142 46.4585 54.3807C46.4327 54.7484 46.4198 55.1097 46.4198 55.4774C46.4198 59.0581 47.523 61.4774 49.723 62.7355C51.923 63.9871 54.5811 63.7162 57.7037 61.9097C60.8263 60.1097 63.4908 57.3097 65.6908 53.5162C67.8908 49.7162 68.994 46.0258 68.994 42.4452C68.994 38.8645 67.8908 36.4452 65.6908 35.1871ZM62.7295 44.3807L57.2521 53.6904C56.9166 54.271 56.523 54.6968 56.0714 54.9549C55.6198 55.2194 55.2263 55.2516 54.8843 55.0581L52.6843 53.8065C52.3424 53.6129 52.1746 53.2581 52.1746 52.7355C52.1746 52.2129 52.3424 51.671 52.6843 51.0839C53.0198 50.5033 53.4263 50.071 53.8972 49.8C54.3682 49.5291 54.7746 49.4904 55.1101 49.6839L56.0714 50.2323L60.3037 42.9936C60.6392 42.4129 61.0456 41.9807 61.5166 41.7097C61.9875 41.4387 62.3875 41.4 62.7295 41.5936C63.065 41.7871 63.2327 42.1549 63.2327 42.6903C63.2327 43.2258 63.065 43.7936 62.7295 44.3807Z"
        fill="#F2F6F6"
        stroke="#044752"
        strokeWidth="0.774194"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M63.2326 42.6904C63.2326 43.2323 63.065 43.7936 62.7295 44.3807L57.2521 53.6904C56.9166 54.271 56.523 54.6968 56.0714 54.9549C55.6197 55.2194 55.2262 55.2517 54.8843 55.0581L52.6843 53.8065C52.3423 53.613 52.1746 53.2581 52.1746 52.7356C52.1746 52.213 52.3423 51.671 52.6843 51.0839C53.0197 50.5033 53.4262 50.071 53.8972 49.8001C54.3681 49.5291 54.7746 49.4905 55.1101 49.684L56.0714 50.2323L60.3036 42.9936C60.6391 42.413 61.0455 41.9807 61.5165 41.7098C61.9875 41.4388 62.3875 41.4001 62.7295 41.5936C63.065 41.7872 63.2326 42.1549 63.2326 42.6904Z"
        fill="#F2F6F6"
        stroke="#044752"
        strokeWidth="0.774194"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.6456 42.4001L39.3037 46.6388L33.5488 49.9614L32.8779 50.3485C32.7166 50.4388 32.5617 50.5162 32.4134 50.5614C31.9746 50.7291 31.594 50.7098 31.2714 50.5292C30.9811 50.3615 30.7876 50.0904 30.6908 49.7033C30.6456 49.5098 30.6198 49.2969 30.6198 49.0582C30.6198 48.3227 30.8392 47.5872 31.2714 46.8388C31.7037 46.0904 32.2392 45.5357 32.8779 45.1679L34.1037 44.4646L41.8392 39.9937L44.5811 41.3678L46.6456 42.4001Z"
        fill="#F2F6F6"
        stroke="#044752"
        strokeWidth="0.774194"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M63.1488 8.49026C62.265 7.98703 61.2069 8.09026 59.9617 8.80639L51.5746 13.6515L44.6585 17.6451L28.3617 27.0515C27.123 27.7677 26.0585 28.8903 25.1746 30.4128C25.1424 30.4709 25.1101 30.529 25.0779 30.587C24.2585 32.0515 23.8521 33.4645 23.8521 34.8386V78.5419L10.9488 72.0903V28.387C10.9488 26.9612 11.3875 25.4903 12.2714 23.9612C13.1553 22.4386 14.2198 21.3161 15.4585 20.5999L47.0585 2.35478C48.1875 1.70316 49.1617 1.56123 49.994 1.91607L50.265 2.05157L63.1488 8.49026Z"
        fill="#F2F6F6"
        stroke="#044752"
        strokeWidth="0.774194"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.7037 23.0644C57.7037 23.7934 57.4908 24.5353 57.0585 25.2837C56.6263 26.0257 56.0908 26.587 55.4521 26.9547L52.5682 28.6192L37.0456 37.5805H37.0392V37.5934H37.0263L32.8779 39.987C32.3747 40.2773 31.9359 40.3805 31.5617 40.2837C31.4585 40.2579 31.3617 40.2257 31.2714 40.1677C30.8392 39.9225 30.6198 39.4321 30.6198 38.6966C30.6198 38.3547 30.665 38.0128 30.7617 37.6708C30.8714 37.2773 31.0392 36.8773 31.2714 36.4773C31.7037 35.7353 32.2392 35.1741 32.8779 34.8064L55.4521 21.774C56.0908 21.4063 56.6263 21.3418 57.0585 21.5934C57.4908 21.8386 57.7037 22.3289 57.7037 23.0644Z"
        fill="#F2F6F6"
        stroke="#044752"
        strokeWidth="0.774194"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.0779 55.3937L39.2456 57.0259L38.8134 57.2776L32.8779 60.7033C32.2392 61.0775 31.7037 61.1357 31.2714 60.8905C30.8392 60.6453 30.6198 60.155 30.6198 59.4195C30.6198 58.684 30.8392 57.9486 31.2714 57.2002C31.7037 56.4518 32.2392 55.8969 32.8779 55.5292L34.8263 54.4066L37.2714 52.9937L42.0779 55.3937Z"
        fill="#F2F6F6"
        stroke="#044752"
        strokeWidth="0.774194"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M63.1488 8.49021C62.265 7.98698 61.2069 8.09021 59.9617 8.80634L51.5746 13.6515L44.6585 17.645L28.3617 27.0515C27.123 27.7676 26.0585 28.8902 25.1746 30.4128C25.1424 30.4709 25.1101 30.5289 25.0779 30.587C24.2585 32.0515 23.8521 33.4644 23.8521 34.8386V78.5418L24.6392 77.5031L26.4456 74.3934C26.6714 73.9999 26.9359 73.7225 27.2327 73.5483C27.5359 73.3741 27.8005 73.3483 28.0263 73.4773L29.8327 74.5096C30.0585 74.6386 30.323 74.6128 30.6198 74.4386C30.923 74.2644 31.1876 73.987 31.4134 73.5934L33.2198 70.4838C33.4456 70.0902 33.7037 69.8128 34.0069 69.6386C34.3101 69.4644 34.5682 69.4386 34.794 69.5676L36.6005 70.5999C36.8263 70.7289 37.0908 70.7031 37.394 70.5289C37.6908 70.3547 37.9553 70.0773 38.1811 69.6838L39.9876 66.5741C40.2134 66.1805 40.4779 65.9031 40.7811 65.7289C41.0779 65.5547 41.3424 65.5289 41.5682 65.6579L41.7359 65.7547C42.0392 65.9289 42.3553 65.7741 42.6972 65.3031C43.0327 64.8257 43.1101 64.3999 42.923 64.0386C42.6198 63.1289 42.3746 62.1934 42.1876 61.2257C42.0456 60.4709 41.9553 59.6838 41.923 58.8387C41.9101 58.587 41.9037 58.3354 41.9037 58.0838C41.9037 57.6063 41.9166 57.1612 41.9359 56.7419V56.716C41.9553 56.2967 42.0005 55.8644 42.0779 55.3934L39.2456 57.0257L38.8134 57.2773L32.8779 60.7031C32.2392 61.0773 31.7037 61.1354 31.2714 60.8902C30.8392 60.645 30.6198 60.1547 30.6198 59.4192C30.6198 58.6838 30.8392 57.9483 31.2714 57.1999C31.7037 56.4515 32.2392 55.8967 32.8779 55.5289L34.8263 54.4063L37.2714 52.9934L43.4327 49.4321C43.6392 48.8257 43.8585 48.2257 44.0972 47.6321C44.3359 47.0192 44.594 46.4192 44.8714 45.8192C45.4134 44.6386 46.0069 43.5031 46.6456 42.3999L39.3037 46.6386L33.5488 49.9612L32.8779 50.3483C32.7166 50.4386 32.5617 50.516 32.4134 50.5612C31.9746 50.7289 31.594 50.7096 31.2714 50.5289C30.9811 50.3612 30.7876 50.0902 30.6908 49.7031C30.6456 49.5096 30.6198 49.2967 30.6198 49.0579C30.6198 48.3225 30.8392 47.587 31.2714 46.8386C31.7037 46.0902 32.2392 45.5354 32.8779 45.1676L34.1037 44.4644L41.8392 39.9934L47.1875 36.9096L50.0005 35.2838L55.4521 32.1354C55.4521 32.1354 55.4908 32.116 55.5101 32.1031C56.1553 31.7289 56.8005 31.3805 57.4392 31.058C57.8714 30.8386 58.2972 30.6386 58.723 30.4386C59.8134 29.9418 60.8843 29.5354 61.9359 29.2321C62.5746 29.0773 63.1617 28.6192 63.6843 27.8644C64.2134 27.1096 64.4779 26.3612 64.4779 25.6257V11.3805C64.4779 9.96118 64.0327 8.99343 63.1488 8.49021ZM57.0585 25.2838C56.6263 26.0257 56.0908 26.587 55.4521 26.9547L52.5682 28.6192L37.0456 37.5805H37.0392V37.5934H37.0263L32.8779 39.987C32.3746 40.2773 31.9359 40.3805 31.5617 40.2838C31.4585 40.2579 31.3617 40.2257 31.2714 40.1676C30.8392 39.9225 30.6198 39.4321 30.6198 38.6967C30.6198 38.3547 30.665 38.0128 30.7617 37.6709C30.8714 37.2773 31.0392 36.8773 31.2714 36.4773C31.7037 35.7354 32.2392 35.1741 32.8779 34.8064L55.4521 21.7741C56.0908 21.4063 56.6263 21.3418 57.0585 21.5934C57.4908 21.8386 57.7037 22.3289 57.7037 23.0644C57.7037 23.7999 57.4908 24.5354 57.0585 25.2838Z"
        fill="#F2F6F6"
        stroke="#044752"
        strokeWidth="0.774194"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M65.1747 34.9291C63.0779 33.9871 60.5875 34.3485 57.7037 36.013C57.1359 36.3356 56.5875 36.6969 56.0521 37.0904C53.6327 38.8582 51.523 41.2968 49.723 44.4065C47.7488 47.8194 46.6585 51.142 46.4585 54.3808C46.4327 54.7485 46.4198 55.1098 46.4198 55.4775C46.4198 59.0582 47.523 61.4775 49.723 62.7356L41.9231 58.8388C41.9102 58.5872 41.9037 58.3356 41.9037 58.084C41.9037 57.6066 41.9166 57.1614 41.9359 56.742V56.7162C41.9553 56.2969 42.0005 55.8646 42.0779 55.3937L37.2715 52.9936L43.4327 49.4324C43.6392 48.8259 43.8586 48.2258 44.0973 47.6323C44.336 47.0194 44.5941 46.4194 44.8715 45.8194C45.4134 44.6388 46.007 43.5033 46.6457 42.4001L44.5812 41.3678L41.8392 39.9937L47.1875 36.9097L50.0005 35.284L55.4521 32.1356C55.4521 32.1356 55.4908 32.1162 55.5102 32.1033C56.1554 31.7291 56.8005 31.3807 57.4392 31.0581L65.1747 34.9291Z"
        fill="#F2F6F6"
        stroke="#044752"
        strokeWidth="0.774194"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const ExportIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19 18H5V21H19V18Z"
        fill="white"
        stroke="#B4C8CB"
        strokeWidth="1.5"
      />
      <path
        d="M12 2V15"
        stroke="#B4C8CB"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 10H18C18.2652 10 18.5196 10.1054 18.7071 10.2929C18.8946 10.4804 19 10.7348 19 11V20C19 20.2652 18.8946 20.5196 18.7071 20.7071C18.5196 20.8946 18.2652 21 18 21H6C5.73478 21 5.48043 20.8946 5.29289 20.7071C5.10536 20.5196 5 20.2652 5 20V11C5 10.7348 5.10536 10.4804 5.29289 10.2929C5.48043 10.1054 5.73478 10 6 10H8M16 6L12 2L8 6"
        stroke="#B4C8CB"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const ArrowRight = ({ color = '#F2F6F6' }: { color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="7"
      viewBox="0 0 14 7"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1467 0.146227C10.2404 0.0525929 10.3675 0 10.5 0C10.6325 0 10.7596 0.0525929 10.8533 0.146227L13.3533 2.64623C13.447 2.73998 13.4996 2.86706 13.4996 2.99956C13.4996 3.13206 13.447 3.25914 13.3533 3.35289L10.8533 5.85289C10.8076 5.90202 10.7524 5.94142 10.691 5.96875C10.6297 5.99608 10.5635 6.01077 10.4963 6.01195C10.4292 6.01314 10.3625 6.00079 10.3003 5.97564C10.238 5.95049 10.1815 5.91306 10.134 5.86559C10.0865 5.81811 10.0491 5.76155 10.0239 5.69929C9.99877 5.63703 9.98642 5.57035 9.98761 5.50321C9.98879 5.43608 10.0035 5.36987 10.0308 5.30853C10.0581 5.2472 10.0975 5.192 10.1467 5.14623L11.7933 3.49956H1C0.867392 3.49956 0.740215 3.44688 0.646447 3.35311C0.552678 3.25935 0.5 3.13217 0.5 2.99956C0.5 2.86695 0.552678 2.73978 0.646447 2.64601C0.740215 2.55224 0.867392 2.49956 1 2.49956H11.7933L10.1467 0.852893C10.053 0.759143 10.0004 0.63206 10.0004 0.49956C10.0004 0.36706 10.053 0.239977 10.1467 0.146227Z"
        fill={color}
      />
    </svg>
  )
}

export const PayoutDetailsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11.94 2.20983L9.52995 7.81983H7.11995C6.71995 7.81983 6.32995 7.84983 5.94995 7.92983L6.94995 5.52983L6.98995 5.43983L7.04995 5.27983C7.07995 5.20983 7.09995 5.14983 7.12995 5.09983C8.28995 2.40983 9.58995 1.56983 11.94 2.20983Z"
        fill="white"
      />
      <path
        d="M18.73 8.09002L18.71 8.08002C18.11 7.91002 17.5 7.82002 16.88 7.82002H10.62L12.87 2.59002L12.9 2.52002C13.04 2.57002 13.19 2.64002 13.34 2.69002L15.55 3.62002C16.78 4.13002 17.64 4.66002 18.17 5.30002C18.26 5.42002 18.34 5.53002 18.42 5.66002C18.51 5.80002 18.58 5.94002 18.62 6.09002C18.66 6.18002 18.69 6.26002 18.71 6.35002C18.86 6.86002 18.87 7.44002 18.73 8.09002Z"
        fill="white"
      />
      <path
        d="M18.29 9.51982C17.84 9.38982 17.37 9.31982 16.88 9.31982H7.11999C6.43999 9.31982 5.79999 9.44982 5.19999 9.70982C3.45999 10.4598 2.23999 12.1898 2.23999 14.1998V16.1498C2.23999 16.3898 2.25999 16.6198 2.28999 16.8598C2.50999 20.0398 4.20999 21.7398 7.38999 21.9498C7.61999 21.9798 7.84999 21.9998 8.09999 21.9998H15.9C19.6 21.9998 21.55 20.2398 21.74 16.7398C21.75 16.5498 21.76 16.3498 21.76 16.1498V14.1998C21.76 11.9898 20.29 10.1298 18.29 9.51982ZM14.5 16.7498H9.49999C9.08999 16.7498 8.74999 16.4098 8.74999 15.9998C8.74999 15.5898 9.08999 15.2498 9.49999 15.2498H14.5C14.91 15.2498 15.25 15.5898 15.25 15.9998C15.25 16.4098 14.91 16.7498 14.5 16.7498Z"
        fill="white"
      />
    </svg>
  )
}

export const SettlementActiveIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 12C2.25 6.615 6.615 2.25 12 2.25C17.385 2.25 21.75 6.615 21.75 12C21.75 17.385 17.385 21.75 12 21.75C6.615 21.75 2.25 17.385 2.25 12ZM15.61 10.186C15.67 10.1061 15.7134 10.0149 15.7377 9.91795C15.762 9.82098 15.7666 9.72014 15.7514 9.62135C15.7361 9.52257 15.7012 9.42782 15.6489 9.3427C15.5965 9.25757 15.5276 9.18378 15.4463 9.12565C15.3649 9.06753 15.2728 9.02624 15.1753 9.00423C15.0778 8.98221 14.9769 8.97991 14.8785 8.99746C14.7801 9.01501 14.6862 9.05205 14.6023 9.10641C14.5184 9.16077 14.4462 9.23135 14.39 9.314L11.154 13.844L9.53 12.22C9.38783 12.0875 9.19978 12.0154 9.00548 12.0188C8.81118 12.0223 8.62579 12.101 8.48838 12.2384C8.35097 12.3758 8.27225 12.5612 8.26882 12.7555C8.2654 12.9498 8.33752 13.1378 8.47 13.28L10.72 15.53C10.797 15.6069 10.8898 15.6662 10.992 15.7036C11.0942 15.7411 11.2033 15.7559 11.3118 15.7469C11.4202 15.738 11.5255 15.7055 11.6201 15.6519C11.7148 15.5982 11.7967 15.5245 11.86 15.436L15.61 10.186Z"
        fill="#044752"
      />
    </svg>
  )
}

export const SettlementInactiveIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 12C2.25 6.615 6.615 2.25 12 2.25C17.385 2.25 21.75 6.615 21.75 12C21.75 17.385 17.385 21.75 12 21.75C6.615 21.75 2.25 17.385 2.25 12ZM15.61 10.186C15.67 10.1061 15.7134 10.0149 15.7377 9.91795C15.762 9.82098 15.7666 9.72014 15.7514 9.62135C15.7361 9.52257 15.7012 9.42782 15.6489 9.3427C15.5965 9.25757 15.5276 9.18378 15.4463 9.12565C15.3649 9.06753 15.2728 9.02624 15.1753 9.00423C15.0778 8.98221 14.9769 8.97991 14.8785 8.99746C14.7801 9.01501 14.6862 9.05205 14.6023 9.10641C14.5184 9.16077 14.4462 9.23135 14.39 9.314L11.154 13.844L9.53 12.22C9.38783 12.0875 9.19978 12.0154 9.00548 12.0188C8.81118 12.0223 8.62579 12.101 8.48838 12.2384C8.35097 12.3758 8.27225 12.5612 8.26882 12.7555C8.2654 12.9498 8.33752 13.1378 8.47 13.28L10.72 15.53C10.797 15.6069 10.8898 15.6662 10.992 15.7036C11.0942 15.7411 11.2033 15.7559 11.3118 15.7469C11.4202 15.738 11.5255 15.7055 11.6201 15.6519C11.7148 15.5982 11.7967 15.5245 11.86 15.436L15.61 10.186Z"
        fill="#B4C8CB"
      />
    </svg>
  )
}

export const SuccessIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="82"
      height="82"
      viewBox="0 0 82 82"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.8458 6.82917C28.604 4.80096 30.778 3.17482 33.2203 2.06117C35.6625 0.947528 38.3158 0.372457 41 0.375008C46.6542 0.375008 51.7208 2.87501 55.1542 6.82917C57.8321 6.63797 60.5198 7.02536 63.0347 7.96503C65.5496 8.9047 67.8328 10.3746 69.7292 12.275C71.6288 14.1711 73.0982 16.4536 74.0379 18.9677C74.9775 21.4818 75.3653 24.1686 75.175 26.8458C77.2025 28.6044 78.8278 30.7786 79.9407 33.2208C81.0536 35.6631 81.6281 38.3162 81.625 41C81.6276 43.6842 81.0525 46.3375 79.9388 48.7797C78.8252 51.222 77.1991 53.396 75.1708 55.1542C75.3612 57.8314 74.9733 60.5182 74.0337 63.0323C73.0941 65.5464 71.6246 67.8289 69.725 69.725C67.8289 71.6246 65.5464 73.0941 63.0323 74.0337C60.5182 74.9733 57.8314 75.3612 55.1542 75.1708C53.396 77.1991 51.222 78.8252 48.7797 79.9388C46.3375 81.0525 43.6842 81.6276 41 81.625C38.3158 81.6276 35.6625 81.0525 33.2203 79.9388C30.778 78.8252 28.604 77.1991 26.8458 75.1708C24.1682 75.3626 21.4807 74.9759 18.9659 74.0369C16.451 73.098 14.1676 71.6288 12.2708 69.7292C10.3707 67.8326 8.90091 65.5494 7.96125 63.0345C7.0216 60.5197 6.63408 57.8321 6.82501 55.1542C4.79755 53.3956 3.1722 51.2214 2.05928 48.7792C0.946365 46.337 0.371943 43.6839 0.375012 41C0.375012 35.3458 2.87501 30.2792 6.82918 26.8458C6.63858 24.1686 7.02627 21.4817 7.96593 18.9676C8.90558 16.4535 10.3752 14.1709 12.275 12.275C14.1709 10.3752 16.4535 8.90558 18.9676 7.96592C21.4817 7.02627 24.1686 6.63858 26.8458 6.82917ZM56.0417 33.4417C56.2917 33.1086 56.4726 32.7288 56.5737 32.3248C56.6748 31.9208 56.6942 31.5006 56.6306 31.089C56.5671 30.6774 56.4219 30.2826 56.2036 29.9279C55.9853 29.5732 55.6982 29.2657 55.3594 29.0236C55.0206 28.7814 54.6367 28.6094 54.2305 28.5176C53.8242 28.4259 53.4037 28.4163 52.9937 28.4894C52.5836 28.5625 52.1924 28.7169 51.8428 28.9434C51.4933 29.1699 51.1926 29.464 50.9583 29.8083L37.475 48.6833L30.7083 41.9167C30.1159 41.3647 29.3324 41.0642 28.5228 41.0784C27.7132 41.0927 26.9408 41.4207 26.3683 41.9933C25.7957 42.5658 25.4677 43.3382 25.4534 44.1478C25.4392 44.9574 25.7397 45.7409 26.2917 46.3333L35.6667 55.7083C35.9875 56.0289 36.3742 56.2758 36.8 56.4319C37.2257 56.5879 37.6804 56.6495 38.1324 56.6122C38.5843 56.575 39.0227 56.4398 39.4172 56.216C39.8117 55.9923 40.1527 55.6854 40.4167 55.3167L56.0417 33.4417Z"
        fill="#4F8008"
      />
    </svg>
  )
}

export const AddWehookIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.25C6.615 2.25 2.25 6.615 2.25 12C2.25 17.385 6.615 21.75 12 21.75C17.385 21.75 21.75 17.385 21.75 12C21.75 6.615 17.385 2.25 12 2.25ZM12.75 9C12.75 8.80109 12.671 8.61032 12.5303 8.46967C12.3897 8.32902 12.1989 8.25 12 8.25C11.8011 8.25 11.6103 8.32902 11.4697 8.46967C11.329 8.61032 11.25 8.80109 11.25 9V11.25H9C8.80109 11.25 8.61032 11.329 8.46967 11.4697C8.32902 11.6103 8.25 11.8011 8.25 12C8.25 12.1989 8.32902 12.3897 8.46967 12.5303C8.61032 12.671 8.80109 12.75 9 12.75H11.25V15C11.25 15.1989 11.329 15.3897 11.4697 15.5303C11.6103 15.671 11.8011 15.75 12 15.75C12.1989 15.75 12.3897 15.671 12.5303 15.5303C12.671 15.3897 12.75 15.1989 12.75 15V12.75H15C15.1989 12.75 15.3897 12.671 15.5303 12.5303C15.671 12.3897 15.75 12.1989 15.75 12C15.75 11.8011 15.671 11.6103 15.5303 11.4697C15.3897 11.329 15.1989 11.25 15 11.25H12.75V9Z"
        fill="white"
      />
    </svg>
  )
}

export const CopyLinkIcon = ({ color = '#CB9A2B' }: { color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
    >
      <path
        d="M1 4V18C1 18.2652 1.10536 18.5196 1.29289 18.7071C1.48043 18.8946 1.73478 19 2 19H11M5 14V2C5 1.73478 5.10536 1.48043 5.29289 1.29289C5.48043 1.10536 5.73478 1 6 1H14C14.2652 1 14.5196 1.10536 14.7071 1.29289C14.8946 1.48043 15 1.73478 15 2V14C15 14.2652 14.8946 14.5196 14.7071 14.7071C14.5196 14.8946 14.2652 15 14 15H6C5.73478 15 5.48043 14.8946 5.29289 14.7071C5.10536 14.5196 5 14.2652 5 14Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const LogoutInfoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
    >
      <path
        d="M33.2309 73.297C33.7842 74.2437 34.0576 75.177 34.0576 76.1104C34.0576 77.0437 33.7842 77.657 33.2309 77.9704C32.6842 78.2837 32.0042 78.2037 31.1975 77.737L14.0509 67.837C12.4776 66.9304 11.1309 65.5105 10.0109 63.5772C8.89091 61.6505 8.33089 59.7771 8.33089 57.9771V12.0571C8.33089 10.2571 8.89091 9.03709 10.0109 8.39709L10.3642 8.22376C11.4109 7.79042 12.6376 7.98376 14.0509 8.80376L21.6642 13.1971L27.3843 16.5038L31.1975 18.7038C32.0042 19.1704 32.6842 19.8771 33.2309 20.8238C33.7842 21.7638 34.0576 22.7038 34.0576 23.6304C34.0576 24.5571 33.7842 25.1838 33.2309 25.4971C32.6842 25.8038 32.0042 25.7304 31.1975 25.2638L27.3843 23.0638L21.6642 19.7571L14.0509 15.3638V61.2771L31.1975 71.177C32.0042 71.6437 32.6842 72.3504 33.2309 73.297Z"
        fill="#FEF7F7"
        stroke="#F35656"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.4709 42.9766C26.7442 42.8633 27.0509 42.8367 27.3842 42.91V42.5166L26.4709 42.9766Z"
        fill="#FEF7F7"
        stroke="#F35656"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M58.6376 64.0639C58.6376 64.2639 58.6243 64.4439 58.5909 64.6172C58.4909 65.1972 58.2175 65.6105 57.7775 65.8638L47.5576 71.6904C47.0776 71.9637 46.5243 71.9504 45.8843 71.6437H45.8775C45.7642 71.597 45.6575 71.5371 45.5442 71.4637C45.5375 71.4637 45.5309 71.4637 45.5242 71.4571C44.7375 70.9704 44.0575 70.2371 43.4842 69.2571C42.9642 68.2971 42.7109 67.3704 42.7375 66.4838C42.7575 65.5972 43.0376 65.0039 43.5576 64.7038L44.2176 64.3305L48.8443 61.6905L28.3375 49.8505C27.9975 49.6505 27.6776 49.4105 27.3843 49.1239C26.9776 48.7439 26.6176 48.2772 26.3043 47.7305C25.7576 46.7838 25.4775 45.8505 25.4775 44.9172C25.4775 43.9838 25.7576 43.3705 26.3043 43.0572L26.4709 42.9772C26.7443 42.8639 27.0509 42.8372 27.3843 42.9105C27.6776 42.9638 27.9975 43.0905 28.3375 43.2905L48.8443 55.1305L43.4842 45.8839C43.0775 45.1839 42.8309 44.4905 42.7442 43.8038C42.7175 43.6038 42.7042 43.4105 42.7042 43.2172C42.7042 42.3439 42.9642 41.7305 43.4842 41.3772L43.8043 41.2172C44.2709 41.0572 44.8375 41.1505 45.4909 41.5038C46.2975 41.9438 46.9909 42.6572 47.5576 43.6439L50.1175 48.0638L56.2909 58.7038L57.7775 61.2705C58.3509 62.2572 58.6376 63.1839 58.6376 64.0639Z"
        fill="#FEF7F7"
        stroke="#F35656"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.4776 44.9165C25.4776 45.8499 25.7576 46.7833 26.3043 47.7299C26.6176 48.2766 26.9776 48.7433 27.3843 49.1233V54.6099L14.0509 61.2766V15.3633L21.6643 19.7566L27.3843 23.0632V42.5166L26.4709 42.9766L26.3043 43.0565C25.7576 43.3699 25.4776 43.9899 25.4776 44.9165Z"
        fill="#FEF7F7"
        stroke="#F35656"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.3909 16.9631C47.3909 17.8965 47.1176 18.5165 46.5643 18.8298L46.3976 18.9098L33.2309 25.4965C33.7843 25.1831 34.0576 24.5631 34.0576 23.6298C34.0576 22.6965 33.7843 21.7631 33.2309 20.8231C32.6843 19.8765 32.0043 19.1698 31.1976 18.7031L27.3843 16.5031L21.6643 13.1965L14.0509 8.80314C12.6376 7.98314 11.4109 7.7898 10.3643 8.22314L23.3443 1.72978C24.4643 1.08978 25.8109 1.22311 27.3843 2.13644L44.5309 12.0365C45.3376 12.5031 46.0176 13.2098 46.5643 14.1565C47.1176 15.0965 47.3909 16.0365 47.3909 16.9631Z"
        fill="#FEF7F7"
        stroke="#F35656"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.8376 55.1297L28.3309 43.2898C27.9909 43.0898 27.6709 42.9631 27.3776 42.9098V42.5164L39.6309 36.3898C40.1776 36.0764 40.8576 36.1564 41.6643 36.6231L46.9176 39.6564L43.7976 41.2164L43.4776 41.3764C42.9576 41.7298 42.6976 42.3431 42.6976 43.2164C42.6976 43.4098 42.7109 43.6031 42.7376 43.8031C42.8243 44.4898 43.0709 45.1831 43.4776 45.8831L48.8376 55.1297Z"
        fill="#FEF7F7"
        stroke="#F35656"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M71.9709 57.3968C71.9709 58.2701 71.6842 58.8701 71.1109 59.1968L60.8909 65.0234L47.5575 71.69L57.7775 65.8634C58.2175 65.6101 58.4909 65.1968 58.5909 64.6168C58.6242 64.4434 58.6375 64.2634 58.6375 64.0634C58.6375 63.1834 58.3509 62.2568 57.7775 61.2701L56.2909 58.7034L50.1175 48.0634L47.5575 43.6434C46.9909 42.6568 46.2975 41.9434 45.4909 41.5034C44.8375 41.1501 44.2709 41.0568 43.8042 41.2168L46.9242 39.6568L56.8175 34.7101C57.3442 34.3568 58.0109 34.3968 58.8242 34.8368C59.6309 35.2768 60.3242 35.9901 60.8909 36.9768L71.1109 54.6034C71.6842 55.5901 71.9709 56.5168 71.9709 57.3968Z"
        fill="#FEF7F7"
        stroke="#F35656"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.0576 76.1102C34.0576 75.1769 33.7843 74.2436 33.2309 73.2969C32.6843 72.3502 32.0043 71.6436 31.1976 71.1769L14.0509 61.277L27.3843 54.6104L44.2176 64.3304L43.5576 64.7037C43.0376 65.0037 42.7576 65.597 42.7376 66.4837C42.7109 67.3702 42.9643 68.2969 43.4843 69.2569C44.0576 70.2369 44.7376 70.9702 45.5243 71.4569C45.5309 71.4636 45.5376 71.4636 45.5443 71.4636C45.6576 71.5369 45.7643 71.5969 45.8776 71.6436L33.2309 77.9702C33.7843 77.6569 34.0576 77.0369 34.0576 76.1102Z"
        fill="#FEF7F7"
        stroke="#F35656"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const EmailIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
    >
      <path
        d="M10.3333 0.333008H3.66668C1.66668 0.333008 0.333344 1.33301 0.333344 3.66634V8.33301C0.333344 10.6663 1.66668 11.6663 3.66668 11.6663H10.3333C12.3333 11.6663 13.6667 10.6663 13.6667 8.33301V3.66634C13.6667 1.33301 12.3333 0.333008 10.3333 0.333008ZM10.6467 4.39301L8.56001 6.05967C8.12001 6.41301 7.56001 6.58634 7.00001 6.58634C6.44001 6.58634 5.87334 6.41301 5.44001 6.05967L3.35334 4.39301C3.14001 4.21967 3.10668 3.89967 3.27334 3.68634C3.44668 3.47301 3.76001 3.43301 3.97334 3.60634L6.06001 5.27301C6.56668 5.67967 7.42668 5.67967 7.93334 5.27301L10.02 3.60634C10.2333 3.43301 10.5533 3.46634 10.72 3.68634C10.8933 3.89967 10.86 4.21967 10.6467 4.39301Z"
        fill="#CB9A2B"
      />
    </svg>
  )
}

export const CallIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.36668 9.96634L6.13334 11.1997C5.87334 11.4597 5.46001 11.4597 5.19334 11.2063C5.12001 11.133 5.04668 11.0663 4.97334 10.993C4.28668 10.2997 3.66668 9.57301 3.11334 8.81301C2.56668 8.05301 2.12668 7.29301 1.80668 6.53967C1.49334 5.77968 1.33334 5.05301 1.33334 4.35967C1.33334 3.90634 1.41334 3.47301 1.57334 3.07301C1.73334 2.66634 1.98668 2.29301 2.34001 1.95967C2.76668 1.53967 3.23334 1.33301 3.72668 1.33301C3.91334 1.33301 4.10001 1.37301 4.26668 1.45301C4.44001 1.53301 4.59334 1.65301 4.71334 1.82634L6.26001 4.00634C6.38001 4.17301 6.46668 4.32634 6.52668 4.47301C6.58668 4.61301 6.62001 4.75301 6.62001 4.87967C6.62001 5.03967 6.57334 5.19967 6.48001 5.35301C6.39334 5.50634 6.26668 5.66634 6.10668 5.82634L5.60001 6.35301C5.52668 6.42634 5.49334 6.51301 5.49334 6.61967C5.49334 6.67301 5.50001 6.71967 5.51334 6.77301C5.53334 6.82634 5.55334 6.86634 5.56668 6.90634C5.68668 7.12634 5.89334 7.41301 6.18668 7.75968C6.48668 8.10634 6.80668 8.45967 7.15334 8.81301C7.22001 8.87967 7.29334 8.94634 7.36001 9.01301C7.62668 9.27301 7.63334 9.69967 7.36668 9.96634Z"
        fill="#CB9A2B"
      />
      <path
        d="M14.6467 12.2204C14.6467 12.407 14.6133 12.6004 14.5467 12.787C14.5267 12.8404 14.5067 12.8937 14.48 12.947C14.3667 13.187 14.22 13.4137 14.0267 13.627C13.7 13.987 13.34 14.247 12.9333 14.4137C12.9267 14.4137 12.92 14.4204 12.9133 14.4204C12.52 14.5804 12.0933 14.667 11.6333 14.667C10.9533 14.667 10.2267 14.507 9.45999 14.1804C8.69333 13.8537 7.92666 13.4137 7.16666 12.8604C6.90666 12.667 6.64666 12.4737 6.39999 12.267L8.57999 10.087C8.76666 10.227 8.93333 10.3337 9.07333 10.407C9.10666 10.4204 9.14666 10.4404 9.19333 10.4604C9.24666 10.4804 9.29999 10.487 9.35999 10.487C9.47333 10.487 9.55999 10.447 9.63333 10.3737L10.14 9.87369C10.3067 9.70702 10.4667 9.58035 10.62 9.50035C10.7733 9.40702 10.9267 9.36035 11.0933 9.36035C11.22 9.36035 11.3533 9.38702 11.5 9.44702C11.6467 9.50702 11.8 9.59369 11.9667 9.70702L14.1733 11.2737C14.3467 11.3937 14.4667 11.5337 14.54 11.7004C14.6067 11.867 14.6467 12.0337 14.6467 12.2204Z"
        fill="#CB9A2B"
      />
    </svg>
  )
}

export const InstagramIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
    >
      <path
        d="M17.061 6.14656C16.1168 6.104 15.8323 6.09504 13.44 6.09504C11.0477 6.09504 10.7643 6.104 9.82016 6.14656C7.38976 6.25744 6.25744 7.4088 6.14768 9.81904C6.104 10.7643 6.09392 11.0477 6.09392 13.44C6.09392 15.8323 6.104 16.1157 6.14656 17.061C6.25744 19.4667 7.38528 20.6226 9.81904 20.7334C10.7632 20.776 11.0477 20.7861 13.44 20.7861C15.8334 20.7861 16.1168 20.7771 17.061 20.7346C19.4914 20.6237 20.6226 19.4701 20.7334 17.0621C20.776 16.1168 20.785 15.8334 20.785 13.4411C20.785 11.0488 20.776 10.7654 20.7334 9.82128C20.6226 7.40992 19.4891 6.25744 17.061 6.14656ZM13.44 18.041C10.8987 18.041 8.83904 15.9813 8.83904 13.44C8.83904 10.8987 10.8998 8.83904 13.44 8.83904C15.9802 8.83904 18.041 10.8987 18.041 13.44C18.041 15.9813 15.9813 18.041 13.44 18.041ZM18.2235 9.7328C17.6299 9.7328 17.1483 9.2512 17.1483 8.6576C17.1483 8.064 17.6299 7.5824 18.2235 7.5824C18.8171 7.5824 19.2987 8.064 19.2987 8.6576C19.2987 9.2512 18.8171 9.7328 18.2235 9.7328ZM16.427 13.44C16.427 15.0898 15.0898 16.427 13.44 16.427C11.7902 16.427 10.453 15.0898 10.453 13.44C10.453 11.7902 11.7902 10.453 13.44 10.453C15.0898 10.453 16.427 11.7902 16.427 13.44ZM21.28 0H5.6C2.50768 0 0 2.50768 0 5.6V21.28C0 24.3723 2.50768 26.88 5.6 26.88H21.28C24.3734 26.88 26.88 24.3723 26.88 21.28V5.6C26.88 2.50768 24.3734 0 21.28 0ZM22.3462 17.1338C22.1984 20.3918 20.3851 22.1973 17.1349 22.3462C16.1784 22.3899 15.8738 22.4 13.44 22.4C11.0062 22.4 10.7027 22.3899 9.74624 22.3462C6.48928 22.1973 4.68384 20.3885 4.53376 17.1338C4.49008 16.1784 4.48 15.8738 4.48 13.44C4.48 11.0074 4.49008 10.7016 4.53376 9.74624C4.68384 6.48928 6.49152 4.68272 9.74624 4.53488C10.7027 4.49008 11.0062 4.48 13.44 4.48C15.8738 4.48 16.1784 4.49008 17.1349 4.53376C20.3918 4.68272 22.2006 6.49488 22.3462 9.74512C22.3899 10.7016 22.4 11.0074 22.4 13.44C22.4 15.8738 22.3899 16.1784 22.3462 17.1338Z"
        fill="#044752"
      />
    </svg>
  )
}

export const TwitterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M5.04094 0.560547C2.5667 0.560547 0.560944 2.56631 0.560944 5.04055V22.9605C0.560944 25.4348 2.5667 27.4405 5.04094 27.4405H22.9609C25.4352 27.4405 27.4409 25.4348 27.4409 22.9605V5.04055C27.4409 2.56631 25.4352 0.560547 22.9609 0.560547H5.04094ZM6.37594 6.32055H11.4559L15.0634 11.4468L19.4409 6.32055H21.0409L15.7859 12.473L22.2659 21.6805H17.1872L13.0009 15.733L7.92094 21.6805H6.32094L12.2784 14.7068L6.37594 6.32055ZM8.82594 7.60055L17.8547 20.4005H19.8159L10.7872 7.60055H8.82594Z"
        fill="#044752"
      />
    </svg>
  )
}

export const EditIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16.862 4.48725L18.549 2.79925C18.9007 2.44757 19.3777 2.25 19.875 2.25C20.3723 2.25 20.8493 2.44757 21.201 2.79925C21.5527 3.15092 21.7502 3.6279 21.7502 4.12525C21.7502 4.62259 21.5527 5.09957 21.201 5.45125L10.582 16.0702C10.0533 16.5986 9.40137 16.987 8.685 17.2002L6 18.0002L6.8 15.3152C7.01328 14.5989 7.40163 13.9469 7.93 13.4182L16.862 4.48725ZM16.862 4.48725L19.5 7.12525M18 14.0002V18.7502C18 19.347 17.7629 19.9193 17.341 20.3412C16.919 20.7632 16.3467 21.0002 15.75 21.0002H5.25C4.65326 21.0002 4.08097 20.7632 3.65901 20.3412C3.23705 19.9193 3 19.347 3 18.7502V8.25025C3 7.65351 3.23705 7.08121 3.65901 6.65926C4.08097 6.2373 4.65326 6.00025 5.25 6.00025H10"
        stroke="#B4C8CB"
        stroke-width="1.5"
        stroke-linecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const LinkedInicon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
    >
      <path
        d="M21.28 0H5.6C2.50768 0 0 2.50768 0 5.6V21.28C0 24.3723 2.50768 26.88 5.6 26.88H21.28C24.3734 26.88 26.88 24.3723 26.88 21.28V5.6C26.88 2.50768 24.3734 0 21.28 0ZM8.96 21.28H5.6V8.96H8.96V21.28ZM7.28 7.53984C6.19808 7.53984 5.32 6.65504 5.32 5.56416C5.32 4.47328 6.19808 3.58848 7.28 3.58848C8.36192 3.58848 9.24 4.47328 9.24 5.56416C9.24 6.65504 8.36304 7.53984 7.28 7.53984ZM22.4 21.28H19.04V15.0035C19.04 11.2314 14.56 11.517 14.56 15.0035V21.28H11.2V8.96H14.56V10.9368C16.1235 8.04048 22.4 7.82656 22.4 13.7099V21.28Z"
        fill="#044752"
      />
    </svg>
  )
}

export const CollapseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0.25C4.615 0.25 0.25 4.615 0.25 10C0.25 15.385 4.615 19.75 10 19.75C15.385 19.75 19.75 15.385 19.75 10C19.75 4.615 15.385 0.25 10 0.25ZM13 10.75C13.1989 10.75 13.3897 10.671 13.5303 10.5303C13.671 10.3897 13.75 10.1989 13.75 10C13.75 9.80109 13.671 9.61032 13.5303 9.46967C13.3897 9.32902 13.1989 9.25 13 9.25H7C6.80109 9.25 6.61032 9.32902 6.46967 9.46967C6.32902 9.61032 6.25 9.80109 6.25 10C6.25 10.1989 6.32902 10.3897 6.46967 10.5303C6.61032 10.671 6.80109 10.75 7 10.75H13Z"
        fill="#044752"
      />
    </svg>
  )
}

export const UnCollapseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0.25C4.615 0.25 0.25 4.615 0.25 10C0.25 15.385 4.615 19.75 10 19.75C15.385 19.75 19.75 15.385 19.75 10C19.75 4.615 15.385 0.25 10 0.25ZM10.75 7C10.75 6.80109 10.671 6.61032 10.5303 6.46967C10.3897 6.32902 10.1989 6.25 10 6.25C9.80109 6.25 9.61032 6.32902 9.46967 6.46967C9.32902 6.61032 9.25 6.80109 9.25 7V9.25H7C6.80109 9.25 6.61032 9.32902 6.46967 9.46967C6.32902 9.61032 6.25 9.80109 6.25 10C6.25 10.1989 6.32902 10.3897 6.46967 10.5303C6.61032 10.671 6.80109 10.75 7 10.75H9.25V13C9.25 13.1989 9.32902 13.3897 9.46967 13.5303C9.61032 13.671 9.80109 13.75 10 13.75C10.1989 13.75 10.3897 13.671 10.5303 13.5303C10.671 13.3897 10.75 13.1989 10.75 13V10.75H13C13.1989 10.75 13.3897 10.671 13.5303 10.5303C13.671 10.3897 13.75 10.1989 13.75 10C13.75 9.80109 13.671 9.61032 13.5303 9.46967C13.3897 9.32902 13.1989 9.25 13 9.25H10.75V7Z"
        fill="#044752"
      />
    </svg>
  )
}

export const InclinedArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.87503 0.125H13.25C13.4158 0.125 13.5748 0.190848 13.692 0.308058C13.8092 0.425268 13.875 0.58424 13.875 0.75V10.125C13.875 10.2908 13.8092 10.4497 13.692 10.5669C13.5748 10.6842 13.4158 10.75 13.25 10.75C13.0843 10.75 12.9253 10.6842 12.8081 10.5669C12.6909 10.4497 12.625 10.2908 12.625 10.125V2.25833L1.1917 13.6917C1.07322 13.8021 0.916517 13.8622 0.754599 13.8593C0.592682 13.8565 0.438194 13.7909 0.323683 13.6764C0.209173 13.5618 0.143579 13.4074 0.140722 13.2454C0.137866 13.0835 0.197968 12.9268 0.308368 12.8083L11.7417 1.375H3.87503C3.70927 1.375 3.5503 1.30915 3.43309 1.19194C3.31588 1.07473 3.25003 0.91576 3.25003 0.75C3.25003 0.58424 3.31588 0.425268 3.43309 0.308058C3.5503 0.190848 3.70927 0.125 3.87503 0.125Z"
        fill="#044752"
      />
    </svg>
  )
}

export const StatCustomerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M16.2581 4.87533L11.3081 2.01699C10.4998 1.55033 9.49977 1.55033 8.68311 2.01699L3.74144 4.87533C2.93311 5.34199 2.43311 6.20866 2.43311 7.15033V12.8503C2.43311 13.7837 2.93311 14.6503 3.74144 15.1253L8.69144 17.9837C9.49977 18.4503 10.4998 18.4503 11.3164 17.9837L16.2664 15.1253C17.0748 14.6587 17.5748 13.792 17.5748 12.8503V7.15033C17.5664 6.20866 17.0664 5.35033 16.2581 4.87533ZM9.99977 6.11699C11.0748 6.11699 11.9414 6.98366 11.9414 8.05866C11.9414 9.13366 11.0748 10.0003 9.99977 10.0003C8.92477 10.0003 8.05811 9.13366 8.05811 8.05866C8.05811 6.99199 8.92477 6.11699 9.99977 6.11699ZM12.2331 13.8837H7.76644C7.09144 13.8837 6.69977 13.1337 7.07477 12.5753C7.64144 11.7337 8.74144 11.167 9.99977 11.167C11.2581 11.167 12.3581 11.7337 12.9248 12.5753C13.2998 13.1253 12.8998 13.8837 12.2331 13.8837Z"
        fill="#F35656"
      />
    </svg>
  )
}

export const StatTransactionIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
    >
      <path
        d="M12.158 0.666992H5.17467C2.14134 0.666992 0.333008 2.47533 0.333008 5.50866V12.4837C0.333008 15.5253 2.14134 17.3337 5.17467 17.3337H12.1497C15.183 17.3337 16.9913 15.5253 16.9913 12.492V5.50866C16.9997 2.47533 15.1913 0.666992 12.158 0.666992ZM13.0497 7.30033L11.1247 9.78366C10.883 10.092 10.5413 10.292 10.1497 10.3337C9.75801 10.3837 9.37467 10.2753 9.06634 10.0337L7.54134 8.83366C7.48301 8.78366 7.41634 8.78366 7.38301 8.79199C7.34967 8.79199 7.29134 8.80866 7.24134 8.87533L5.25801 11.4503C5.13301 11.6087 4.94967 11.692 4.76634 11.692C4.63301 11.692 4.49967 11.6503 4.38301 11.5587C4.10801 11.3503 4.05801 10.9587 4.26634 10.6837L6.24967 8.10866C6.49134 7.80033 6.83301 7.60033 7.22467 7.55033C7.60801 7.50033 7.99967 7.60866 8.30801 7.85033L9.83301 9.05033C9.89134 9.10033 9.94967 9.10033 9.99134 9.09199C10.0247 9.09199 10.083 9.07533 10.133 9.00866L12.058 6.52533C12.2663 6.25033 12.6663 6.20033 12.933 6.41699C13.208 6.64199 13.258 7.03366 13.0497 7.30033Z"
        fill="#044752"
      />
    </svg>
  )
}

export const StatBalanceIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M17.8083 13.4003C17.6083 15.6253 16 17.0837 13.6667 17.0837H6.16667C3.86667 17.0837 2 15.217 2 12.917V7.08366C2 4.81699 3.36667 3.23366 5.49167 2.96699C5.70833 2.93366 5.93333 2.91699 6.16667 2.91699H13.6667C13.8833 2.91699 14.0917 2.92533 14.2917 2.95866C16.2833 3.19199 17.6333 4.58366 17.8083 6.60033C17.8333 6.84199 17.6333 7.04199 17.3917 7.04199H16.1C15.3 7.04199 14.5583 7.35033 14.025 7.90033C13.3917 8.51699 13.075 9.38366 13.15 10.2503C13.2833 11.767 14.6167 12.9587 16.2 12.9587H17.3917C17.6333 12.9587 17.8333 13.1587 17.8083 13.4003Z"
        fill="#CB9A2B"
      />
      <path
        d="M18.6668 9.14199V10.8587C18.6668 11.317 18.3002 11.692 17.8335 11.7087H16.2002C15.3002 11.7087 14.4752 11.0503 14.4002 10.1503C14.3502 9.62533 14.5502 9.13366 14.9002 8.79199C15.2085 8.47533 15.6335 8.29199 16.1002 8.29199H17.8335C18.3002 8.30866 18.6668 8.68366 18.6668 9.14199Z"
        fill="#CB9A2B"
      />
    </svg>
  )
}

export const StatRevenueIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M12.3752 3.29134V6.45801H11.1252V3.29134C11.1252 3.06634 10.9252 2.95801 10.7918 2.95801C10.7502 2.95801 10.7085 2.96634 10.6668 2.98301L4.0585 5.47467C3.61683 5.64134 3.3335 6.05801 3.3335 6.53301V7.09134C2.57516 7.65801 2.0835 8.56634 2.0835 9.59134V6.53301C2.0835 5.54134 2.69183 4.65801 3.61683 4.30801L10.2335 1.80801C10.4168 1.74134 10.6085 1.70801 10.7918 1.70801C11.6252 1.70801 12.3752 2.38301 12.3752 3.29134Z"
        fill="#022329"
      />
      <path
        d="M17.9169 12.0837V12.917C17.9169 13.142 17.7419 13.3253 17.5086 13.3337H16.2919C15.8502 13.3337 15.4502 13.0087 15.4169 12.5753C15.3919 12.317 15.4919 12.0753 15.6586 11.9087C15.8086 11.7503 16.0169 11.667 16.2419 11.667H17.5002C17.7419 11.6753 17.9169 11.8587 17.9169 12.0837Z"
        fill="#022329"
      />
      <path
        d="M16.2335 10.7913H17.0835C17.5418 10.7913 17.9168 10.4163 17.9168 9.95801V9.59134C17.9168 7.86634 16.5085 6.45801 14.7835 6.45801H5.21683C4.5085 6.45801 3.8585 6.69134 3.3335 7.09134C2.57516 7.65801 2.0835 8.56634 2.0835 9.59134V15.1997C2.0835 16.9247 3.49183 18.333 5.21683 18.333H14.7835C16.5085 18.333 17.9168 16.9247 17.9168 15.1997V15.0413C17.9168 14.583 17.5418 14.208 17.0835 14.208H16.3585C15.5585 14.208 14.7918 13.7163 14.5835 12.9413C14.4085 12.308 14.6168 11.6997 15.0335 11.2913C15.3418 10.9747 15.7668 10.7913 16.2335 10.7913ZM11.6668 10.6247H5.8335C5.49183 10.6247 5.2085 10.3413 5.2085 9.99967C5.2085 9.65801 5.49183 9.37467 5.8335 9.37467H11.6668C12.0085 9.37467 12.2918 9.65801 12.2918 9.99967C12.2918 10.3413 12.0085 10.6247 11.6668 10.6247Z"
        fill="#022329"
      />
    </svg>
  )
}

export const AdminSidebarLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="174"
      height="32"
      viewBox="0 0 174 32"
      fill="none"
    >
      <path
        d="M18.2207 32V0H32.0427C34.4194 0 36.4989 0.467348 38.2814 1.40205C40.0639 2.33674 41.4503 3.65051 42.4405 5.34335C43.4308 7.03618 43.9259 9.01462 43.9259 11.2787C43.9259 13.5635 43.4152 15.5419 42.3936 17.214C41.3825 18.8861 39.9597 20.1739 38.1251 21.0774C36.3009 21.9809 34.1692 22.4327 31.73 22.4327H23.4743V15.7029H29.9788C31.0004 15.7029 31.8707 15.5263 32.59 15.1732C33.3197 14.8097 33.8773 14.2957 34.263 13.631C34.6591 12.9663 34.8572 12.1822 34.8572 11.2787C34.8572 10.3647 34.6591 9.58583 34.263 8.94193C33.8773 8.28764 33.3197 7.78913 32.59 7.44641C31.8707 7.09331 31.0004 6.91675 29.9788 6.91675H26.9142V32H18.2207Z"
        fill="white"
      />
      <path
        d="M10.7781 20.2693C12.7861 19.4831 14.3874 18.2507 15.5804 16.5663C16.7719 14.8818 17.3677 12.9328 17.3677 10.713C17.3677 7.64655 16.3122 5.09569 14.1984 3.05892C12.0845 1.01914 9.43534 0 6.2494 0H0V6.77106H6.09214C7.20805 6.77106 8.13646 7.15664 8.87738 7.92629C9.61527 8.69593 9.98724 9.65459 9.98724 10.8038C9.98724 11.9529 9.61376 12.8844 8.86679 13.6449C8.11983 14.4085 7.19444 14.7881 6.09365 14.7881H0V21.0617H3.03473L9.62434 32H18.2537L10.7796 20.2693H10.7781Z"
        fill="#CB9A2B"
      />
      <path
        d="M168.02 27.6529C167.75 28.355 167.489 28.9761 167.237 29.5162C166.985 30.0563 166.661 30.5063 166.265 30.8664C165.886 31.2445 165.4 31.5235 164.806 31.7035C164.212 31.9016 163.429 32.0006 162.457 32.0006C161.413 32.0006 160.405 31.8385 159.432 31.5145L159.973 28.193C160.585 28.463 161.215 28.598 161.863 28.598C162.313 28.598 162.682 28.544 162.97 28.436C163.258 28.346 163.492 28.202 163.672 28.0039C163.87 27.8239 164.032 27.5989 164.158 27.3288C164.284 27.0588 164.419 26.7438 164.563 26.3837L164.86 25.6276L159.108 12.3955H163.483L166.859 21.0639H166.913L169.802 12.3955H173.961L168.02 27.6529Z"
        fill="white"
      />
      <path
        d="M154.19 23.8721H154.136C153.686 24.5742 153.083 25.0783 152.327 25.3844C151.589 25.6904 150.806 25.8434 149.977 25.8434C149.365 25.8434 148.771 25.7534 148.195 25.5734C147.637 25.4114 147.142 25.1593 146.71 24.8173C146.278 24.4752 145.936 24.0522 145.684 23.5481C145.432 23.044 145.306 22.4589 145.306 21.7928C145.306 21.0367 145.441 20.3976 145.711 19.8755C145.999 19.3534 146.377 18.9214 146.845 18.5793C147.331 18.2373 147.88 17.9762 148.492 17.7962C149.104 17.5982 149.734 17.4541 150.382 17.3641C151.049 17.2741 151.706 17.2201 152.354 17.2021C153.02 17.1841 153.632 17.1751 154.19 17.1751C154.19 16.455 153.929 15.8879 153.407 15.4738C152.903 15.0418 152.3 14.8257 151.598 14.8257C150.932 14.8257 150.319 14.9697 149.761 15.2578C149.221 15.5278 148.735 15.9059 148.303 16.392L146.143 14.1776C146.899 13.4755 147.781 12.9534 148.789 12.6114C149.797 12.2513 150.842 12.0713 151.922 12.0713C153.11 12.0713 154.082 12.2243 154.838 12.5304C155.612 12.8184 156.224 13.2505 156.674 13.8266C157.143 14.4027 157.467 15.1138 157.647 15.9599C157.827 16.788 157.917 17.7512 157.917 18.8494V25.5194H154.19V23.8721ZM153.191 19.7675C152.885 19.7675 152.498 19.7855 152.03 19.8215C151.58 19.8395 151.139 19.9115 150.707 20.0375C150.292 20.1636 149.932 20.3526 149.626 20.6046C149.338 20.8567 149.194 21.2077 149.194 21.6578C149.194 22.1439 149.401 22.5039 149.815 22.738C150.229 22.972 150.661 23.089 151.112 23.089C151.508 23.089 151.886 23.035 152.246 22.927C152.624 22.819 152.957 22.6659 153.245 22.4679C153.533 22.2699 153.758 22.0178 153.92 21.7118C154.1 21.4058 154.19 21.0457 154.19 20.6316V19.7675H153.191Z"
        fill="white"
      />
      <path
        d="M129.457 6.40039H136.559C137.549 6.40039 138.485 6.4904 139.368 6.67043C140.25 6.85046 141.015 7.16551 141.663 7.61558C142.329 8.04765 142.851 8.64174 143.229 9.39786C143.625 10.136 143.823 11.0721 143.823 12.2063C143.823 13.3225 143.643 14.2586 143.283 15.0147C142.923 15.7709 142.428 16.374 141.798 16.824C141.168 17.2741 140.421 17.5981 139.557 17.7962C138.692 17.9762 137.756 18.0662 136.748 18.0662H133.67V25.5194H129.457V6.40039ZM133.67 14.5017H136.478C136.856 14.5017 137.216 14.4657 137.558 14.3936C137.918 14.3216 138.233 14.2046 138.503 14.0426C138.791 13.8626 139.017 13.6285 139.179 13.3405C139.359 13.0344 139.449 12.6564 139.449 12.2063C139.449 11.7202 139.332 11.3332 139.098 11.0451C138.882 10.7391 138.593 10.505 138.233 10.343C137.891 10.181 137.504 10.082 137.072 10.046C136.64 9.99195 136.226 9.96495 135.83 9.96495H133.67V14.5017Z"
        fill="white"
      />
      <path
        d="M122.676 23.8721H122.622C122.172 24.5742 121.569 25.0783 120.813 25.3844C120.075 25.6904 119.292 25.8434 118.464 25.8434C117.852 25.8434 117.258 25.7534 116.681 25.5734C116.123 25.4114 115.628 25.1593 115.196 24.8173C114.764 24.4752 114.422 24.0522 114.17 23.5481C113.918 23.044 113.792 22.4589 113.792 21.7928C113.792 21.0367 113.927 20.3976 114.197 19.8755C114.485 19.3534 114.863 18.9214 115.331 18.5793C115.817 18.2373 116.366 17.9762 116.978 17.7962C117.591 17.5982 118.221 17.4541 118.869 17.3641C119.535 17.2741 120.192 17.2201 120.84 17.2021C121.506 17.1841 122.118 17.1751 122.676 17.1751C122.676 16.455 122.415 15.8879 121.893 15.4738C121.389 15.0418 120.786 14.8257 120.084 14.8257C119.418 14.8257 118.806 14.9697 118.248 15.2578C117.708 15.5278 117.222 15.9059 116.789 16.392L114.629 14.1776C115.385 13.4755 116.267 12.9534 117.276 12.6114C118.284 12.2513 119.328 12.0713 120.408 12.0713C121.596 12.0713 122.568 12.2243 123.324 12.5304C124.099 12.8184 124.711 13.2505 125.161 13.8266C125.629 14.4027 125.953 15.1138 126.133 15.9599C126.313 16.788 126.403 17.7512 126.403 18.8494V25.5194H122.676V23.8721ZM121.677 19.7675C121.371 19.7675 120.984 19.7855 120.516 19.8215C120.066 19.8395 119.625 19.9115 119.193 20.0375C118.779 20.1636 118.419 20.3526 118.113 20.6046C117.825 20.8567 117.681 21.2077 117.681 21.6578C117.681 22.1439 117.888 22.5039 118.302 22.738C118.716 22.972 119.148 23.089 119.598 23.089C119.994 23.089 120.372 23.035 120.732 22.927C121.11 22.819 121.443 22.6659 121.731 22.4679C122.019 22.2699 122.244 22.0178 122.406 21.7118C122.586 21.4058 122.676 21.0457 122.676 20.6316V19.7675H121.677Z"
        fill="white"
      />
      <path
        d="M98.0576 12.3955H102.432L105.754 21.3069H105.808L108.886 12.3955H112.964L107.779 25.5196H103.485L98.0576 12.3955Z"
        fill="white"
      />
      <path
        d="M83.0527 12.3955H87.4274L90.7489 21.3069H90.8029L93.8814 12.3955H97.9591L92.7743 25.5196H88.4806L83.0527 12.3955Z"
        fill="white"
      />
      <path
        d="M81.3456 23.251C80.6975 24.0792 79.8783 24.7183 78.8882 25.1683C77.898 25.6184 76.8719 25.8434 75.8097 25.8434C74.8015 25.8434 73.8474 25.6814 72.9472 25.3574C72.0651 25.0333 71.291 24.5742 70.6249 23.9802C69.9768 23.3681 69.4637 22.6389 69.0856 21.7928C68.7076 20.9467 68.5186 20.0015 68.5186 18.9574C68.5186 17.9132 68.7076 16.9681 69.0856 16.1219C69.4637 15.2758 69.9768 14.5557 70.6249 13.9616C71.291 13.3495 72.0651 12.8814 72.9472 12.5574C73.8474 12.2333 74.8015 12.0713 75.8097 12.0713C76.7458 12.0713 77.592 12.2333 78.3481 12.5574C79.1222 12.8814 79.7703 13.3495 80.2924 13.9616C80.8325 14.5557 81.2465 15.2758 81.5346 16.1219C81.8226 16.9681 81.9667 17.9132 81.9667 18.9574V20.2266H72.5692C72.7312 21.0007 73.0823 21.6218 73.6224 22.0899C74.1624 22.5399 74.8285 22.765 75.6207 22.765C76.2868 22.765 76.8449 22.6209 77.2949 22.3329C77.763 22.0268 78.1681 21.6398 78.5101 21.1717L81.3456 23.251ZM77.916 17.4721C77.934 16.788 77.709 16.2029 77.2409 15.7169C76.7728 15.2308 76.1698 14.9877 75.4316 14.9877C74.9816 14.9877 74.5855 15.0598 74.2435 15.2038C73.9014 15.3478 73.6044 15.5368 73.3523 15.7709C73.1183 15.9869 72.9292 16.2479 72.7852 16.554C72.6592 16.842 72.5872 17.1481 72.5692 17.4721H77.916Z"
        fill="white"
      />
      <path
        d="M51.9258 6.40039H59.3249C60.2971 6.40039 61.2152 6.49941 62.0794 6.69744C62.9615 6.87746 63.7266 7.19251 64.3747 7.64258C65.0408 8.07465 65.5629 8.66875 65.941 9.42486C66.337 10.163 66.5351 11.0901 66.5351 12.2063C66.5351 13.5565 66.184 14.7087 65.4819 15.6628C64.7798 16.599 63.7536 17.1931 62.4034 17.4451L67.2642 25.5194H62.2144L58.2178 17.8772H56.1384V25.5194H51.9258V6.40039ZM56.1384 14.3126H58.6228C59.0009 14.3126 59.397 14.3036 59.811 14.2856C60.2431 14.2496 60.6301 14.1686 60.9722 14.0426C61.3143 13.8986 61.5933 13.6825 61.8093 13.3945C62.0434 13.1064 62.1604 12.7014 62.1604 12.1793C62.1604 11.6932 62.0614 11.3062 61.8633 11.0181C61.6653 10.7301 61.4133 10.514 61.1072 10.37C60.8012 10.208 60.4501 10.1 60.0541 10.046C59.658 9.99195 59.2709 9.96495 58.8929 9.96495H56.1384V14.3126Z"
        fill="white"
      />
    </svg>
  )
}

export const MerchantProfileIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M14.19 0H5.81C2.17 0 0 2.17 0 5.81V14.19C0 17 1.29 18.93 3.56 19.66C4.22 19.89 4.98 20 5.81 20H14.19C15.02 20 15.78 19.89 16.44 19.66C18.71 18.93 20 17 20 14.19V5.81C20 2.17 17.83 0 14.19 0ZM18.5 14.19C18.5 16.33 17.66 17.68 15.97 18.24C15 16.33 12.7 14.97 10 14.97C7.3 14.97 5.01 16.32 4.03 18.24H4.02C2.35 17.7 1.5 16.34 1.5 14.2V5.81C1.5 2.99 2.99 1.5 5.81 1.5H14.19C17.01 1.5 18.5 2.99 18.5 5.81V14.19Z"
        fill="white"
      />
      <path
        d="M9.99992 6C8.01992 6 6.41992 7.6 6.41992 9.58C6.41992 11.56 8.01992 13.17 9.99992 13.17C11.9799 13.17 13.5799 11.56 13.5799 9.58C13.5799 7.6 11.9799 6 9.99992 6Z"
        fill="white"
      />
    </svg>
  )
}
export const AllTransactionIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M19.587 0.666504H8.41366C3.56033 0.666504 0.666992 3.55984 0.666992 8.41317V19.5865C0.666992 23.3332 2.38699 25.9065 5.41366 26.8798C6.29366 27.1865 7.30699 27.3332 8.41366 27.3332H19.587C20.6937 27.3332 21.707 27.1865 22.587 26.8798C25.6137 25.9065 27.3337 23.3332 27.3337 19.5865V8.41317C27.3337 3.55984 24.4403 0.666504 19.587 0.666504ZM25.3337 19.5865C25.3337 22.4398 24.2137 24.2398 21.9603 24.9865C20.667 22.4398 17.6003 20.6265 14.0003 20.6265C10.4003 20.6265 7.34699 22.4265 6.04033 24.9865H6.02699C3.80033 24.2665 2.66699 22.4532 2.66699 19.5998V8.41317C2.66699 4.65317 4.65366 2.6665 8.41366 2.6665H19.587C23.347 2.6665 25.3337 4.65317 25.3337 8.41317V19.5865Z"
        fill="#CB9A2B"
      />
      <path
        d="M13.9999 8.6665C11.3599 8.6665 9.22656 10.7998 9.22656 13.4398C9.22656 16.0798 11.3599 18.2265 13.9999 18.2265C16.6399 18.2265 18.7732 16.0798 18.7732 13.4398C18.7732 10.7998 16.6399 8.6665 13.9999 8.6665Z"
        fill="#CB9A2B"
      />
    </svg>
  )
}

export const WalletMinusIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M15.9203 2.94677L12.7069 10.4268H9.49359C8.96026 10.4268 8.44026 10.4668 7.93359 10.5734L9.26693 7.37343L9.32026 7.25343L9.40026 7.0401C9.44026 6.94677 9.46693 6.86677 9.50693 6.8001C11.0536 3.21343 12.7869 2.09343 15.9203 2.94677Z"
        fill="#CB9A2B"
      />
      <path
        d="M24.9735 10.7865L24.9468 10.7732C24.1468 10.5465 23.3335 10.4265 22.5068 10.4265H14.1602L17.1602 3.4532L17.2002 3.35986C17.3868 3.42653 17.5868 3.51986 17.7868 3.58653L20.7335 4.82653C22.3735 5.50653 23.5202 6.2132 24.2268 7.06653C24.3468 7.22653 24.4535 7.3732 24.5602 7.54653C24.6802 7.7332 24.7735 7.91986 24.8268 8.11986C24.8802 8.23986 24.9202 8.34653 24.9468 8.46653C25.1468 9.14653 25.1602 9.91986 24.9735 10.7865Z"
        fill="#CB9A2B"
      />
      <path
        d="M24.3863 12.6934C23.7863 12.5201 23.1597 12.4268 22.5063 12.4268H9.493C8.58633 12.4268 7.73299 12.6001 6.93299 12.9468C4.61299 13.9468 2.98633 16.2534 2.98633 18.9334V21.5334C2.98633 21.8534 3.01299 22.1601 3.05299 22.4801C3.34633 26.7201 5.61299 28.9868 9.85299 29.2668C10.1597 29.3068 10.4663 29.3334 10.7997 29.3334H21.1997C26.133 29.3334 28.733 26.9868 28.9863 22.3201C28.9997 22.0668 29.013 21.8001 29.013 21.5334V18.9334C29.013 15.9868 27.053 13.5068 24.3863 12.6934ZM19.333 22.3334H12.6663C12.1197 22.3334 11.6663 21.8801 11.6663 21.3334C11.6663 20.7868 12.1197 20.3334 12.6663 20.3334H19.333C19.8797 20.3334 20.333 20.7868 20.333 21.3334C20.333 21.8801 19.8797 22.3334 19.333 22.3334Z"
        fill="#CB9A2B"
      />
    </svg>
  )
}

export const ProcessedIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M19.587 0.666504H8.41366C3.56033 0.666504 0.666992 3.55984 0.666992 8.41317V19.5732C0.666992 24.4398 3.56033 27.3332 8.41366 27.3332H19.5737C24.427 27.3332 27.3203 24.4398 27.3203 19.5865V8.41317C27.3337 3.55984 24.4403 0.666504 19.587 0.666504ZM21.0137 11.2798L17.9337 15.2532C17.547 15.7465 17.0003 16.0665 16.3737 16.1332C15.747 16.2132 15.1337 16.0398 14.6403 15.6532L12.2003 13.7332C12.107 13.6532 12.0003 13.6532 11.947 13.6665C11.8937 13.6665 11.8003 13.6932 11.7203 13.7998L8.54699 17.9198C8.34699 18.1732 8.05366 18.3065 7.76033 18.3065C7.54699 18.3065 7.33366 18.2398 7.14699 18.0932C6.70699 17.7598 6.62699 17.1332 6.96033 16.6932L10.1337 12.5732C10.5203 12.0798 11.067 11.7598 11.6937 11.6798C12.307 11.5998 12.9337 11.7732 13.427 12.1598L15.867 14.0798C15.9603 14.1598 16.0537 14.1598 16.1203 14.1465C16.1737 14.1465 16.267 14.1198 16.347 14.0132L19.427 10.0398C19.7603 9.59984 20.4003 9.51984 20.827 9.8665C21.267 10.2265 21.347 10.8532 21.0137 11.2798Z"
        fill="#CB9A2B"
      />
    </svg>
  )
}

export const AddPaymentIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M22 19V22H2V19C2 18.45 2.45 18 3 18H21C21.55 18 22 18.45 22 19Z"
        fill="white"
        stroke="white"
        strokeWidth="1.5"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M7 11H5V18H7V11Z" fill="white" />
      <path d="M11 11H9V18H11V11Z" fill="white" />
      <path d="M15 11H13V18H15V11Z" fill="white" />
      <path d="M19 11H17V18H19V11Z" fill="white" />
      <path
        d="M23 22.75H1C0.59 22.75 0.25 22.41 0.25 22C0.25 21.59 0.59 21.25 1 21.25H23C23.41 21.25 23.75 21.59 23.75 22C23.75 22.41 23.41 22.75 23 22.75Z"
        fill="white"
      />
      <path
        d="M21.37 5.74984L12.37 2.14984C12.17 2.06984 11.83 2.06984 11.63 2.14984L2.63 5.74984C2.28 5.88984 2 6.29984 2 6.67984V9.99984C2 10.5498 2.45 10.9998 3 10.9998H21C21.55 10.9998 22 10.5498 22 9.99984V6.67984C22 6.29984 21.72 5.88984 21.37 5.74984ZM12 8.49984C11.17 8.49984 10.5 7.82984 10.5 6.99984C10.5 6.16984 11.17 5.49984 12 5.49984C12.83 5.49984 13.5 6.16984 13.5 6.99984C13.5 7.82984 12.83 8.49984 12 8.49984Z"
        fill="white"
      />
    </svg>
  )
}

export const DeleteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.75 2.73162V2.92079C12.8325 3.01978 13.9106 3.16212 14.9817 3.34746C15.0625 3.36146 15.1399 3.39126 15.2092 3.43515C15.2786 3.47904 15.3386 3.53616 15.3859 3.60326C15.4332 3.67035 15.4668 3.74609 15.4848 3.82617C15.5028 3.90624 15.5048 3.98908 15.4908 4.06996C15.4768 4.15083 15.447 4.22815 15.4031 4.29751C15.3593 4.36686 15.3021 4.42689 15.235 4.47417C15.1679 4.52146 15.0922 4.55506 15.0121 4.57307C14.932 4.59107 14.8492 4.59313 14.7683 4.57912L14.5942 4.54996L13.7567 15.4416C13.7084 16.0696 13.4248 16.6562 12.9627 17.0842C12.5006 17.5122 11.894 17.7499 11.2642 17.75H4.73667C4.10683 17.7499 3.50022 17.5122 3.03811 17.0842C2.576 16.6562 2.29246 16.0696 2.24417 15.4416L1.40584 4.54996L1.23167 4.57912C1.1508 4.59313 1.06796 4.59107 0.987883 4.57307C0.907807 4.55506 0.832061 4.52146 0.76497 4.47417C0.629475 4.37869 0.537462 4.23329 0.509172 4.06996C0.480882 3.90663 0.518634 3.73875 0.614121 3.60326C0.709608 3.46776 0.85501 3.37575 1.01834 3.34746C2.08939 3.16189 3.16749 3.01956 4.25001 2.92079V2.73162C4.25001 1.42829 5.26084 0.314957 6.59667 0.272457C7.53227 0.242514 8.46858 0.242514 9.40417 0.272457C10.74 0.314957 11.75 1.42829 11.75 2.73162ZM6.63667 1.52162C7.54561 1.49255 8.45524 1.49255 9.36417 1.52162C9.99167 1.54162 10.5 2.06996 10.5 2.73162V2.82579C8.83487 2.72466 7.16514 2.72466 5.50001 2.82579V2.73162C5.50001 2.06996 6.00751 1.54162 6.63667 1.52162ZM6.34084 6.47579C6.33767 6.39371 6.31836 6.31307 6.28402 6.23845C6.24967 6.16384 6.20097 6.09672 6.14069 6.04093C6.08041 5.98513 6.00973 5.94176 5.93269 5.91328C5.85565 5.88481 5.77375 5.87178 5.69167 5.87496C5.6096 5.87813 5.52895 5.89744 5.45433 5.93178C5.37972 5.96612 5.3126 6.01482 5.25681 6.0751C5.20102 6.13538 5.15764 6.20606 5.12917 6.28311C5.10069 6.36015 5.08767 6.44205 5.09084 6.52412L5.38001 14.0241C5.38642 14.1898 5.45837 14.3461 5.58003 14.4587C5.64027 14.5144 5.71091 14.5578 5.7879 14.5862C5.86489 14.6147 5.94673 14.6277 6.02876 14.6245C6.11078 14.6214 6.19137 14.6021 6.26593 14.5677C6.3405 14.5334 6.40757 14.4848 6.46332 14.4245C6.51908 14.3643 6.56242 14.2936 6.59088 14.2166C6.61933 14.1397 6.63235 14.0578 6.62917 13.9758L6.34084 6.47579ZM10.9075 6.52412C10.9136 6.44047 10.9028 6.35644 10.8758 6.27705C10.8487 6.19765 10.806 6.12452 10.7501 6.06199C10.6942 5.99947 10.6262 5.94884 10.5504 5.91311C10.4745 5.87739 10.3922 5.85731 10.3083 5.85406C10.2245 5.85082 10.1409 5.86448 10.0625 5.89423C9.98408 5.92397 9.91245 5.9692 9.85187 6.02722C9.79129 6.08523 9.74302 6.15484 9.70991 6.23191C9.6768 6.30898 9.65955 6.39192 9.65917 6.47579L9.37001 13.9758C9.3636 14.1416 9.4233 14.3031 9.53597 14.4248C9.64865 14.5466 9.80508 14.6185 9.97084 14.625C10.1366 14.6314 10.2981 14.5717 10.4199 14.459C10.5416 14.3463 10.6136 14.1899 10.62 14.0241L10.9075 6.52412Z"
        fill="#F35656"
      />
    </svg>
  )
}

export const AddTeamMemberIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21.97 2.33C21.25 1.51 20.18 1 19 1C17.88 1 16.86 1.46 16.13 2.21C15.71 2.64 15.39 3.16 15.2 3.74C15.07 4.14 15 4.56 15 5C15 5.75 15.21 6.46 15.58 7.06C15.78 7.4 16.04 7.71 16.34 7.97C17.04 8.61 17.97 9 19 9C19.44 9 19.86 8.93 20.25 8.79C21.17 8.5 21.94 7.87 22.42 7.06C22.63 6.72 22.79 6.33 22.88 5.93C22.96 5.63 23 5.32 23 5C23 3.98 22.61 3.04 21.97 2.33ZM20.49 5.73H19.75V6.51C19.75 6.92 19.41 7.26 19 7.26C18.59 7.26 18.25 6.92 18.25 6.51V5.73H17.51C17.1 5.73 16.76 5.39 16.76 4.98C16.76 4.57 17.1 4.23 17.51 4.23H18.25V3.52C18.25 3.11 18.59 2.77 19 2.77C19.41 2.77 19.75 3.11 19.75 3.52V4.23H20.49C20.9 4.23 21.24 4.57 21.24 4.98C21.24 5.39 20.91 5.73 20.49 5.73Z"
        fill="#B4C8CB"
      />
      <path
        d="M22 12C22 10.69 21.75 9.43 21.28 8.28C20.97 8.5 20.62 8.67 20.25 8.79C20.14 8.83 20.03 8.86 19.91 8.89C20.29 9.85 20.5 10.9 20.5 12C20.5 14.32 19.56 16.43 18.04 17.97C17.75 17.6 17.38 17.26 16.94 16.97C14.23 15.15 9.79 15.15 7.06 16.97C6.62 17.26 6.26 17.6 5.96 17.97C4.44 16.43 3.5 14.32 3.5 12C3.5 7.31 7.31 3.5 12 3.5C13.09 3.5 14.14 3.71 15.1 4.09C15.13 3.97 15.16 3.86 15.2 3.74C15.32 3.37 15.49 3.03 15.72 2.72C14.57 2.25 13.31 2 12 2C6.49 2 2 6.49 2 12C2 14.9 3.25 17.51 5.23 19.34C5.23 19.35 5.23 19.35 5.22 19.36C5.32 19.46 5.44 19.54 5.54 19.63C5.6 19.68 5.65 19.73 5.71 19.77C5.89 19.92 6.09 20.06 6.28 20.2C6.35 20.25 6.41 20.29 6.48 20.34C6.67 20.47 6.87 20.59 7.08 20.7C7.15 20.74 7.23 20.79 7.3 20.83C7.5 20.94 7.71 21.04 7.93 21.13C8.01 21.17 8.09 21.21 8.17 21.24C8.39 21.33 8.61 21.41 8.83 21.48C8.91 21.51 8.99 21.54 9.07 21.56C9.31 21.63 9.55 21.69 9.79 21.75C9.86 21.77 9.93 21.79 10.01 21.8C10.29 21.86 10.57 21.9 10.86 21.93C10.9 21.93 10.94 21.94 10.98 21.95C11.32 21.98 11.66 22 12 22C12.34 22 12.68 21.98 13.01 21.95C13.05 21.95 13.09 21.94 13.13 21.93C13.42 21.9 13.7 21.86 13.98 21.8C14.05 21.79 14.12 21.76 14.2 21.75C14.44 21.69 14.69 21.64 14.92 21.56C15 21.53 15.08 21.5 15.16 21.48C15.38 21.4 15.61 21.33 15.82 21.24C15.9 21.21 15.98 21.17 16.06 21.13C16.27 21.04 16.48 20.94 16.69 20.83C16.77 20.79 16.84 20.74 16.91 20.7C17.11 20.58 17.31 20.47 17.51 20.34C17.58 20.3 17.64 20.25 17.71 20.2C17.91 20.06 18.1 19.92 18.28 19.77C18.34 19.72 18.39 19.67 18.45 19.63C18.56 19.54 18.67 19.45 18.77 19.36C18.77 19.35 18.77 19.35 18.76 19.34C20.75 17.51 22 14.9 22 12Z"
        fill="#B4C8CB"
      />
      <path
        d="M12 6.92969C9.93 6.92969 8.25 8.60969 8.25 10.6797C8.25 12.7097 9.84 14.3597 11.95 14.4197C11.98 14.4197 12.02 14.4197 12.04 14.4197C12.06 14.4197 12.09 14.4197 12.11 14.4197C12.12 14.4197 12.13 14.4197 12.13 14.4197C14.15 14.3497 15.74 12.7097 15.75 10.6797C15.75 8.60969 14.07 6.92969 12 6.92969Z"
        fill="#B4C8CB"
      />
    </svg>
  )
}

export const CurrencyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        opacity="0.4"
        d="M16.0831 6.60023V10.8919C16.0831 13.4586 14.6165 14.5586 12.4165 14.5586H5.09147C4.71647 14.5586 4.35813 14.5253 4.0248 14.4503C3.81647 14.4169 3.61647 14.3586 3.43314 14.2919C2.18314 13.8253 1.4248 12.7419 1.4248 10.8919V6.60023C1.4248 4.03356 2.89147 2.93359 5.09147 2.93359H12.4165C14.2831 2.93359 15.6248 3.72526 15.9831 5.53359C16.0415 5.86692 16.0831 6.20856 16.0831 6.60023Z"
        fill="#B4C8CB"
      />
      <path
        d="M18.5837 9.09984V13.3915C18.5837 15.9582 17.1171 17.0582 14.9171 17.0582H7.59206C6.97539 17.0582 6.41706 16.9749 5.93373 16.7915C4.94206 16.4249 4.26706 15.6665 4.02539 14.4499C4.35872 14.5249 4.71706 14.5582 5.09206 14.5582H12.4171C14.6171 14.5582 16.0837 13.4582 16.0837 10.8915V6.59984C16.0837 6.20818 16.0504 5.8582 15.9837 5.5332C17.5671 5.86654 18.5837 6.98318 18.5837 9.09984Z"
        fill="#B4C8CB"
      />
      <path
        d="M8.74982 10.9508C9.96484 10.9508 10.9498 9.96582 10.9498 8.75079C10.9498 7.53577 9.96484 6.55078 8.74982 6.55078C7.53479 6.55078 6.5498 7.53577 6.5498 8.75079C6.5498 9.96582 7.53479 10.9508 8.74982 10.9508Z"
        fill="#B4C8CB"
      />
      <path
        d="M3.9834 6.875C3.64173 6.875 3.3584 7.15833 3.3584 7.5V10C3.3584 10.3417 3.64173 10.625 3.9834 10.625C4.32506 10.625 4.6084 10.3417 4.6084 10V7.5C4.6084 7.15833 4.3334 6.875 3.9834 6.875Z"
        fill="#B4C8CB"
      />
      <path
        d="M13.5088 6.875C13.1671 6.875 12.8838 7.15833 12.8838 7.5V10C12.8838 10.3417 13.1671 10.625 13.5088 10.625C13.8505 10.625 14.1338 10.3417 14.1338 10V7.5C14.1338 7.15833 13.8588 6.875 13.5088 6.875Z"
        fill="#B4C8CB"
      />
    </svg>
  )
}

export const ActiveCurrencyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        opacity="0.4"
        d="M16.0831 6.60023V10.8919C16.0831 13.4586 14.6165 14.5586 12.4165 14.5586H5.09147C4.71647 14.5586 4.35813 14.5253 4.0248 14.4503C3.81647 14.4169 3.61647 14.3586 3.43314 14.2919C2.18314 13.8253 1.4248 12.7419 1.4248 10.8919V6.60023C1.4248 4.03356 2.89147 2.93359 5.09147 2.93359H12.4165C14.2831 2.93359 15.6248 3.72526 15.9831 5.53359C16.0415 5.86692 16.0831 6.20856 16.0831 6.60023Z"
        fill="#022329"
      />
      <path
        d="M18.5837 9.09984V13.3915C18.5837 15.9582 17.1171 17.0582 14.9171 17.0582H7.59206C6.97539 17.0582 6.41706 16.9749 5.93373 16.7915C4.94206 16.4249 4.26706 15.6665 4.02539 14.4499C4.35872 14.5249 4.71706 14.5582 5.09206 14.5582H12.4171C14.6171 14.5582 16.0837 13.4582 16.0837 10.8915V6.59984C16.0837 6.20818 16.0504 5.8582 15.9837 5.5332C17.5671 5.86654 18.5837 6.98318 18.5837 9.09984Z"
        fill="#022329"
      />
      <path
        d="M8.74982 10.9498C9.96484 10.9498 10.9498 9.96484 10.9498 8.74982C10.9498 7.53479 9.96484 6.5498 8.74982 6.5498C7.53479 6.5498 6.5498 7.53479 6.5498 8.74982C6.5498 9.96484 7.53479 10.9498 8.74982 10.9498Z"
        fill="#022329"
      />
      <path
        d="M3.9834 6.875C3.64173 6.875 3.3584 7.15833 3.3584 7.5V10C3.3584 10.3417 3.64173 10.625 3.9834 10.625C4.32506 10.625 4.6084 10.3417 4.6084 10V7.5C4.6084 7.15833 4.3334 6.875 3.9834 6.875Z"
        fill="#022329"
      />
      <path
        d="M13.5088 6.875C13.1671 6.875 12.8838 7.15833 12.8838 7.5V10C12.8838 10.3417 13.1671 10.625 13.5088 10.625C13.8505 10.625 14.1338 10.3417 14.1338 10V7.5C14.1338 7.15833 13.8588 6.875 13.5088 6.875Z"
        fill="#022329"
      />
    </svg>
  )
}

export const PaymentSuccessIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.25 10C0.25 4.615 4.615 0.25 10 0.25C15.385 0.25 19.75 4.615 19.75 10C19.75 15.385 15.385 19.75 10 19.75C4.615 19.75 0.25 15.385 0.25 10ZM13.61 8.186C13.67 8.10605 13.7134 8.01492 13.7377 7.91795C13.762 7.82098 13.7666 7.72014 13.7514 7.62135C13.7361 7.52257 13.7012 7.42782 13.6489 7.3427C13.5965 7.25757 13.5276 7.18378 13.4463 7.12565C13.3649 7.06753 13.2728 7.02624 13.1753 7.00423C13.0778 6.98221 12.9769 6.97991 12.8785 6.99746C12.7801 7.01501 12.6862 7.05205 12.6023 7.10641C12.5184 7.16077 12.4462 7.23135 12.39 7.314L9.154 11.844L7.53 10.22C7.38783 10.0875 7.19978 10.0154 7.00548 10.0188C6.81118 10.0223 6.62579 10.101 6.48838 10.2384C6.35097 10.3758 6.27225 10.5612 6.26882 10.7555C6.2654 10.9498 6.33752 11.1378 6.47 11.28L8.72 13.53C8.79699 13.6069 8.8898 13.6662 8.99199 13.7036C9.09418 13.7411 9.20329 13.7559 9.31176 13.7469C9.42023 13.738 9.52546 13.7055 9.62013 13.6519C9.7148 13.5982 9.79665 13.5245 9.86 13.436L13.61 8.186Z"
        fill="#044752"
      />
    </svg>
  )
}

export const PaymentProcessingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
    >
      <path
        d="M10 19V16M3.64 16.36L5.76 14.24M1 10H4M3.64 3.64L5.76 5.76M10 1V4M16.36 3.64L14.24 5.76M18 10H16M15 15L14.29 14.29"
        stroke="#CB9A2B"
        stroke-width="2"
        stroke-linecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const PaymentFailedIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.25 10C0.25 4.615 4.615 0.25 10 0.25C15.385 0.25 19.75 4.615 19.75 10C19.75 15.385 15.385 19.75 10 19.75C4.615 19.75 0.25 15.385 0.25 10ZM10 6.25C10.1989 6.25 10.3897 6.32902 10.5303 6.46967C10.671 6.61032 10.75 6.80109 10.75 7V10.75C10.75 10.9489 10.671 11.1397 10.5303 11.2803C10.3897 11.421 10.1989 11.5 10 11.5C9.80109 11.5 9.61032 11.421 9.46967 11.2803C9.32902 11.1397 9.25 10.9489 9.25 10.75V7C9.25 6.80109 9.32902 6.61032 9.46967 6.46967C9.61032 6.32902 9.80109 6.25 10 6.25ZM10 14.5C10.1989 14.5 10.3897 14.421 10.5303 14.2803C10.671 14.1397 10.75 13.9489 10.75 13.75C10.75 13.5511 10.671 13.3603 10.5303 13.2197C10.3897 13.079 10.1989 13 10 13C9.80109 13 9.61032 13.079 9.46967 13.2197C9.32902 13.3603 9.25 13.5511 9.25 13.75C9.25 13.9489 9.32902 14.1397 9.46967 14.2803C9.61032 14.421 9.80109 14.5 10 14.5Z"
        fill="#F35656"
      />
    </svg>
  )
}

export const DeleteMemberIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
    >
      <path
        d="M78.1587 38.4473L72.2872 41.7227L57.1929 49.2699L62.0607 46.5529L63.0646 45.9944L78.1587 38.4473Z"
        fill="#FEF7F7"
        stroke="#F35656"
        stroke-width="0.8"
        stroke-linecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M60.0756 54.2506L63.0644 59.3978L61.3738 60.3261L59.0795 61.594L53.2756 51.5789L47.3965 54.8468L43.4795 48.0921L49.2833 44.7034L45.4568 38.0921L43.4795 34.6883L47.3965 32.3789L53.2756 42.5072L59.0795 39.1185L59.5701 39.9638L63.0644 45.994L62.0606 46.5525L57.1927 49.2695L57.5021 49.8053L60.0756 54.2506Z"
        fill="#FEF7F7"
        stroke="#F35656"
        stroke-width="0.8"
        stroke-linecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M68.1507 34.583L64.0677 36.6207L59.079 39.1188L53.2752 42.5075L47.396 32.3792L62.4903 24.832L68.1507 34.583Z"
        fill="#FEF7F7"
        stroke="#F35656"
        stroke-width="0.8"
        stroke-linecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M78.1586 38.4477L63.0645 45.9949L59.5702 39.9647L59.0796 39.1194L64.0683 36.6213L68.1513 34.5836L74.1739 31.5723L78.1586 38.4477Z"
        fill="#FEF7F7"
        stroke="#F35656"
        stroke-width="0.8"
        stroke-linecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.2792 67.6934V76.6823L1.50928 50.8331V41.8444C1.50928 40.0255 1.91682 38.5916 2.73192 37.535C3.13947 37.0067 3.61494 36.6142 4.15079 36.3425H4.15834C4.70174 36.0708 5.30554 35.9274 5.98479 35.9199C8.87539 35.9274 11.8187 36.3802 14.7998 37.2783C15.3961 37.4595 15.9998 37.6558 16.6036 37.8746C19.0036 38.7199 21.4338 39.8595 23.8942 41.2859C26.9734 43.0595 29.9999 45.2256 32.9886 47.7765C35.9697 50.3275 38.9131 53.2709 41.8036 56.5992C42.3848 57.2784 42.9131 57.9954 43.3885 58.7501C44.03 59.7539 44.5886 60.8256 45.0565 61.9652C45.8716 63.9652 46.2792 65.867 46.2792 67.6934Z"
        fill="#FEF7F7"
        stroke="#F35656"
        stroke-width="0.8"
        stroke-linecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.087 31.6925V31.7076C35.087 35.2321 33.9926 37.6095 31.7964 38.8623C29.6077 40.1151 26.9738 39.851 23.8945 38.0699C21.2983 36.5755 19.0115 34.3642 17.0492 31.4283C16.8002 31.0585 16.5511 30.6661 16.3096 30.2661C16.204 30.0925 16.0984 29.9189 15.9927 29.7378C13.7965 25.9566 12.7021 22.2963 12.7021 18.7642C12.7021 15.2321 13.7965 12.8472 15.9927 11.5944L16.5436 11.3151C18.6191 10.4019 21.0719 10.7491 23.8945 12.3868C25.5549 13.3453 27.087 14.5906 28.4832 16.1378C29.6832 17.451 30.7851 18.9831 31.7964 20.7189C32.9889 22.7793 33.8643 24.8019 34.4077 26.7868C34.8606 28.4472 35.087 30.0849 35.087 31.6925Z"
        fill="#FEF7F7"
        stroke="#F35656"
        stroke-width="0.8"
        stroke-linecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M78.1586 51.8516L74.1739 54.0478L61.3739 60.4478L59.0796 61.595L61.3739 60.327L63.0645 59.3987L74.0834 53.8893L78.1586 51.8516Z"
        fill="#FEF7F7"
        stroke="#F35656"
        stroke-width="0.8"
        stroke-linecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M78.1587 51.8529L74.0834 53.8906L63.0646 59.4001L60.0758 54.2529L57.5023 49.8076L57.1929 49.2718L72.2872 41.7246L78.1587 51.8529Z"
        fill="#FEF7F7"
        stroke="#F35656"
        stroke-width="0.8"
        stroke-linecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.1812 24.1463C50.1812 27.6784 49.0869 30.0633 46.8906 31.3161L46.3397 31.5954L40.3774 34.5689L31.7963 38.8633C33.9925 37.6105 35.0869 35.2331 35.0869 31.7086V31.6935C35.0869 30.0859 34.8604 28.4482 34.4075 26.7878C33.8641 24.8029 32.9887 22.7803 31.7963 20.7199C30.785 18.984 29.6831 17.4519 28.4831 16.1387C27.0869 14.5915 25.5548 13.3463 23.8944 12.3878C21.0718 10.7501 18.6189 10.4029 16.5435 11.3161L31.0869 4.04818C33.2755 2.8029 35.9095 3.05949 38.9887 4.84062C42.068 6.61421 44.7019 9.39913 46.8906 13.1727C49.0869 16.9538 50.1812 20.6142 50.1812 24.1463Z"
        fill="#FEF7F7"
        stroke="#F35656"
        stroke-width="0.8"
        stroke-linecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M61.3733 60.4487V69.1355L46.279 76.683V67.694C46.279 65.8676 45.8714 63.9657 45.0563 61.9657C44.5884 60.8261 44.0299 59.7544 43.3883 58.7506C42.9129 57.9959 42.3846 57.2789 41.8035 56.5997C38.9129 53.2714 35.9695 50.328 32.9884 47.777C29.9997 45.2261 26.9733 43.06 23.8941 41.2864C21.4337 39.86 19.0035 38.7204 16.6035 37.8751C15.9997 37.6563 15.3959 37.46 14.7997 37.2789C11.8185 36.3808 8.87521 35.928 5.98465 35.9204C5.3054 35.928 4.7016 36.0714 4.1582 36.343L16.3091 30.2676C16.5506 30.6676 16.7997 31.06 17.0487 31.4298C19.011 34.3657 21.2978 36.577 23.8941 38.0714C26.9733 39.8525 29.6073 40.1166 31.796 38.8638L40.3771 34.5695C42.0828 35.6185 43.7808 36.7959 45.4563 38.094L49.2828 44.7053L43.4789 48.094L47.396 54.8487L53.2751 51.5808L59.079 61.5959L61.3733 60.4487Z"
        fill="#FEF7F7"
        stroke="#F35656"
        stroke-width="0.8"
        stroke-linecap="round"
        strokeLinejoin="round"
      />
      <path d="M4.15843 36.3418H4.15088H4.15843Z" fill="#FEF7F7" />
      <path
        d="M4.15843 36.3418H4.15088"
        stroke="#F35656"
        stroke-width="0.8"
        stroke-linecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const InfoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M6.5 6.5L6.52733 6.48667C6.61282 6.44396 6.70875 6.42664 6.80378 6.43677C6.8988 6.4469 6.98893 6.48404 7.0635 6.54381C7.13806 6.60357 7.19394 6.68345 7.22451 6.77399C7.25508 6.86453 7.25907 6.96193 7.236 7.05467L6.764 8.94533C6.74076 9.03811 6.74463 9.13561 6.77513 9.22626C6.80563 9.31691 6.86149 9.39691 6.93609 9.45678C7.01069 9.51664 7.10089 9.55384 7.196 9.56399C7.2911 9.57413 7.38712 9.55678 7.47267 9.514L7.5 9.5M13 7C13 7.78793 12.8448 8.56815 12.5433 9.2961C12.2417 10.0241 11.7998 10.6855 11.2426 11.2426C10.6855 11.7998 10.0241 12.2417 9.2961 12.5433C8.56815 12.8448 7.78793 13 7 13C6.21207 13 5.43185 12.8448 4.7039 12.5433C3.97595 12.2417 3.31451 11.7998 2.75736 11.2426C2.20021 10.6855 1.75825 10.0241 1.45672 9.2961C1.15519 8.56815 1 7.78793 1 7C1 5.4087 1.63214 3.88258 2.75736 2.75736C3.88258 1.63214 5.4087 1 7 1C8.5913 1 10.1174 1.63214 11.2426 2.75736C12.3679 3.88258 13 5.4087 13 7ZM7 4.5H7.00533V4.50533H7V4.5Z"
        stroke="#855C00"
        stroke-linecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const SessionIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
    >
      <path
        d="M77.8385 32.654V47.9694C77.8539 50.7694 76.9385 53.5155 75.0923 56.2155C73.2461 58.9232 70.4692 61.3464 66.7538 63.4848C63.0461 65.631 58.8461 67.2387 54.1615 68.3002C49.4846 69.3694 44.7153 69.9002 39.8768 69.8848C35.0306 69.8771 30.2615 69.331 25.5692 68.2541C20.8769 67.1694 16.6615 65.5464 12.923 63.3925C9.19225 61.231 6.38453 58.8001 4.5076 56.0924C2.63068 53.3848 1.68457 50.6309 1.66919 47.8309V32.4463C1.68457 35.0309 2.49219 37.5694 4.09219 40.0771C4.22296 40.2848 4.36145 40.5001 4.5076 40.7078C6.38453 43.4155 9.19225 45.8464 12.923 48.0079C16.6615 50.1618 20.8769 51.7848 25.5692 52.8694C30.2615 53.9464 35.0306 54.4925 39.8768 54.5002C44.7153 54.5156 49.4846 53.9848 54.1615 52.9156C58.8461 51.8541 63.0461 50.2464 66.7538 48.1002C70.4692 45.9618 73.2461 43.5386 75.0923 40.8309C75.2076 40.6694 75.3153 40.5001 75.4153 40.3386C77.0308 37.8155 77.8385 35.2617 77.8385 32.654Z"
        fill="#FEF7F7"
        stroke="#F35656"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M61.2228 20.1232L49.7613 26.7386L43.4228 30.3925C42.1997 30.3079 40.9459 30.2617 39.6613 30.2617C38.3767 30.2617 37.2228 30.2925 36.0459 30.3771L29.6459 26.6847L18.1536 20.0462C24.1459 16.5847 31.3152 14.8617 39.6613 14.8771C47.9998 14.8924 55.192 16.6386 61.2228 20.1232Z"
        fill="#FEF7F7"
        stroke="#F35656"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M75.0001 24.3229C73.1232 21.6152 70.3232 19.1845 66.5848 17.0229C62.854 14.8691 58.6386 13.246 53.9462 12.1614C49.2462 11.0844 44.4771 10.5383 39.6386 10.5306C34.7925 10.5152 30.0309 11.046 25.3463 12.1153C20.6616 13.1768 16.4693 14.7845 12.7539 16.9306C9.04625 19.0691 6.26165 21.4922 4.4155 24.1998C2.56934 26.8998 1.654 29.646 1.66938 32.446C1.68476 35.0306 2.49238 37.5691 4.09238 40.0768C4.22315 40.2845 4.36164 40.4998 4.5078 40.7075C6.38472 43.4152 9.19248 45.8461 12.9232 48.0076C16.6617 50.1615 20.877 51.7845 25.5693 52.8691C30.2616 53.946 35.0309 54.4922 39.877 54.4998C44.7155 54.5152 49.4848 53.9845 54.1617 52.9153C58.8463 51.8538 63.0463 50.2461 66.754 48.0999C70.4694 45.9615 73.2463 43.5383 75.0924 40.8306C75.2078 40.6691 75.3156 40.4998 75.4156 40.3383C77.0308 37.8152 77.8385 35.2614 77.8385 32.6537V32.5845C77.8231 29.7845 76.877 27.0306 75.0001 24.3229ZM49.7616 26.7383L43.4232 30.3922L39.754 32.5153L36.0462 30.3768L29.6463 26.6845L18.1539 20.046C24.1462 16.5845 31.3156 14.8614 39.6617 14.8768C48.0002 14.8922 55.1924 16.6384 61.2232 20.123L49.7616 26.7383Z"
        fill="#FEF7F7"
        stroke="#F35656"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export const EditDetailsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
    >
      <path
        d="M14.862 3.48725L16.549 1.79925C16.9007 1.44757 17.3777 1.25 17.875 1.25C18.3723 1.25 18.8493 1.44757 19.201 1.79925C19.5527 2.15092 19.7502 2.6279 19.7502 3.12525C19.7502 3.62259 19.5527 4.09957 19.201 4.45125L8.582 15.0702C8.05332 15.5986 7.40137 15.987 6.685 16.2002L4 17.0002L4.8 14.3152C5.01328 13.5989 5.40163 12.9469 5.93 12.4182L14.862 3.48725ZM14.862 3.48725L17.5 6.12525M16 13.0002V17.7502C16 18.347 15.7629 18.9193 15.341 19.3412C14.919 19.7632 14.3467 20.0002 13.75 20.0002H3.25C2.65326 20.0002 2.08097 19.7632 1.65901 19.3412C1.23705 18.9193 1 18.347 1 17.7502V7.25025C1 6.65351 1.23705 6.08121 1.65901 5.65926C2.08097 5.2373 2.65326 5.00025 3.25 5.00025H8"
        stroke="#B4C8CB"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export const CountryIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        opacity="0.4"
        d="M6.3748 17.4255C6.3498 17.4255 6.31647 17.4422 6.29147 17.4422C4.6748 16.6422 3.35814 15.3172 2.5498 13.7005C2.5498 13.6755 2.56647 13.6422 2.56647 13.6172C3.58314 13.9172 4.63314 14.1422 5.6748 14.3172C5.85814 15.3672 6.0748 16.4089 6.3748 17.4255Z"
        fill="#022329"
      />
      <path
        opacity="0.4"
        d="M17.4502 13.7089C16.6252 15.3672 15.2502 16.7089 13.5752 17.5172C13.8919 16.4589 14.1585 15.3922 14.3335 14.3172C15.3835 14.1422 16.4169 13.9172 17.4335 13.6172C17.4252 13.6505 17.4502 13.6839 17.4502 13.7089Z"
        fill="#022329"
      />
      <path
        opacity="0.4"
        d="M17.5169 6.42409C16.4669 6.10742 15.4085 5.84909 14.3335 5.66576C14.1585 4.59076 13.9002 3.52409 13.5752 2.48242C15.3002 3.30742 16.6919 4.69909 17.5169 6.42409Z"
        fill="#022329"
      />
      <path
        opacity="0.4"
        d="M6.37507 2.57578C6.07507 3.59245 5.8584 4.62578 5.6834 5.67578C4.6084 5.84245 3.54173 6.10911 2.4834 6.42578C3.29173 4.75078 4.6334 3.37578 6.29173 2.55078C6.31673 2.55078 6.35006 2.57578 6.37507 2.57578Z"
        fill="#022329"
      />
      <path
        d="M12.9085 5.49102C10.9751 5.27435 9.02513 5.27435 7.0918 5.49102C7.30013 4.34935 7.5668 3.20768 7.9418 2.10768C7.95846 2.04102 7.95013 1.99102 7.95846 1.92435C8.6168 1.76602 9.2918 1.66602 10.0001 1.66602C10.7001 1.66602 11.3835 1.76602 12.0335 1.92435C12.0418 1.99102 12.0418 2.04102 12.0585 2.10768C12.4335 3.21602 12.7001 4.34935 12.9085 5.49102Z"
        fill="#022329"
      />
      <path
        d="M5.49199 12.9085C4.34199 12.7001 3.20866 12.4335 2.10866 12.0585C2.04199 12.0418 1.99199 12.0501 1.92533 12.0418C1.76699 11.3835 1.66699 10.7085 1.66699 10.0001C1.66699 9.30013 1.76699 8.6168 1.92533 7.9668C1.99199 7.95846 2.04199 7.95846 2.10866 7.9418C3.21699 7.57513 4.34199 7.30013 5.49199 7.0918C5.28366 9.02513 5.28366 10.9751 5.49199 12.9085Z"
        fill="#022329"
      />
      <path
        d="M18.3338 10.0001C18.3338 10.7085 18.2338 11.3835 18.0755 12.0418C18.0088 12.0501 17.9588 12.0418 17.8921 12.0585C16.7838 12.4251 15.6505 12.7001 14.5088 12.9085C14.7255 10.9751 14.7255 9.02513 14.5088 7.0918C15.6505 7.30013 16.7921 7.5668 17.8921 7.9418C17.9588 7.95846 18.0088 7.9668 18.0755 7.9668C18.2338 8.62513 18.3338 9.30013 18.3338 10.0001Z"
        fill="#022329"
      />
      <path
        d="M12.9085 14.5078C12.7001 15.6578 12.4335 16.7911 12.0585 17.8911C12.0418 17.9578 12.0418 18.0078 12.0335 18.0745C11.3835 18.2328 10.7001 18.3328 10.0001 18.3328C9.2918 18.3328 8.6168 18.2328 7.95846 18.0745C7.95013 18.0078 7.95846 17.9578 7.9418 17.8911C7.57513 16.7828 7.30013 15.6578 7.0918 14.5078C8.05846 14.6161 9.02513 14.6911 10.0001 14.6911C10.9751 14.6911 11.9501 14.6161 12.9085 14.5078Z"
        fill="#022329"
      />
      <path
        d="M13.1364 13.1355C11.0522 13.3984 8.94846 13.3984 6.86422 13.1355C6.60125 11.0512 6.60125 8.94749 6.86422 6.86324C8.94846 6.60027 11.0522 6.60027 13.1364 6.86324C13.3994 8.94749 13.3994 11.0512 13.1364 13.1355Z"
        fill="#022329"
      />
    </svg>
  )
}

export const CountryActiveIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        opacity="0.4"
        d="M6.3748 17.4255C6.3498 17.4255 6.31647 17.4422 6.29147 17.4422C4.6748 16.6422 3.35814 15.3172 2.5498 13.7005C2.5498 13.6755 2.56647 13.6422 2.56647 13.6172C3.58314 13.9172 4.63314 14.1422 5.6748 14.3172C5.85814 15.3672 6.0748 16.4089 6.3748 17.4255Z"
        fill="#B4C8CB"
      />
      <path
        opacity="0.4"
        d="M17.4502 13.7089C16.6252 15.3672 15.2502 16.7089 13.5752 17.5172C13.8919 16.4589 14.1585 15.3922 14.3335 14.3172C15.3835 14.1422 16.4169 13.9172 17.4335 13.6172C17.4252 13.6505 17.4502 13.6839 17.4502 13.7089Z"
        fill="#B4C8CB"
      />
      <path
        opacity="0.4"
        d="M17.5169 6.42409C16.4669 6.10742 15.4085 5.84909 14.3335 5.66576C14.1585 4.59076 13.9002 3.52409 13.5752 2.48242C15.3002 3.30742 16.6919 4.69909 17.5169 6.42409Z"
        fill="#B4C8CB"
      />
      <path
        opacity="0.4"
        d="M6.37507 2.57578C6.07507 3.59245 5.8584 4.62578 5.6834 5.67578C4.6084 5.84245 3.54173 6.10911 2.4834 6.42578C3.29173 4.75078 4.6334 3.37578 6.29173 2.55078C6.31673 2.55078 6.35006 2.57578 6.37507 2.57578Z"
        fill="#B4C8CB"
      />
      <path
        d="M12.9085 5.49102C10.9751 5.27435 9.02513 5.27435 7.0918 5.49102C7.30013 4.34935 7.5668 3.20768 7.9418 2.10768C7.95846 2.04102 7.95013 1.99102 7.95846 1.92435C8.6168 1.76602 9.2918 1.66602 10.0001 1.66602C10.7001 1.66602 11.3835 1.76602 12.0335 1.92435C12.0418 1.99102 12.0418 2.04102 12.0585 2.10768C12.4335 3.21602 12.7001 4.34935 12.9085 5.49102Z"
        fill="#B4C8CB"
      />
      <path
        d="M5.49199 12.9085C4.34199 12.7001 3.20866 12.4335 2.10866 12.0585C2.04199 12.0418 1.99199 12.0501 1.92533 12.0418C1.76699 11.3835 1.66699 10.7085 1.66699 10.0001C1.66699 9.30013 1.76699 8.6168 1.92533 7.9668C1.99199 7.95846 2.04199 7.95846 2.10866 7.9418C3.21699 7.57513 4.34199 7.30013 5.49199 7.0918C5.28366 9.02513 5.28366 10.9751 5.49199 12.9085Z"
        fill="#B4C8CB"
      />
      <path
        d="M18.3338 10.0001C18.3338 10.7085 18.2338 11.3835 18.0755 12.0418C18.0088 12.0501 17.9588 12.0418 17.8921 12.0585C16.7838 12.4251 15.6505 12.7001 14.5088 12.9085C14.7255 10.9751 14.7255 9.02513 14.5088 7.0918C15.6505 7.30013 16.7921 7.5668 17.8921 7.9418C17.9588 7.95846 18.0088 7.9668 18.0755 7.9668C18.2338 8.62513 18.3338 9.30013 18.3338 10.0001Z"
        fill="#B4C8CB"
      />
      <path
        d="M12.9085 14.5078C12.7001 15.6578 12.4335 16.7911 12.0585 17.8911C12.0418 17.9578 12.0418 18.0078 12.0335 18.0745C11.3835 18.2328 10.7001 18.3328 10.0001 18.3328C9.2918 18.3328 8.6168 18.2328 7.95846 18.0745C7.95013 18.0078 7.95846 17.9578 7.9418 17.8911C7.57513 16.7828 7.30013 15.6578 7.0918 14.5078C8.05846 14.6161 9.02513 14.6911 10.0001 14.6911C10.9751 14.6911 11.9501 14.6161 12.9085 14.5078Z"
        fill="#B4C8CB"
      />
      <path
        d="M13.1364 13.1355C11.0522 13.3984 8.94846 13.3984 6.86422 13.1355C6.60125 11.0512 6.60125 8.94749 6.86422 6.86324C8.94846 6.60027 11.0522 6.60027 13.1364 6.86324C13.3994 8.94749 13.3994 11.0512 13.1364 13.1355Z"
        fill="#B4C8CB"
      />
    </svg>
  )
}

export const MomoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
        fill="#F2F6F6"
      />
      <path
        d="M11.3333 2.33325H4.66659C2.66659 2.33325 1.33325 3.33325 1.33325 5.66659V5.99992V9.99992V10.3333C1.33325 12.6666 2.66659 13.6666 4.66659 13.6666H11.3333C13.3333 13.6666 14.6666 12.6666 14.6666 10.3333V9.99992V5.99992V5.66659C14.6666 3.33325 13.3333 2.33325 11.3333 2.33325ZM4.66659 12.6666C4.66659 10.7866 4.05992 10.0933 2.33325 10.0133V9.99992V5.99992V5.98659C4.05992 5.90658 4.66659 5.21325 4.66659 3.33325H11.3333C11.3333 5.21325 11.9399 5.90658 13.6666 5.98659V5.99992V9.99992V10.0133C11.9399 10.0933 11.3333 10.7866 11.3333 12.6666H4.66659Z"
        fill="#F2F6F6"
      />
    </svg>
  )
}

export const CheckoutRevLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="88"
      height="16"
      viewBox="0 0 88 16"
      fill="none"
    >
      <path
        d="M9.11011 15.9998V0H16.021C17.2094 0 18.2491 0.233671 19.1404 0.701014C20.0316 1.16836 20.7248 1.82523 21.2199 2.67164C21.715 3.51805 21.9626 4.50726 21.9626 5.63927C21.9626 6.78166 21.7072 7.77087 21.1964 8.60689C20.6909 9.44291 19.9795 10.0868 19.0622 10.5386C18.1501 10.9903 17.0843 11.2162 15.8647 11.2162H11.7369V7.85135H14.9891C15.4999 7.85135 15.935 7.76308 16.2947 7.58653C16.6595 7.40478 16.9383 7.14774 17.1312 6.81541C17.3292 6.48308 17.4283 6.09103 17.4283 5.63927C17.4283 5.18231 17.3292 4.79286 17.1312 4.47091C16.9383 4.14377 16.6595 3.89452 16.2947 3.72316C15.935 3.54661 15.4999 3.45833 14.9891 3.45833H13.4568V15.9998H9.11011Z"
        fill="#044752"
      />
      <path
        d="M5.38896 10.1345C6.39297 9.74141 7.1936 9.12525 7.79011 8.28304C8.38586 7.44082 8.68373 6.4663 8.68373 5.35645C8.68373 3.82323 8.15602 2.54781 7.0991 1.52944C6.04217 0.509562 4.71761 0 3.12466 0H0V3.38549H3.04604C3.60398 3.38549 4.06818 3.57828 4.43864 3.9631C4.80758 4.34791 4.99356 4.82724 4.99356 5.40182C4.99356 5.9764 4.80682 6.44211 4.43335 6.82239C4.05987 7.20419 3.59718 7.39395 3.04679 7.39395H0V10.5307H1.51735L4.81212 15.9998H9.12676L5.38972 10.1345H5.38896Z"
        fill="#CB9A2B"
      />
      <path
        d="M84.8087 13.8264C84.6736 14.1774 84.5431 14.488 84.4171 14.758C84.2911 15.028 84.1291 15.2531 83.931 15.4331C83.742 15.6221 83.499 15.7616 83.2019 15.8517C82.9049 15.9507 82.5133 16.0002 82.0273 16.0002C81.5052 16.0002 81.0011 15.9192 80.515 15.7571L80.7851 14.0964C81.0911 14.2314 81.4062 14.2989 81.7302 14.2989C81.9553 14.2989 82.1398 14.2719 82.2838 14.2179C82.4278 14.1729 82.5448 14.1009 82.6349 14.0019C82.7339 13.9119 82.8149 13.7994 82.8779 13.6643C82.9409 13.5293 83.0084 13.3718 83.0804 13.1918L83.2289 12.8137L80.353 6.19775H82.5403L84.2281 10.5319H84.2551L85.6998 6.19775H87.7791L84.8087 13.8264Z"
        fill="#044752"
      />
      <path
        d="M77.8943 11.936H77.8673C77.6423 12.287 77.3407 12.5391 76.9627 12.6921C76.5936 12.8451 76.202 12.9216 75.788 12.9216C75.4819 12.9216 75.1849 12.8766 74.8969 12.7866C74.6178 12.7056 74.3703 12.5796 74.1542 12.4086C73.9382 12.2375 73.7672 12.026 73.6412 11.774C73.5152 11.5219 73.4521 11.2294 73.4521 10.8963C73.4521 10.5183 73.5197 10.1987 73.6547 9.93771C73.7987 9.67667 73.9877 9.46064 74.2218 9.28962C74.4648 9.11859 74.7393 8.98807 75.0454 8.89806C75.3514 8.79904 75.6665 8.72703 75.9905 8.68203C76.3236 8.63702 76.6521 8.61002 76.9762 8.60102C77.3092 8.59201 77.6152 8.58751 77.8943 8.58751C77.8943 8.22746 77.7638 7.94392 77.5027 7.73689C77.2507 7.52086 76.9492 7.41284 76.5981 7.41284C76.2651 7.41284 75.959 7.48485 75.68 7.62888C75.4099 7.76389 75.1669 7.95292 74.9509 8.19596L73.8707 7.0888C74.2488 6.73775 74.6898 6.47671 75.1939 6.30568C75.698 6.12566 76.22 6.03564 76.7601 6.03564C77.3542 6.03564 77.8403 6.11216 78.2183 6.26518C78.6054 6.4092 78.9114 6.62523 79.1365 6.91327C79.3705 7.20131 79.5325 7.55687 79.6225 7.97993C79.7126 8.39399 79.7576 8.87556 79.7576 9.42464V12.7596H77.8943V11.936ZM77.3947 9.8837C77.2417 9.8837 77.0482 9.8927 76.8141 9.91071C76.5891 9.91971 76.3686 9.95571 76.1525 10.0187C75.9455 10.0817 75.7655 10.1762 75.6125 10.3023C75.4684 10.4283 75.3964 10.6038 75.3964 10.8288C75.3964 11.0719 75.4999 11.2519 75.707 11.3689C75.914 11.4859 76.13 11.5444 76.3551 11.5444C76.5531 11.5444 76.7421 11.5174 76.9221 11.4634C77.1112 11.4094 77.2777 11.3329 77.4217 11.2339C77.5657 11.1349 77.6783 11.0089 77.7593 10.8558C77.8493 10.7028 77.8943 10.5228 77.8943 10.3158V9.8837H77.3947Z"
        fill="#044752"
      />
      <path
        d="M65.5281 3.19971H69.0791C69.5742 3.19971 70.0422 3.24471 70.4833 3.33473C70.9244 3.42474 71.3069 3.58226 71.631 3.80729C71.964 4.02333 72.225 4.32037 72.4141 4.69842C72.6121 5.06748 72.7111 5.53554 72.7111 6.10263C72.7111 6.66071 72.6211 7.12878 72.4411 7.50683C72.2611 7.88488 72.0135 8.18643 71.6985 8.41146C71.3834 8.63649 71.0099 8.79852 70.5778 8.89753C70.1457 8.98754 69.6777 9.03255 69.1736 9.03255H67.6344V12.7591H65.5281V3.19971ZM67.6344 7.25029H69.0386C69.2276 7.25029 69.4076 7.23229 69.5787 7.19629C69.7587 7.16028 69.9162 7.10177 70.0512 7.02076C70.1953 6.93075 70.3078 6.81373 70.3888 6.66971C70.4788 6.51669 70.5238 6.32766 70.5238 6.10263C70.5238 5.85959 70.4653 5.66606 70.3483 5.52204C70.2403 5.36902 70.0962 5.252 69.9162 5.17099C69.7452 5.08998 69.5517 5.04047 69.3356 5.02247C69.1196 4.99547 68.9126 4.98196 68.7145 4.98196H67.6344V7.25029Z"
        fill="#044752"
      />
      <path
        d="M62.1377 11.936H62.1107C61.8857 12.287 61.5841 12.5391 61.2061 12.6921C60.837 12.8451 60.4455 12.9216 60.0314 12.9216C59.7254 12.9216 59.4283 12.8766 59.1403 12.7866C58.8612 12.7056 58.6137 12.5796 58.3977 12.4086C58.1816 12.2375 58.0106 12.026 57.8846 11.774C57.7586 11.5219 57.6956 11.2294 57.6956 10.8963C57.6956 10.5183 57.7631 10.1987 57.8981 9.93771C58.0421 9.67667 58.2311 9.46064 58.4652 9.28962C58.7082 9.11859 58.9827 8.98807 59.2888 8.89806C59.5948 8.79904 59.9099 8.72703 60.2339 8.68203C60.567 8.63702 60.8955 8.61002 61.2196 8.60102C61.5526 8.59201 61.8587 8.58751 62.1377 8.58751C62.1377 8.22746 62.0072 7.94392 61.7461 7.73689C61.4941 7.52086 61.1926 7.41284 60.8415 7.41284C60.5085 7.41284 60.2024 7.48485 59.9234 7.62888C59.6533 7.76389 59.4103 7.95292 59.1943 8.19596L58.1141 7.0888C58.4922 6.73775 58.9332 6.47671 59.4373 6.30568C59.9414 6.12566 60.4635 6.03564 61.0035 6.03564C61.5976 6.03564 62.0837 6.11216 62.4617 6.26518C62.8488 6.4092 63.1548 6.62523 63.3799 6.91327C63.6139 7.20131 63.7759 7.55687 63.8659 7.97993C63.956 8.39399 64.001 8.87556 64.001 9.42464V12.7596H62.1377V11.936ZM61.6381 9.8837C61.4851 9.8837 61.2916 9.8927 61.0575 9.91071C60.8325 9.91971 60.612 9.95571 60.3959 10.0187C60.1889 10.0817 60.0089 10.1762 59.8559 10.3023C59.7118 10.4283 59.6398 10.6038 59.6398 10.8288C59.6398 11.0719 59.7434 11.2519 59.9504 11.3689C60.1574 11.4859 60.3734 11.5444 60.5985 11.5444C60.7965 11.5444 60.9855 11.5174 61.1656 11.4634C61.3546 11.4094 61.5211 11.3329 61.6651 11.2339C61.8092 11.1349 61.9217 11.0089 62.0027 10.8558C62.0927 10.7028 62.1377 10.5228 62.1377 10.3158V9.8837H61.6381Z"
        fill="#044752"
      />
      <path
        d="M49.8284 6.19775H52.0157L53.6764 10.6534H53.7034L55.2427 6.19775H57.2814L54.6891 12.7597H52.5423L49.8284 6.19775Z"
        fill="#044752"
      />
      <path
        d="M42.3259 6.19775H44.5132L46.174 10.6534H46.201L47.7402 6.19775H49.779L47.1866 12.7597H45.0398L42.3259 6.19775Z"
        fill="#044752"
      />
      <path
        d="M41.4723 11.6255C41.1482 12.0395 40.7387 12.3591 40.2436 12.5841C39.7485 12.8091 39.2354 12.9216 38.7044 12.9216C38.2003 12.9216 37.7232 12.8406 37.2732 12.6786C36.8321 12.5166 36.445 12.287 36.112 11.99C35.7879 11.684 35.5314 11.3194 35.3424 10.8963C35.1534 10.4733 35.0588 10.0007 35.0588 9.47864C35.0588 8.95657 35.1534 8.484 35.3424 8.06094C35.5314 7.63788 35.7879 7.27782 36.112 6.98078C36.445 6.67474 36.8321 6.4407 37.2732 6.27868C37.7232 6.11666 38.2003 6.03564 38.7044 6.03564C39.1724 6.03564 39.5955 6.11666 39.9735 6.27868C40.3606 6.4407 40.6847 6.67474 40.9457 6.98078C41.2157 7.27782 41.4228 7.63788 41.5668 8.06094C41.7108 8.484 41.7828 8.95657 41.7828 9.47864V10.1132H37.0841C37.1651 10.5003 37.3407 10.8108 37.6107 11.0449C37.8807 11.2699 38.2138 11.3824 38.6099 11.3824C38.9429 11.3824 39.2219 11.3104 39.447 11.1664C39.681 11.0134 39.8835 10.8198 40.0546 10.5858L41.4723 11.6255ZM39.7575 8.73604C39.7665 8.39399 39.654 8.10144 39.42 7.85841C39.1859 7.61537 38.8844 7.49386 38.5153 7.49386C38.2903 7.49386 38.0923 7.52986 37.9213 7.60187C37.7502 7.67388 37.6017 7.7684 37.4757 7.88541C37.3587 7.99343 37.2642 8.12395 37.1921 8.27697C37.1291 8.42099 37.0931 8.57401 37.0841 8.73604H39.7575Z"
        fill="#044752"
      />
      <path
        d="M26.7627 3.19971H30.4622C30.9483 3.19971 31.4074 3.24921 31.8394 3.34823C32.2805 3.43824 32.663 3.59576 32.9871 3.8208C33.3201 4.03683 33.5812 4.33387 33.7702 4.71193C33.9682 5.08098 34.0673 5.54455 34.0673 6.10263C34.0673 6.77772 33.8917 7.35381 33.5407 7.83088C33.1896 8.29894 32.6766 8.59599 32.0015 8.72201L34.4318 12.7591H31.9069L29.9087 8.93804H28.869V12.7591H26.7627V3.19971ZM28.869 7.15578H30.1112C30.3002 7.15578 30.4982 7.15128 30.7053 7.14228C30.9213 7.12427 31.1148 7.08377 31.2859 7.02076C31.4569 6.94875 31.5964 6.84073 31.7044 6.69671C31.8214 6.55269 31.8799 6.35016 31.8799 6.08912C31.8799 5.84609 31.8304 5.65256 31.7314 5.50854C31.6324 5.36452 31.5064 5.2565 31.3534 5.18449C31.2003 5.10348 31.0248 5.04947 30.8268 5.02247C30.6288 4.99547 30.4352 4.98196 30.2462 4.98196H28.869V7.15578Z"
        fill="#044752"
      />
    </svg>
  )
}

export const CheckerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.603 3.799C9.02496 3.31223 9.54673 2.92196 10.1329 2.65468C10.719 2.38741 11.3558 2.24939 12 2.25C13.357 2.25 14.573 2.85 15.397 3.799C16.0397 3.75311 16.6847 3.84609 17.2883 4.07161C17.8919 4.29713 18.4399 4.64992 18.895 5.106C19.3509 5.56106 19.7036 6.10888 19.9291 6.71226C20.1546 7.31564 20.2477 7.96047 20.202 8.603C20.6886 9.02505 21.0787 9.54686 21.3458 10.133C21.6129 10.7191 21.7507 11.3559 21.75 12C21.7506 12.6442 21.6126 13.281 21.3453 13.8671C21.078 14.4533 20.6878 14.975 20.201 15.397C20.2467 16.0395 20.1536 16.6844 19.9281 17.2877C19.7026 17.8911 19.3499 18.4389 18.894 18.894C18.4389 19.3499 17.8911 19.7026 17.2877 19.9281C16.6844 20.1536 16.0395 20.2467 15.397 20.201C14.975 20.6878 14.4533 21.078 13.8671 21.3453C13.281 21.6126 12.6442 21.7506 12 21.75C11.3558 21.7506 10.719 21.6126 10.1329 21.3453C9.54673 21.078 9.02496 20.6878 8.603 20.201C7.96038 20.247 7.31538 20.1542 6.71181 19.9289C6.10824 19.7035 5.56023 19.3509 5.105 18.895C4.64897 18.4398 4.29622 17.8919 4.0707 17.2883C3.84518 16.6847 3.75218 16.0397 3.798 15.397C3.31141 14.9749 2.92133 14.4531 2.65423 13.867C2.38713 13.2809 2.24927 12.6441 2.25 12C2.25 10.643 2.85 9.427 3.799 8.603C3.75326 7.96047 3.8463 7.31562 4.07182 6.71222C4.29734 6.10883 4.65005 5.56103 5.106 5.106C5.56103 4.65005 6.10883 4.29734 6.71222 4.07182C7.31562 3.8463 7.96047 3.75326 8.603 3.799ZM15.61 10.186C15.67 10.1061 15.7134 10.0149 15.7377 9.91795C15.762 9.82098 15.7666 9.72014 15.7514 9.62136C15.7361 9.52257 15.7013 9.42783 15.6489 9.3427C15.5965 9.25757 15.5276 9.18378 15.4463 9.12565C15.3649 9.06753 15.2728 9.02624 15.1753 9.00423C15.0778 8.98222 14.9769 8.97992 14.8785 8.99746C14.7801 9.01501 14.6862 9.05205 14.6023 9.10641C14.5184 9.16077 14.4462 9.23135 14.39 9.314L11.154 13.844L9.53 12.22C9.38783 12.0875 9.19978 12.0154 9.00548 12.0188C8.81118 12.0223 8.62579 12.101 8.48838 12.2384C8.35097 12.3758 8.27226 12.5612 8.26883 12.7555C8.2654 12.9498 8.33752 13.1378 8.47 13.28L10.72 15.53C10.797 15.6069 10.8898 15.6662 10.992 15.7036C11.0942 15.7411 11.2033 15.7559 11.3118 15.7469C11.4202 15.738 11.5255 15.7055 11.6201 15.6519C11.7148 15.5982 11.7967 15.5245 11.86 15.436L15.61 10.186Z"
        fill="#044752"
      />
    </svg>
  )
}

export const FailedStatusIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
    >
      <path
        d="M72.9465 57.0166C71.7233 53.0497 70.1944 49.2067 68.368 45.4795C67.5332 43.7522 66.6241 42.058 65.6572 40.3803C65.0291 39.2976 64.3762 38.2315 63.6985 37.1819C61.087 33.1076 58.1283 29.3059 54.8308 25.7687C50.682 21.3224 46.2522 17.7357 41.5332 15.0084C36.8142 12.2894 32.3845 10.7522 28.2357 10.4133C28.087 10.3968 27.9382 10.3885 27.7894 10.3803C24.3184 10.1571 21.2275 10.6778 18.5332 11.9423C18.1531 12.1241 17.7729 12.3224 17.4093 12.529C14.3432 14.2728 11.9134 17.0166 10.1201 20.7439C8.33493 24.4712 7.43408 29.0414 7.43408 34.4464C7.43408 39.8514 8.33493 45.4629 10.1201 51.2563C11.9134 57.0497 14.3432 62.5952 17.4093 67.8927C20.4754 73.1819 24.087 78.058 28.2357 82.5042C32.3845 86.9505 36.8142 90.5373 41.5332 93.2646C46.2522 95.9836 50.682 97.5208 54.8308 97.8596C58.5415 98.1654 61.8308 97.6282 64.6737 96.2646C65.0126 96.0993 65.3349 95.9257 65.6572 95.7439C68.1118 94.339 70.1613 92.3059 71.806 89.6282C72.2109 88.9671 72.5911 88.2646 72.9465 87.529C74.7316 83.8018 75.6324 79.2315 75.6324 73.8183C75.6324 68.4051 74.7316 62.81 72.9465 57.0166ZM46.3514 56.9588L46.4589 57.1489L56.1944 73.9505C56.8225 75.0249 57.1283 76.1158 57.1283 77.2315C57.1283 78.3472 56.8225 79.0662 56.1944 79.4216C55.5663 79.7852 54.7729 79.6778 53.806 79.1241C52.839 78.5621 52.0456 77.7439 51.4175 76.6695L41.5332 59.6117L35.8969 62.8266L31.6407 65.2481C31.0208 65.6117 30.2275 65.5042 29.2605 64.9505C28.2936 64.3885 27.5002 63.5704 26.8721 62.496C26.244 61.4133 25.9299 60.3224 25.9299 59.215C25.9299 58.1076 26.244 57.372 26.8721 57.0166L31.2275 54.529L36.7564 51.3803L26.8721 34.3224C26.244 33.2481 25.9299 32.1571 25.9299 31.0414C25.9299 29.9257 26.244 29.2067 26.8721 28.8431C27.5002 28.4877 28.2936 28.5952 29.2605 29.1489C30.2275 29.7109 31.0208 30.529 31.6407 31.6034L41.5332 48.6613L51.4175 43.0249C51.8556 42.7687 52.368 42.7439 52.9713 42.9423C53.0622 42.9671 53.1531 43.0001 53.244 43.0497C53.4258 43.1158 53.6076 43.2067 53.806 43.3224C54.7729 43.8844 55.5663 44.7026 56.1944 45.777C56.8225 46.8514 57.1283 47.9505 57.1283 49.058C57.1283 50.1654 56.8225 50.9009 56.1944 51.2563L46.3101 56.8927L46.3514 56.9588Z"
        fill="#FEF7F7"
        stroke="#F35656"
        stroke-width="0.793388"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M53.2851 43.116L36.7561 51.3805L26.8718 34.3226C26.2437 33.2483 25.9297 32.1573 25.9297 31.0416C25.9297 29.9259 26.2437 29.2069 26.8718 28.8433C27.4999 28.4879 28.2933 28.5954 29.2603 29.1491C30.2272 29.7111 31.0206 30.5292 31.6404 31.6036L41.533 48.6615L52.971 42.9425C53.0619 42.9673 53.1528 43.0003 53.2437 43.0499L53.2851 43.116Z"
        fill="#FEF7F7"
        stroke="#F35656"
        stroke-width="0.793388"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M57.1282 77.2311C57.1282 78.3385 56.8225 79.0658 56.1944 79.4212C55.5663 79.7848 54.773 79.6774 53.806 79.1236C52.8391 78.5617 52.0456 77.7435 51.4175 76.6691L41.5332 59.6112L46.4588 57.1484L56.1944 73.9501C56.8225 75.0245 57.1282 76.1154 57.1282 77.2311Z"
        fill="#FEF7F7"
        stroke="#F35656"
        stroke-width="0.793388"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M46.3512 56.9582L46.4586 57.1483L41.533 59.6111L35.8966 62.826L31.6404 65.2475C31.0206 65.6111 30.2272 65.5037 29.2603 64.9499C28.2933 64.388 27.4999 63.5698 26.8718 62.4954C26.2437 61.4128 25.9297 60.3218 25.9297 59.2144C25.9297 58.107 26.2437 57.3714 26.8718 57.0161L31.2272 54.5285L36.7561 51.3797L53.2851 43.1152L43.4008 48.7516C42.7727 49.107 42.4586 49.8425 42.4586 50.9499C42.4586 52.0574 42.7727 53.1483 43.4008 54.2309C44.0289 55.3053 44.8222 56.1235 45.7892 56.6855C45.9875 56.8012 46.1694 56.8921 46.3512 56.9582Z"
        fill="#FEF7F7"
        stroke="#F35656"
        stroke-width="0.793388"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M92.1613 65.554C92.1613 70.9672 91.2605 75.5375 89.4753 79.2648C87.682 82.992 85.2522 85.7276 82.1861 87.4796C81.996 87.5871 81.7977 87.6945 81.5993 87.802L81.4506 87.8763L64.6737 96.2648C65.0125 96.0995 65.3349 95.9259 65.6572 95.7441C68.1117 94.3391 70.1613 92.3061 71.8059 89.6284C72.2109 88.9672 72.5911 88.2648 72.9464 87.5292C74.7315 83.802 75.6324 79.2317 75.6324 73.8185C75.6324 68.4053 74.7315 62.8102 72.9464 57.0168C71.7233 53.0499 70.1944 49.2069 68.3679 45.4796C67.5332 43.7524 66.6241 42.0582 65.6572 40.3805C65.0291 39.2978 64.3762 38.2317 63.6985 37.1821C61.0869 33.1077 58.1282 29.3061 54.8307 25.7689C50.682 21.3226 46.2522 17.7358 41.5332 15.0086C36.8142 12.2896 32.3844 10.7524 28.2357 10.4135C28.0869 10.397 27.9382 10.3887 27.7894 10.3805C24.3183 10.1573 21.2274 10.678 18.5332 11.9425L33.9382 4.26477C37.0043 2.5127 40.6159 1.81022 44.7646 2.14906C48.9134 2.48791 53.3431 4.0251 58.0621 6.74411C62.7811 9.47138 67.2109 13.0582 71.3597 17.5044C75.5084 21.9507 79.12 26.8267 82.1861 32.116C85.2522 37.4135 87.682 42.9507 89.4753 48.7524C91.2605 54.5458 92.1613 60.1491 92.1613 65.554Z"
        fill="#FEF7F7"
        stroke="#F35656"
        stroke-width="0.793388"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M52.9713 42.9421L41.5332 48.6611L51.4175 43.0247C51.8555 42.7685 52.368 42.7437 52.9713 42.9421Z"
        fill="#FEF7F7"
        stroke="#F35656"
        stroke-width="0.793388"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
